var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _g, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _rect2, _path193, _g2, _g3, _path194, _path195, _path196, _path197, _path198, _path199, _g4, _path200, _path201, _path202, _path203, _path204, _path205, _g5, _path206, _path207, _path208, _path209, _path210, _path211, _g6, _path212, _path213, _path214, _path215, _path216, _path217, _g7, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _g8, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _rect3, _path238, _path239, _rect4, _path240, _path241, _rect5, _path242, _path243, _rect6, _path244, _path245, _rect7, _path246, _path247, _rect8, _path248, _path249, _rect9, _path250, _path251, _rect10, _path252, _path253, _rect11, _path254, _path255, _path256, _rect12, _path257, _path258, _path259, _rect13, _path260, _path261, _path262, _rect14, _path263, _path264, _path265, _path266, _g9, _g10, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _g11, _path572, _path573, _path574, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _g26, _circle, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _g27, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _g28, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _g29, _g30, _g31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_1050)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1048,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 689-.5 1048H1440l-127-359H116Z",
    fill: "url(#paint0_linear_1989_1050)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 689-.5 1048H1440l-127-359H116Z",
    fill: "url(#paint1_linear_1989_1050)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m344 1047.5 12-75.5h34.5l-9.5 75.5h-37Z",
    fill: "url(#paint2_linear_1989_1050)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m461 937 13-129h31.5l-11 129H461Z",
    fill: "url(#paint3_linear_1989_1050)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m658 911 2-129h31.5v129H658Z",
    fill: "url(#paint4_linear_1989_1050)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m857 937-8-129h31.5l10 129H857Z",
    fill: "url(#paint5_linear_1989_1050)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M980.5 872.5 962 752h31.5l19 120.5h-32Z",
    fill: "url(#paint6_linear_1989_1050)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1146 1028.5 1119 908h31.5l27.5 120.5h-32Z",
    fill: "url(#paint7_linear_1989_1050)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1000 1009-19-137h31.5l21 137H1000Z",
    fill: "url(#paint8_linear_1989_1050)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m403 864 19-129h31.5l-17 129H403Z",
    fill: "url(#paint9_linear_1989_1050)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.5 1015 271 889h31.5l-23 126h-35Z",
    fill: "url(#paint10_linear_1989_1050)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "m66.5 1047.5 31-110.5H129l-31.5 112.5-31-2Z",
    fill: "url(#paint11_linear_1989_1050)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M519.5 1047.5 524 989h31.5l-3 58.5h-33Z",
    fill: "url(#paint12_linear_1989_1050)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M316.5 1009 339 871.5h31.5l-20 137.5h-34Z",
    fill: "url(#paint13_linear_1989_1050)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M311 845.5 336.5 708H365l-20 137.5h-34Z",
    fill: "url(#paint14_linear_1989_1050)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M161.5 937 193 808h30l-29.5 129h-32Z",
    fill: "url(#paint15_linear_1989_1050)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m394 720 6-32h29l-5.5 32H394Z",
    fill: "url(#paint16_linear_1989_1050)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m229 782 22-93h29l-20 93h-31Z",
    fill: "url(#paint17_linear_1989_1050)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m140.5 781 25.5-92h29l-25.5 93-29-1Z",
    fill: "url(#paint18_linear_1989_1050)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "m210 876 20.5-92h29L240 877l-30-1Z",
    fill: "url(#paint19_linear_1989_1050)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m31 1050 103.5-358.983",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m99 1050 95.5-358.983",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m68 1050 98.5-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m136 1050 86.5-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m169 1050 82.5-359.992",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m205 1050 76-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m237 1050 76-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m274.5 1050 66-358.983",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m311 1050 58.5-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M345.5 1050 400 690.512",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m381.5 1050 47-359.488",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m415 1050 44.5-358.983",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m450.5 1049.5 36-358.988",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m520 1049.5 25-358.988",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M554 1049.5 574 689",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m591 1049.5 12-358.483",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m626 1049.5 7.5-358.988",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M661 1049.5V690.512",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M692 1049.5V690.512",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m487 1049.5 28-358.988",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 1029.83h37",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M141 890.676h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M173 767.654h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162 938.07h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M200 908.827h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M217 989.497h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M240 1029.83h38",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M269 890.676h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M246 854.374h31",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M231 783.788h31",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M358 753.536h31",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M394 720.26h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M376 839.249h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M340 872.525h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M291 954.204h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M318 1010.67h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M357 973.363h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M434 890.676h31",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M475 808.997h31",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M450 767.654h29",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M461 937.062h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M523 990.506h33",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M532 854.374h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M598 824.123h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M631 752.528h29",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M625 1012.69h35",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M593 953.196h34",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M507 783.788h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M498 907.818h32",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M336 708.159h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M194 808.997h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M98 937.062h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M133 806.98h30",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52 973.363h36",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30 927h36",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91 839h33",
    stroke: "#F3EFEA",
    strokeOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m30 1049 103.5-358.983",
    stroke: "#D09E75"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m98 1049 95.5-358.983",
    stroke: "#D09E75"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m67 1049 98.5-359.488",
    stroke: "#D09E75"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m135 1049 86.5-359.488",
    stroke: "#D09E75"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m168 1049 82.5-359.992",
    stroke: "#D09E75"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m204 1049 76-359.488",
    stroke: "#D09E75"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m236 1049 76-359.488",
    stroke: "#D09E75"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m273.5 1049 66-358.983",
    stroke: "#D09E75"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m310 1049 58.5-359.488",
    stroke: "#D09E75"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M344.5 1049 399 689.512",
    stroke: "#D09E75"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m380.5 1049 47-359.488",
    stroke: "#D09E75"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m414 1049 44.5-358.983",
    stroke: "#D09E75"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m449.5 1048.5 36-358.988",
    stroke: "#D09E75"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m519 1048.5 25-358.988",
    stroke: "#D09E75"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M553 1048.5 573 688",
    stroke: "#D09E75"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m590 1048.5 12-358.483",
    stroke: "#D09E75"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m625 1048.5 7.5-358.988",
    stroke: "#D09E75"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M660 1048.5V689.512",
    stroke: "#D09E75"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M691 1048.5V689.512",
    stroke: "#D09E75"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m486 1048.5 28-358.988",
    stroke: "#D09E75"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M104 1029h36",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M141 889.676h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M173 766.654h30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M162 937.07h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M200 907.827h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M217 988.497h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M240 1028.83h38",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M269 889.676h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M246 853.374h31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M230 782.788h31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M358 752.536h31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M394 719.26h30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M376 838.249h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M339 871.525h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M291 953.204h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M317 1009.67h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M356 972.363h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M434 889.676h31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M474 807.997h31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M449 766.654h29",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M461 936.062h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M523 989.506h33",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M532 853.374h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M597 823h33",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M631 751.528h29",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M625 1011.69h35",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M593 952.196h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M506 782.788h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M497 906.818h32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M336 707.159h30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M193 807.997h30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M98 936.062h30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M134 806h29",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M52 972.363h36",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M29 926h36",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M91 838.249h34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1322 1050-103.5-358.983",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.5 1048.49 1253 691.017",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1397 1050-116-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1254 1050-95.5-358.983",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1285 1050-98.5-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1217 1050-86.5-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1184 1050-82.5-359.992",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1148 1050-76-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1116 1050-76-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1078.5 1050-66-358.983",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1042 1050-58.5-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.5 1050 953 690.512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m971.5 1050-47-359.488",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m938 1050-44.5-358.983",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.5 1049.5-36-358.988",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m833 1049.5-25-358.988",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 1049.5 779 689",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m762 1049.5-12-358.483",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m727 1049.5-7.5-358.988",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866 1049.5-28-358.988",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.5 1029.83h-37",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211 890.676h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179 767.654h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 938.07h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 908.827h-34",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135 989.497h-32",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112 1029.83h-38",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 890.676h-34",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106 854.374h-31",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 783.788h-31",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994 753.536h-31",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958 720.26h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976 839.249h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013 872.525h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061 954.204h-34",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035 1010.67h-34",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996 973.363h-34",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918 890.676h-31",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 808.997h-31",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903 767.654h-29",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891 937.062h-34",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829 990.506h-33",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 854.374h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 824.123h-33",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 808.997h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 1012.69h-35",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759 953.196h-34",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 784h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 907.818h-32",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016 708.159h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159 808.997h-30",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254 937.062h-30",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219 806.98h-30",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365 834.207h-38",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1417 982.438h-42",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 973.363h-36",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328 939.078h-38",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261 839.249h-34",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288 806.98h-36",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307 767.654h-31",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m1321 1049-103.5-358.983",
    stroke: "#D09E75"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.5 1047.49 1252 690.017",
    stroke: "#D09E75"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m1396 1049-116-359.488",
    stroke: "#D09E75"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m1253 1049-95.5-358.983",
    stroke: "#D09E75"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m1284 1049-98.5-359.488",
    stroke: "#D09E75"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m1216 1049-86.5-359.488",
    stroke: "#D09E75"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m1183 1049-82.5-359.992",
    stroke: "#D09E75"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m1147 1049-76-359.488",
    stroke: "#D09E75"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m1115 1049-76-359.488",
    stroke: "#D09E75"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m1077.5 1049-66-358.983",
    stroke: "#D09E75"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m1041 1049-58.5-359.488",
    stroke: "#D09E75"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.5 1049 952 689.512",
    stroke: "#D09E75"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m970.5 1049-47-359.488",
    stroke: "#D09E75"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m937 1049-44.5-358.983",
    stroke: "#D09E75"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m901.5 1048.5-36-358.988",
    stroke: "#D09E75"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m832 1048.5-25-358.988",
    stroke: "#D09E75"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M798 1048.5 778 688",
    stroke: "#D09E75"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m761 1048.5-12-358.483",
    stroke: "#D09E75"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m726 1048.5-7.5-358.988",
    stroke: "#D09E75"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m865 1048.5-28-358.988",
    stroke: "#D09E75"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.5 1028.83h-37",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1210 889.676h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1178 766.654h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1189 937.07h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1151 907.827h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1134 988.497h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1111 1028.83h-38",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 889.676h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1105 853.374h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1121 782.788h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M993 752.536h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M957 719.26h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M975 838.249h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1012 871.525h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 953.204h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1034 1009.67h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M995 972.363h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M917 889.676h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M877 807.997h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M902 766.654h-29",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M890 936.062h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M828 989.506h-33",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M819 853.374h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M754 823.123h-33",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M721 807.997h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m725 1012-34-.31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M758 952.196h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M844 783h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M854 906.818h-32",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 707.159h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1158 807.997h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1253 936.062h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1218 805.98h-30",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1364 833.207h-38",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1416 981.438h-42",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1299 972.363h-36",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1327 938.078h-38",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1260 838.249h-34",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1287 805.98h-36",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1306 766.654h-31",
    stroke: "#D09E75",
    strokeOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 689,
    width: 1198,
    height: 2,
    fill: "#D09E75"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M116 0h1197v689H116V0Z",
    fill: "#F3EFEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1989_1050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 180,
    width: 343,
    height: 233,
    fill: "url(#paint20_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 180,
    width: 343,
    height: 233,
    fill: "url(#paint21_radial_1989_1050)",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 182,
    width: 339,
    height: 229,
    stroke: "#F9F8F9",
    strokeWidth: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395 509.5-9.539 20h-254.95l-9.511-20h274Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M121 513a1.5 1.5 0 0 1 1.5-1.5h273a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-273a1.5 1.5 0 0 1-1.5-1.5v-8Z",
    fill: "#CAA98E"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M127 494.5h270v15a2 2 0 0 1-2 2H123.827a2 2 0 0 1-1.886-2.666L127 494.5Z",
    fill: "url(#paint22_linear_1989_1050)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.5 511.5H397",
    stroke: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.5 494.5h269",
    stroke: "#9B571E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m127 494.5-6 17",
    stroke: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m396.5 494 .5 17.5",
    stroke: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395 600.5-9.539 20h-254.95l-9.511-20h274Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M121 604a1.5 1.5 0 0 1 1.5-1.5h273a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-273a1.5 1.5 0 0 1-1.5-1.5v-8Z",
    fill: "#CAA98E"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M127 581.5h270v19a2 2 0 0 1-2 2H123.651a2 2 0 0 1-1.923-2.549L127 581.5Z",
    fill: "url(#paint23_linear_1989_1050)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.5 602.5h276",
    stroke: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.5 581.5h269",
    stroke: "#9B571E"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m127.5 581-6.5 21.5",
    stroke: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M397 582v20.5",
    stroke: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395 414-9.539 20h-254.95L121 414h274Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M121 417.5a1.5 1.5 0 0 1 1.5-1.5h273a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-273a1.5 1.5 0 0 1-1.5-1.5v-8Z",
    fill: "#CAA98E"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M127 404h269l.91 10.917a1 1 0 0 1-.997 1.083H122.618a1 1 0 0 1-.894-1.447L127 404Z",
    fill: "url(#paint24_linear_1989_1050)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.5 416H397",
    stroke: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.5 404h268",
    stroke: "#9B571E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.5 403.5 121 416",
    stroke: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m396 403.5 1 12.5",
    stroke: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter4_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395 303-9.539 20h-254.95L121 303h274Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M121 306.5a1.5 1.5 0 0 1 1.5-1.5h273a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-273a1.5 1.5 0 0 1-1.5-1.5v-8Z",
    fill: "#CAA98E"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M127 297h269l.859 6.876a1 1 0 0 1-.992 1.124H123a1 1 0 0 1-.8-1.6l4.8-6.4Z",
    fill: "url(#paint25_linear_1989_1050)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.5 305H397",
    stroke: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.5 297h268",
    stroke: "#9B571E"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.5 296.5 121 305",
    stroke: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m395.5 297 1.5 8",
    stroke: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter5_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m395 212-9.539 20h-254.95L121 212h274Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M121 215.5a1.5 1.5 0 0 1 1.5-1.5h273a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-273a1.5 1.5 0 0 1-1.5-1.5v-8Z",
    fill: "#DABFAA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M127 209h269l1 5H121l6-5Z",
    fill: "#EFDDCD"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M120.5 214H397",
    stroke: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.5 209h268",
    stroke: "#9B571E"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.5 208.5 121 214",
    stroke: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m395.5 208.5 1.5 5.5",
    stroke: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m1313 689 127 359V0h-127v689Z",
    fill: "#EBDCCD"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M116 689 0 1048V0h116v689Z",
    fill: "#EBDCCD"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1011 462-6.41 10.203H833.387L827 462h184Z",
    fill: "#14161A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M827 459.203 831.406 449h176.204l3.39 10.203H827Z",
    fill: "url(#paint26_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 459.203h184v6.122H827v-6.122Z",
    fill: "#56546F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M826.5 459.5H1011",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m371.106 603.29 28.316-11.488s-1.599-3.782-.524-8.246l-28.012 11.188c-.961 3.893-.302 6.98.22 8.546Z",
    fill: "#E2ECF1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M370.05 596.818c.037-.364.063-.738.131-1.104.047-.366.134-.733.202-1.1l.045-.244.264-.117c1.156-.506 2.314-.981 3.482-1.448 1.169-.466 2.349-.903 3.529-1.34 2.36-.883 4.71-1.776 7.059-2.669 2.35-.893 4.699-1.796 7.059-2.67 2.36-.884 4.711-1.767 7.071-2.64l.037.098a1977.27 1977.27 0 0 1-6.941 2.954c-2.313.991-4.637 1.953-6.952 2.924-2.314.972-4.638 1.944-6.952 2.925-1.156.496-2.313.991-3.481 1.457-1.091.432-2.171.862-3.273 1.264a8.9 8.9 0 0 0-.173.755c-.079.337-.138.683-.196 1.038l-.068.518-.057.527c-.019.172-.028.353-.047.526l-.014.262-.003.262c-.009.171-.008.352-.007.533l.004.533c.001.181.012.351.024.532.011.18.022.35.043.53.033.36.086.709.128 1.058.062.349.125.707.198 1.064l-.108.037a11.695 11.695 0 0 1-.686-2.079l-.067-.267-.047-.269a60.035 60.035 0 0 1-.095-.547c-.032-.179-.054-.369-.075-.549a9.193 9.193 0 0 1-.045-.55 13.526 13.526 0 0 1 .011-2.204Z",
    fill: "#939598"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M370.819 604.787a.43.43 0 0 0 .213.188.47.47 0 0 0 .173.029.647.647 0 0 0 .129-.028l29.387-12.06a.412.412 0 1 0-.31-.765l-29.024 11.906a9.977 9.977 0 0 1-.291-.776c-.512-1.557-1.182-4.653-.221-8.547l28.013-11.187 1.659-.659a.408.408 0 0 0 .228-.537.405.405 0 0 0-.236-.227.558.558 0 0 0-.123-.032.386.386 0 0 0-.179.031l-29.858 11.929a.404.404 0 0 0-.182.142.846.846 0 0 0-.072.135c-1.566 6.095.592 10.283.694 10.458Z",
    fill: "#227BA6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m331.538 581.06 38.668 13.136a.436.436 0 0 1 .183-.142l29.868-11.93a.533.533 0 0 1 .18-.031l-38.493-8.299-30.406 7.266Z",
    fill: "#0B4861"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m332.182 591.219 38.849 13.768a.39.39 0 0 1-.213-.188c-.092-.175-2.261-4.363-.685-10.458.017-.052.034-.103.072-.136l-38.668-13.135c-1.561 6.004.645 10.149.645 10.149Z",
    fill: "#005E83"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M371.106 603.29c.111.325.209.591.291.776l29.014-11.915-.99-.36-28.315 11.499Z",
    fill: "#0B4861"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m362.134 592.784 35.588-9.696s-1.757-2.152-.38-5.992l-35.158 8.864c-.815 3.331-.461 5.573-.05 6.824Z",
    fill: "#E2ECF1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M361.403 589.36c-.018-.593.016-1.178.069-1.765.063-.588.157-1.167.272-1.747l.055-.245.276-.078c2.907-.838 5.816-1.636 8.763-2.315 2.948-.67 5.884-1.368 8.83-2.058 2.946-.689 5.881-1.398 8.828-2.077 2.947-.68 5.884-1.369 8.831-2.038l.027.109c-2.908.808-5.828 1.596-8.748 2.394-2.919.799-5.839 1.577-8.75 2.355a860.53 860.53 0 0 0-8.749 2.374c-2.83.783-5.688 1.436-8.558 2.061-.122.45-.234.91-.325 1.368-.106.55-.182 1.108-.236 1.675-.045.566-.06 1.131-.034 1.692.026.562.102 1.131.229 1.696l-.109.037a5.942 5.942 0 0 1-.294-.826 8.03 8.03 0 0 1-.205-.853 12.857 12.857 0 0 1-.172-1.759Z",
    fill: "#BCBEC0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M362.074 594.528a.42.42 0 0 0 .352.159c.03-.002.06-.004.08-.015l36.758-10.132a.414.414 0 0 0 .289-.511.373.373 0 0 0-.175-.231s-.01.001-.011-.009c-.021-.009-.031-.018-.052-.027a.42.42 0 0 0-.273-.023l-36.462 10.043a5.2 5.2 0 0 1-.437-1.019c-.412-1.251-.776-3.492.05-6.823l35.157-8.864 1.417-.361a.418.418 0 0 0 .3-.502.418.418 0 0 0-.502-.3l-36.812 9.29a.418.418 0 0 0-.303.301c-1.593 6.147.536 8.919.624 9.024Z",
    fill: "#B53D41"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "m333.011 578.725 29.062 15.805c-.088-.115-2.217-2.878-.623-9.014l-28.844-13.173c-1.148 4.428.405 6.382.405 6.382Z",
    fill: "#EE4540"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m332.606 572.342 28.845 13.174a.44.44 0 0 1 .303-.301l36.812-9.291-34.22-7.774-31.74 4.192Z",
    fill: "#CF4140"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M362.134 592.784c.161.483.323.815.437 1.019l36.462-10.044a.36.36 0 0 1 .273.023 10.584 10.584 0 0 0-1.593-.684l-35.579 9.686Z",
    fill: "#9E3940"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 464.142,
    width: 6.57882,
    height: 51.8082,
    fill: "#3A98AE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m153.579 464.143 10.69-18.092v51.808l-10.69 18.092v-51.808Z",
    fill: "#4EAFC6"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M147 464.143h6.579l10.69-17.681h-5.756L147 464.143Z",
    fill: "#FFFAF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 468.622,
    width: 6.01005,
    height: 47.3291,
    fill: "#D75B5B"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m161.01 468.622 9.767-16.528v47.329l-9.767 16.528v-47.329Z",
    fill: "#EE9292"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M155 468.622h6.01l9.766-16.152h-5.258L155 468.622Z",
    fill: "#FFFAF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 462.105,
    width: 6.58353,
    height: 51.8453,
    fill: "#A3D997"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M168.585 462.105 179.283 444v51.845l-10.698 18.105v-51.845Z",
    fill: "#82B577"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M162 462.105h6.584l10.698-17.694h-5.761L162 462.105Z",
    fill: "#FFFAF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 464.142,
    width: 6.57882,
    height: 51.8082,
    fill: "#F2C979"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m177.579 464.143 10.69-18.092v51.808l-10.69 18.092v-51.808Z",
    fill: "#F8DBA3"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M171 464.143h6.579l10.69-17.681h-5.756L171 464.143Z",
    fill: "#F0FFF3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 468.622,
    width: 6.01005,
    height: 47.3291,
    fill: "#7E6262"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m185.01 468.622 9.767-16.528v47.329l-9.767 16.528v-47.329Z",
    fill: "#624848"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M179 468.622h6.01l9.766-16.152h-5.258L179 468.622Z",
    fill: "#FFFAF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 462.105,
    width: 6.58353,
    height: 51.8453,
    fill: "#6A6D98"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M192.585 462.105 203.283 444v51.845l-10.698 18.105v-51.845Z",
    fill: "#4B4E75"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M186 462.105h6.584l10.698-17.694h-5.761L186 462.105Z",
    fill: "#FFF0FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 194.776,
    y: 467.085,
    width: 6.07821,
    height: 47.8659,
    fill: "#3A69AE"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m200.855 467.085 9.877-16.715v47.866l-9.877 16.715v-47.866Z",
    fill: "#6995D5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M194.776 467.085h6.079l9.877-16.335h-5.319l-10.637 16.335Z",
    fill: "#F0F6FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 202.167,
    y: 471.223,
    width: 5.55271,
    height: 43.7276,
    fill: "#D75B5B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m207.72 471.223 9.023-15.27v43.728l-9.023 15.27v-43.728Z",
    fill: "#EE9292"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M202.167 471.223h5.553l9.023-14.923h-4.859l-9.717 14.923Z",
    fill: "#FFFAF0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 208.635,
    y: 465.202,
    width: 6.08256,
    height: 47.9002,
    fill: "#A3D997"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m214.719 465.202 9.884-16.727v47.9l-9.884 16.727v-47.9Z",
    fill: "#82B577"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M208.635 465.202h6.082l9.884-16.347h-5.322l-10.644 16.347Z",
    fill: "#F0FFF3"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M214.776 465.454v47.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 216.95,
    y: 467.085,
    width: 6.07821,
    height: 47.8659,
    fill: "url(#paint27_linear_1989_1050)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m223.028 467.085 9.878-16.715v47.866l-9.878 16.715v-47.866Z",
    fill: "#F8DBA3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M222.776 467.454v47.205",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M216.95 467.085h6.078l9.877-16.335h-5.318l-10.637 16.335Z",
    fill: "#F0FFFA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 224.341,
    y: 471.223,
    width: 5.55271,
    height: 43.7276,
    fill: "url(#paint28_linear_1989_1050)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m229.894 471.223 9.023-15.27v43.728l-9.023 15.27v-43.728Z",
    fill: "#624848"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.776 471.454v43.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M224.341 471.223h5.553l9.023-14.923h-4.859l-9.717 14.923Z",
    fill: "#FFFAF0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 230.809,
    y: 465.202,
    width: 6.08256,
    height: 47.9002,
    fill: "url(#paint29_linear_1989_1050)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m236.893 465.202 9.884-16.727v47.9l-9.884 16.727v-47.9Z",
    fill: "#CCCCCC"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M236.776 465.454v47.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M230.809 465.202h6.082l9.885-16.347h-5.323l-10.644 16.347Z",
    fill: "#EEEEEE"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m1239 820.5 63-96.5 104 321h-116l-51-224.5Z",
    fill: "url(#paint30_linear_1989_1050)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.5 654V72l88 143v689l-88-250Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341 654v.427l.14.403 88 250 4.86-.83V214.292l-.37-.602-88-143-4.63-7.523V654Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1361 649V136l70.5 118v589L1361 649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361 649V136l70.5 118v589L1361 649Z",
    fill: "url(#paint31_linear_1989_1050)"
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1431 553-70-135v-22.5l70 136V553Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1430 531.742v17.157l-68-131.143v-18.128l68 132.114Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m1148 935.5 63-96.5 65.5 205.5h-104l-24.5-109Z",
    fill: "url(#paint32_linear_1989_1050)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1360 137v515.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M201.781 173.802c-.737-1.567-.737-3.325-.725-5.026.013-1.86.026-3.713.128-5.572.101-1.904.4-3.998 1.962-5.274.483-.393 1.061-.679 1.544-1.073.483-.393.877-.945.813-1.535-.184-1.746-3.888-1.086-5.037-1.06-2.491.044-4.981.12-7.465.228-.565.026-1.175.07-1.709.235-.533-.165-1.143-.209-1.708-.235a370.679 370.679 0 0 0-7.465-.228c-1.15-.019-4.853-.686-5.037 1.06-.064.584.33 1.142.813 1.535.482.394 1.061.686 1.543 1.073 1.563 1.269 1.862 3.364 1.963 5.274.102 1.853.115 3.712.127 5.572.013 1.701.013 3.459-.724 5.026-.851 1.802-2.566 3.135-3.85 4.709-2.07 2.551-2.979 5.788-2.953 8.961.031 3.173.952 6.289 2.255 9.234 1.188 2.678 5.33 8.732 6.346 9.297.165.463.184.965-.127 1.587-.286.564-.807 1.085-.756 1.7.057.705.807 1.187 1.518 1.479 3.653 1.479 13.265 1.25 16.212 0 .705-.298 1.461-.774 1.519-1.479.05-.621-.471-1.136-.756-1.7-.312-.622-.299-1.124-.128-1.587 1.017-.565 5.038-6.619 6.226-9.297 1.309-2.939 2.23-6.061 2.255-9.234.032-3.173-.876-6.403-2.954-8.961-1.264-1.58-2.979-2.907-3.83-4.709Z",
    fill: "#FF7145"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M201.781 173.802c-.737-1.567-.737-3.325-.724-5.026.012-1.86.025-3.713.127-5.572.101-1.904.4-3.998 1.963-5.274.482-.393 1.06-.679 1.543-1.073.483-.393.877-.945.813-1.535-.184-1.746-3.887-1.086-5.037-1.06a346.24 346.24 0 0 0-6.848.203c.025 1.149-.007 2.31-.922 2.989-1.054.787-2.731.831-4.021.882-1.569.064-3.411.457-4.929.406 3.818.134 8.296.61 10.208 3.618 2.16 3.389-.387 7.799.801 11.563.514 1.618 1.677 2.982 2.611 4.436 2.166 3.357 3.144 7.45 2.102 11.226-1.041 3.776-4.275 7.121-8.436 8.047-2.859.635-5.889.14-8.652-.768-2.891-.951-5.756-2.506-7.115-5.013-.674-1.244-.934-2.634-1.245-4.005.095 3.047.991 6.042 2.248 8.866 1.188 2.678 5.33 8.733 6.347 9.297.165.464.184.965-.127 1.587-.286.565-.807 1.085-.756 1.701.057.704.807 1.187 1.518 1.479 3.653 1.478 13.264 1.25 16.212 0 .705-.299 1.461-.775 1.518-1.479.051-.622-.47-1.136-.756-1.701-.311-.622-.298-1.123-.127-1.587 1.017-.564 5.038-6.619 6.226-9.297 1.309-2.938 2.23-6.061 2.255-9.234.032-3.173-.877-6.403-2.954-8.961-1.277-1.586-2.992-2.913-3.843-4.715Z",
    fill: "#F96643"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M203.026 186.844c.031 2.24-.216 4.493-.915 6.651-1.055 3.243-3.202 6.27-6.346 8.085-4.454 2.57-10.698 2.265-14.821-.73 2.922 3.281 7.864 4.956 12.438 4.252 4.581-.711 8.621-3.77 10.228-7.724.635-1.567.909-3.23 1.086-4.892.426-4.068.159-8.492-2.572-11.735 1.073 1.269.883 4.582.902 6.093Z",
    fill: "#F45B3D"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M203.375 154.122c-.006.013-.006.026-.012.038-.026.089-.038.197-.121.254-.083.057-.241.013-.222-.076l-.35.616c-.012.59-.438 1.123-.972 1.459-.533.337-1.175.502-1.81.641-2.725.603-5.527.806-8.335.959-.908.253-1.956.285-2.82.323-1.569.064-3.412.457-4.93.406.127.007.26.013.394.013 2.611.045 5.228.121 7.82.413 1.398.152 2.878.412 3.869 1.32.984.907 1.258 2.259 1.385 3.528.343 3.408.044 6.994 1.689 10.072a32.415 32.415 0 0 1-.927-7.521c-.006-1.681.127-3.382.743-4.969.343-.876.851-1.72 1.601-2.361.832-.71 1.874-1.097 2.967-1.415.451-.343.972-.615 1.41-.971.483-.393.877-.945.813-1.536-.089-.882-1.08-1.148-2.192-1.193Z",
    fill: "#F45B3D"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M191.299 156.007c7.627 0 13.811-.634 13.811-1.415 0-.782-6.184-1.415-13.811-1.415s-13.811.633-13.811 1.415c0 .781 6.184 1.415 13.811 1.415Z",
    fill: "#B35639"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M203.47 153.925c-2.433.406-6.785.673-11.746.673-5.26 0-9.834-.305-12.165-.749-1.309.216-2.065.47-2.065.749 0 .781 6.181 1.415 13.811 1.415 7.629 0 13.81-.634 13.81-1.415 0-.248-.597-.476-1.645-.673Z",
    fill: "#A34D36"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M189.851 177.832c-3.374-.628-8.704-1.161-10.94 1.866-.521.704-.794 1.536-.972 2.373a12.088 12.088 0 0 0 .909 7.66c.419.882.946 1.726 1.696 2.399s1.734 1.161 2.789 1.219c1.143.063 2.255-.368 3.214-.94 3.138-1.865 4.936-5.089 6.302-8.263.585-1.358 1.118-2.912.432-4.232-.603-1.175-2.026-1.822-3.43-2.082Z",
    fill: "#FF7C48"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M205.472 178.314c-7.611 1.06-15.761.933-23.607.267-1.531-.127-2.96-.4-4.377-.679-.178.197-.355.4-.521.609-2.071 2.551-2.979 5.788-2.954 8.961.032 3.173.953 6.289 2.256 9.234.127.292.292.628.489.984 4.656 1.009 9.91 1.84 13.664 1.935 6.893.172 14.192-.983 15.088-1.32a17.92 17.92 0 0 0 .819-1.605c1.309-2.939 2.23-6.061 2.256-9.234.031-3.173-.877-6.404-2.954-8.961a2.475 2.475 0 0 1-.159-.191Z",
    fill: "#FFBF85"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M205.453 178.314a82.707 82.707 0 0 1-7.7.686c1.881 3.23 2.675 7.038 1.703 10.573-1.042 3.776-4.276 7.12-8.437 8.047-2.858.634-5.888.139-8.652-.768-2.89-.952-5.755-2.507-7.115-5.014-.673-1.244-.934-2.634-1.245-4.004.006.19.013.38.025.564v.007c.013.19.026.374.045.565v.006c.019.184.038.368.063.558v.013l.077.546c0 .006 0 .019.006.025.025.178.057.356.089.54 0 .012.006.025.006.031.032.178.07.35.102.527.006.013.006.032.013.045l.114.507a.243.243 0 0 1 .013.064c.038.165.082.33.127.495.006.025.013.051.019.082l.133.476c.013.032.019.07.032.102l.133.45.039.127c.044.14.088.286.139.426.019.05.038.101.051.152.045.133.089.266.14.393.025.064.044.127.07.191.044.12.089.241.133.355.032.076.064.159.089.235.038.101.083.209.121.311.044.101.082.203.127.305.032.076.063.158.095.234.076.184.153.362.235.54l.095.209c.007.013.007.019.013.032.032.07.064.14.102.209l.019.038c.038.07.076.146.114.223.007.012.013.019.013.031.044.083.083.165.127.248 4.657 1.009 9.91 1.84 13.665 1.935 6.892.172 14.191-.983 15.087-1.32.305-.545.565-1.047.756-1.472.019-.044.038-.082.057-.127 1.309-2.938 2.23-6.061 2.255-9.234.032-3.173-.876-6.403-2.954-8.961-.025-.07-.082-.133-.139-.203Z",
    fill: "#FFAA71"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M183.727 195.215a84.563 84.563 0 0 1-8.564-1.34c.21.622.439 1.238.686 1.841a89.575 89.575 0 0 0 18.055 1.631 91.276 91.276 0 0 0 11.091-.819c.49-.063.979-.133 1.481-.203.26-.603.501-1.212.724-1.828-.82.153-1.639.28-2.465.394-6.931.958-14.033 1.047-21.008.324Z",
    fill: "#EE704A"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M204.106 193.533c-2.478.412-4.987.634-7.503.723-5.145.178-10.291-.203-15.405-.666-2.09-.184-4.32-.241-6.365-.8.038.121.07.248.108.368 1.493.47 3.138.584 4.694.737 2.675.26 5.349.52 8.03.685 5.19.324 10.425.343 15.577-.4a50.063 50.063 0 0 0 4.116-.774l.235-.057.172-.565h-.006a46.7 46.7 0 0 1-3.653.749Z",
    fill: "#EE704A"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M196.133 183.449c-4.898.152-9.808.165-14.687-.28a84.716 84.716 0 0 1-4.25-.488c-.775-.108-1.55-.273-2.331-.406l-.115.342c.629.14 1.264.241 1.881.349 1.175.21 2.35.381 3.538.514 2.535.28 5.082.426 7.63.489 4.91.114 9.916.083 14.795-.45a42.88 42.88 0 0 0 5.26-.895 14.11 14.11 0 0 0-.165-.476c-3.742.939-7.681 1.18-11.556 1.301Z",
    fill: "#EE704A"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M181.319 180.472c-1.741-.171-3.507-.381-5.209-.787-.305.482-.579.99-.814 1.504 1.455.368 2.954.609 4.473.787 2.452.286 4.923.47 7.388.59 5.012.241 10.043.121 15.017-.526a63.188 63.188 0 0 0 5.102-.876 12.461 12.461 0 0 0-.839-1.536c-8.208 1.701-16.758 1.65-25.118.844Z",
    fill: "#EE704A"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M186.337 160.31c-.756-.273-1.601.057-1.963.717-.362.647-.292 1.415-.216 2.139.191 1.764.382 3.541.318 5.312-.064 1.777-.388 3.56-1.188 5.178-.121.241-.248.482-.273.743-.026.26.076.552.324.685.133.07.292.089.451.102 1.398.127 2.795.26 4.193.387.139.012.286.025.406-.045.14-.082.184-.247.21-.399.152-1.022-.045-2.063-.114-3.091-.185-2.786.584-5.553.609-8.345.007-.781-.063-1.619-.609-2.222-.502-.558-1.423-.901-2.148-1.161Z",
    fill: "#FF7C48"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M190.963 156.54a29.645 29.645 0 0 1-10.654-.634c-.61-.153-1.219-.324-1.836-.457-.355-.077-1.372-.184-.864.495.134.177.363.273.579.355 4.078 1.568 8.703 1.923 13.016.996.508-.107 1.08-.285 1.29-.723-.483-.165-1.023-.095-1.531-.032Z",
    fill: "#FF7C48"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M176.84 187.586a1.86 1.86 0 0 0-.191.197c.045-.038.083-.076.127-.114.007-.007.007-.013.013-.019a.476.476 0 0 0 .051-.064Z",
    fill: "#EE704A"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M176.23 185.765a1.07 1.07 0 0 1-.152-.432.506.506 0 0 0 .152.432Z",
    fill: "#EE704A"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M178.32 185.492a1.286 1.286 0 0 0-.012-.559c-.108-.387-.483-.691-.915-.755-.432-.063-.89.127-1.131.457-.146.203-.21.451-.184.698a.54.54 0 0 1 .038-.146c.082-.19.267-.336.476-.419.293-.114.667-.101.909.089.222.178.305.457.311.73.019.749-.502 1.409-.972 1.999.07-.063.146-.12.222-.178.591-.558 1.125-1.167 1.258-1.916Z",
    fill: "#EE704A"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M176.84 187.586a.476.476 0 0 0-.051.064c-.006.006-.006.013-.013.019.096-.089.191-.172.286-.261a2.06 2.06 0 0 0-.222.178Z",
    fill: "#EE704A"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M182.494 186.812c-.908-.425-1.988-.476-2.992-.311-.775.127-1.766.425-2.433.908-.095.088-.191.177-.286.26-.622.78-.889 1.466-1.092 2.411.209-1.059.997-2.005 2.051-2.487 1.061-.476 2.364-.476 3.418.012.642.299 1.207.787 1.404 1.416.203.628-.038 1.389-.661 1.719-.622.33-1.569.057-1.759-.571-.248.457-.038 1.054.406 1.371.445.311 1.074.362 1.608.197.533-.165.978-.514 1.321-.92.432-.521.724-1.162.686-1.816-.051-.932-.762-1.764-1.671-2.189Z",
    fill: "#EE704A"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M184.012 191.857a.487.487 0 0 0-.114.439.89.89 0 0 1 .114-.439Z",
    fill: "#EE704A"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M185.607 191.921c.013.266-.038.558-.248.749-.229.209-.591.247-.896.152-.216-.064-.412-.197-.514-.387-.026-.045-.038-.095-.051-.14-.006.241.076.489.241.679.267.311.744.463 1.169.375.426-.096.775-.426.845-.819a1.242 1.242 0 0 0-.038-.552c-.197-.736-.781-1.307-1.417-1.815a2.33 2.33 0 0 1-.235-.165c.521.552 1.099 1.174 1.144 1.923Z",
    fill: "#EE704A"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M189.412 185.492c-.546-.127-1.169-.032-1.588.311-.419.343-.572.952-.286 1.396.134-.641 1.061-.977 1.709-.692.648.286.953 1.029.807 1.67-.146.641-.667 1.167-1.283 1.51-1.01.558-2.313.654-3.412.247-1.099-.399-1.956-1.294-2.255-2.335.28.927.61 1.593 1.29 2.329.101.076.209.159.311.241.705.432 1.722.66 2.503.73 1.016.089 2.084-.038 2.954-.52.87-.483 1.512-1.365 1.48-2.291-.019-.654-.362-1.276-.838-1.758-.369-.394-.845-.711-1.392-.838Z",
    fill: "#EE704A"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M184.407 189.934c.019.019.038.045.057.064.076.057.152.114.235.165a6.175 6.175 0 0 0-.292-.229Z",
    fill: "#EE704A"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M184.394 189.922c-.045-.032-.089-.07-.134-.102.064.064.134.121.21.184-.019-.019-.038-.044-.057-.063l-.019-.019Z",
    fill: "#EE704A"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M194.475 185.486c.064-.178.102-.362.083-.552-.038-.394-.356-.755-.769-.876-.413-.121-.902-.006-1.201.286a1.033 1.033 0 0 0-.305.66c.013-.051.039-.096.064-.14.114-.178.324-.298.546-.343.312-.07.674-.006.883.222.191.203.223.495.178.762-.108.742-.743 1.32-1.308 1.834.082-.051.165-.102.254-.146.686-.463 1.315-.99 1.575-1.707Z",
    fill: "#EE704A"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M192.652 187.339a1.58 1.58 0 0 0-.222.165l.146-.095c.006-.007.013-.007.013-.013a.598.598 0 0 0 .063-.057Z",
    fill: "#EE704A"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M192.366 185.454a.993.993 0 0 1-.076-.451.495.495 0 0 0 .076.451Z",
    fill: "#EE704A"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M198.37 187.383c-.826-.546-1.881-.755-2.903-.736-.788.013-1.824.165-2.561.546-.108.076-.222.146-.33.215-.749.68-1.131 1.321-1.499 2.228.387-1.015 1.328-1.84 2.458-2.158 1.131-.323 2.421-.127 3.374.502.584.38 1.054.952 1.143 1.599.089.647-.279 1.364-.953 1.599-.673.235-1.563-.165-1.639-.812-.324.419-.222 1.034.159 1.409.388.374.997.507 1.556.425.553-.083 1.055-.368 1.462-.724.52-.45.914-1.047.991-1.694.12-.927-.432-1.847-1.258-2.399Z",
    fill: "#EE704A"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M192.652 187.339c-.019.019-.045.038-.064.057-.006.006-.013.006-.013.013l.331-.216a2.995 2.995 0 0 0-.254.146Z",
    fill: "#EE704A"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M205.434 187.072c-.515-.203-1.15-.203-1.62.076-.47.279-.731.857-.528 1.333.248-.616 1.214-.813 1.804-.438.591.374.763 1.149.509 1.758s-.864 1.06-1.531 1.307a4.238 4.238 0 0 1-3.412-.241c-1.01-.552-1.709-1.561-1.823-2.627.121.958.324 1.662.87 2.481l.267.286c.623.526 1.588.901 2.344 1.078.991.235 2.065.261 3.012-.095.946-.355 1.727-1.129 1.861-2.05.095-.647-.134-1.307-.521-1.859-.305-.425-.718-.806-1.232-1.009Z",
    fill: "#EE704A"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M198.801 193a1.05 1.05 0 0 1 .191-.419.498.498 0 0 0-.191.419Z",
    fill: "#EE704A"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M199.704 190.728c-.038-.038-.076-.083-.115-.121.051.07.108.14.172.21-.013-.026-.032-.045-.044-.07 0-.007-.007-.013-.013-.019Z",
    fill: "#EE704A"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M199.716 190.747c.013.025.032.044.045.069.063.07.133.134.203.197l-.267-.285c.013.006.019.012.019.019Z",
    fill: "#EE704A"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M199.767 190.816c.413.622.876 1.314.794 2.063-.032.266-.134.546-.375.704-.26.172-.629.159-.915.026-.203-.095-.375-.254-.438-.451a.394.394 0 0 1-.025-.146c-.045.241-.007.495.12.705.21.349.655.564 1.087.533.431-.032.838-.311.978-.686.063-.177.076-.368.063-.552-.063-.755-.546-1.402-1.08-1.993-.082-.069-.146-.139-.209-.203Z",
    fill: "#EE704A"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M181.687 184.578c-.082-.038-.171-.038-.26-.038-.381.019-.737.152-1.074.311a7.263 7.263 0 0 0-2.147 1.536c.121-.064.242-.114.362-.165a9.776 9.776 0 0 1 1.957-.559c.406-.076.845-.139 1.137-.406.108-.095.191-.216.203-.343.013-.133-.051-.279-.178-.336Z",
    fill: "#EE704A"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m177.393 187.047.527-.343c.089-.108.185-.209.28-.317a2.59 2.59 0 0 0-.572.387 1.66 1.66 0 0 0-.235.273Z",
    fill: "#EE704A"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M190.733 191.489c.102-.114.254-.19.375-.292.121-.101.21-.266.14-.4-.064-.12-.229-.171-.369-.152-.146.019-.273.089-.4.152-.94.464-2.046.635-3.1.514a6.048 6.048 0 0 1-.781-.146c-.191-.044-.318-.152-.337.051-.026.324.749.92.972 1.136.521.508 1.181.965 1.95 1.022.261.019.553-.019.724-.197.178-.178.146-.514-.095-.596.407.133.87-.019 1.188-.28.184-.152.337-.361.299-.583-.058-.229-.394-.381-.566-.229Z",
    fill: "#EE704A"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M198.935 186.082a.864.864 0 0 0-.68-.184c.223-.038.331-.311.229-.495-.095-.19-.337-.285-.565-.292-.229-.006-.452.057-.667.127.127-.076.26-.165.336-.285.076-.127.064-.305-.063-.388-.089-.057-.21-.05-.318-.038-.559.077-1.054.343-1.518.641-.807.521-1.442 1.2-2.217 1.746 1.454-.762 3.373-.971 4.942-.349.203.076.476.146.616-.007.134-.139.051-.355-.095-.476Z",
    fill: "#EE704A"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M176.186 187.523c-.172-.076-.35.095-.452.241.051-.076-.05-.171-.139-.165-.096.006-.172.07-.235.133a1.79 1.79 0 0 0-.343.502 20.87 20.87 0 0 1-.324-.375c-.477.813-.286 1.803-.077 2.704.108.476.28 1.021.407 1.497a4.11 4.11 0 0 1 .083-1.738c.216-.813.667-1.549 1.099-2.291.095-.165.165-.426-.019-.508Z",
    fill: "#EE704A"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M207.866 185.225a.676.676 0 0 0-.235.204c-.025-.102-.05-.21-.127-.28-.076-.076-.228-.095-.298-.019a.203.203 0 0 0-.051.115c-.051.196-.108.393-.159.596-.082-.165-.171-.343-.33-.451-.165-.107-.42-.12-.54.026-.089.108-.076.26-.038.393.101.362.33.686.546 1.009.343.527.661 1.079.8 1.682.159.686.007 1.295-.311 1.923a8.027 8.027 0 0 0 .947-4.493c-.026-.241-.064-.495-.204-.705Z",
    fill: "#EE704A"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M200.142 205.997c.101-.057.235-.172.387-.324-.038.019-.07.045-.108.064-.781.431-1.626.761-2.496 1.009-.985.279-2.001.457-3.031.571-2.414.266-4.866.197-7.286.419 1.467.031 2.928.285 4.294.761.451.153.934.368 1.106.781.101.247.07.533-.038.78-.337.768-1.271 1.162-2.154 1.371-.648.152-1.309.248-1.969.305 4.065.228 8.747-.153 10.647-.958.705-.299 1.461-.775 1.518-1.479.051-.622-.47-1.136-.756-1.701-.305-.635-.286-1.13-.114-1.599Z",
    fill: "#F45B3D"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M190.81 209.1c-.394-.088-.807-.095-1.214-.139-1.118-.108-2.185-.463-3.258-.755-.858-.235-2.287-.743-3.126-.248-.26.152-.438.425-.413.705.045.488.616.767 1.118.945 2.039.717 4.231 1.212 6.404.971.495-.057 1.01-.159 1.397-.45.077-.058.146-.121.159-.21.013-.082-.025-.165-.076-.228-.21-.311-.597-.502-.991-.591Z",
    fill: "#FF7145"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M186.42 177.889c-1.175-.171-2.693.032-3.684.635a8.503 8.503 0 0 0-2.44 2.24c-1.023 1.409-1.531 3.072-1.779 4.741-.254 1.713-.235 3.522.591 5.077.388.729 1.042 1.434 1.931 1.535.941.108 1.824-.52 2.275-1.275.444-.762.559-1.637.737-2.482a16.225 16.225 0 0 1 2.814-6.225c.4-.54.832-1.066 1.073-1.682.242-.609.255-1.339-.165-1.866-.311-.393-.826-.622-1.353-.698Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M204.481 181.094a25.69 25.69 0 0 1 .775 3.636 27.01 27.01 0 0 1-.019 7.4 27.576 27.576 0 0 1-.915 4.157c-.286.946-.616 1.878-1.061 2.767-2.274 4.569-7.668 7.723-13.188 7.666.965.356 2.052.222 3.081.076 1.461-.209 2.928-.444 4.288-.958 3.316-1.244 5.685-4.011 7.128-6.993 3.227-6.677 2.306-14.622-1.258-21.159.54 1.028.851 2.316 1.169 3.408Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M186.319 162.036c-1.036-.216-.413 2.355-.375 2.901.089 1.326.114 2.659-.013 3.985-.14 1.504-.464 2.995-1.073 4.404-.14.324-.286.724-.045.99.241.267.737.203 1.01-.038.267-.241.369-.596.438-.933.274-1.231.407-2.487.54-3.744.147-1.396.299-2.799.305-4.208.007-.698.28-3.135-.787-3.357Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "m178.53 155.975.089.026c0-.038-.051-.045-.089-.026Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M178.441 156.007c-.006-.019-.019-.044-.025-.063l-.21-.07c.083.044.159.089.235.133Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M178.352 155.779c.019.05.044.107.063.158l.115.038c.038-.019.089-.012.089.026l-.089-.026c-.026.013-.045.032-.038.057.012.07.095.102.165.121 2.49.692 5.006 1.383 7.61 1.491.674.026 1.379.013 1.97-.279-1.563-.469-3.266-.184-4.873-.52-1.671-.343-3.291-.927-5.012-1.066Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M181.707 180.447c-.617.717-1.042 1.561-1.36 2.424-.254.692-.438 1.434-.273 2.151.089.394.381.825.819.819.312-.006.559-.229.731-.463.457-.629.603-1.397.889-2.101.331-.812.858-1.542 1.423-2.234.369-.451 1.531-1.377 1.245-2.018-.514-1.18-3.119 1.009-3.474 1.422Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M322.643 228.782c.402 0 .697.381.595.768-.576 2.217-1.876 8.653-1.876 11.575 0 3.561.735 24.679 2.386 27.528 1.651 2.85 9.361 12.409 9.729 18.579.254 4.289-.907 9.702-1.64 12.608a2.738 2.738 0 0 1-2.656 2.07h-19.762a2.738 2.738 0 0 1-2.656-2.07c-.733-2.906-1.896-8.319-1.64-12.608.368-6.172 8.075-15.732 9.729-18.579 1.651-2.849 2.386-23.967 2.386-27.528 0-2.922-1.3-9.358-1.876-11.575a.613.613 0 0 1 .595-.768h6.686Z",
    fill: "#03009D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M322.621 228.791c.399 0 .692.381.589.768-.571 2.217-1.862 8.644-1.862 11.566 0 3.561.728 24.679 2.368 27.528 1.64 2.85 9.294 12.409 9.656 18.579.254 4.289-.9 9.684-1.628 12.59a2.721 2.721 0 0 1-2.636 2.07h-19.616a2.72 2.72 0 0 1-2.636-2.07c-.728-2.906-1.883-8.301-1.629-12.59.366-6.172 8.017-15.732 9.657-18.579 1.64-2.847 2.365-23.967 2.365-27.528 0-2.922-1.29-9.347-1.862-11.566a.612.612 0 0 1 .59-.768h6.644Z",
    fill: "#03019E"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M322.596 228.8c.396 0 .687.381.587.769-.569 2.216-1.849 8.634-1.849 11.556 0 3.561.724 24.679 2.353 27.528 1.628 2.85 9.223 12.409 9.585 18.579.252 4.289-.893 9.666-1.617 12.57a2.707 2.707 0 0 1-2.617 2.07h-19.472a2.706 2.706 0 0 1-2.617-2.07c-.724-2.906-1.869-8.283-1.617-12.57.36-6.172 7.957-15.731 9.585-18.579 1.629-2.847 2.348-23.967 2.348-27.528 0-2.922-1.282-9.337-1.849-11.556a.613.613 0 0 1 .588-.769h6.592Z",
    fill: "#04029F"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M322.571 228.809c.394 0 .68.381.583.769-.565 2.217-1.835 8.625-1.835 11.547 0 3.561.719 24.679 2.334 27.528 1.615 2.85 9.155 12.409 9.515 18.579.25 4.289-.887 9.646-1.603 12.552-.3 1.217-1.371 2.07-2.598 2.07h-19.328c-1.227 0-2.298-.853-2.597-2.07-.717-2.906-1.853-8.265-1.604-12.552.359-6.172 7.898-15.731 9.516-18.579 1.617-2.847 2.327-23.967 2.327-27.528 0-2.922-1.27-9.328-1.835-11.547a.61.61 0 0 1 .583-.769h6.542Z",
    fill: "#0403A0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M322.546 228.818c.39 0 .676.381.579.769-.561 2.217-1.822 8.616-1.822 11.538 0 3.561.712 24.679 2.316 27.528 1.604 2.85 9.087 12.409 9.443 18.579.247 4.289-.88 9.628-1.592 12.534-.298 1.217-1.361 2.069-2.579 2.069h-19.183c-1.219 0-2.28-.852-2.58-2.069-.712-2.906-1.839-8.247-1.592-12.534.356-6.172 7.839-15.731 9.443-18.579 1.604-2.847 2.316-23.967 2.316-27.528 0-2.922-1.261-9.319-1.821-11.538-.098-.39.186-.769.578-.769h6.494Z",
    fill: "#0503A1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M322.521 228.827c.388 0 .671.381.574.769-.556 2.217-1.808 8.607-1.808 11.529 0 3.561.708 24.679 2.298 27.528 1.592 2.85 9.019 12.409 9.373 18.579.245 4.289-.874 9.61-1.581 12.516-.295 1.217-1.35 2.069-2.559 2.069H309.78c-1.209 0-2.264-.852-2.559-2.069-.707-2.906-1.826-8.227-1.581-12.516.354-6.172 7.781-15.732 9.373-18.579 1.592-2.847 2.298-23.967 2.298-27.528 0-2.922-1.252-9.31-1.808-11.529-.098-.39.186-.769.574-.769h6.444Z",
    fill: "#0504A2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M322.498 228.836c.386 0 .667.381.57.769-.552 2.217-1.795 8.598-1.795 11.518 0 3.561.701 24.679 2.282 27.528 1.581 2.85 8.951 12.409 9.3 18.579.243 4.289-.866 9.591-1.569 12.497-.293 1.218-1.341 2.07-2.541 2.07H309.85c-1.2 0-2.246-.852-2.54-2.07-.701-2.906-1.813-8.208-1.57-12.497.352-6.172 7.721-15.732 9.3-18.579 1.579-2.847 2.286-23.965 2.286-27.526 0-2.922-1.243-9.301-1.794-11.518-.097-.39.184-.768.57-.768h6.396v-.003Z",
    fill: "#0605A3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M322.473 228.845c.382 0 .661.381.565.769-.546 2.217-1.78 8.589-1.78 11.508 0 3.562.696 24.68 2.263 27.529 1.568 2.849 8.883 12.409 9.23 18.579.243 4.289-.862 9.573-1.556 12.479-.29 1.217-1.329 2.07-2.52 2.07h-18.75c-1.191 0-2.23-.853-2.52-2.07-.696-2.906-1.799-8.19-1.556-12.479.349-6.173 7.662-15.732 9.23-18.579 1.567-2.847 2.264-23.967 2.264-27.529 0-2.922-1.234-9.291-1.781-11.508-.095-.39.184-.769.565-.769h6.346Z",
    fill: "#0606A4"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M322.448 228.857c.379 0 .656.381.561.768-.543 2.217-1.767 8.58-1.767 11.5 0 3.561.691 24.679 2.245 27.528 1.556 2.85 8.812 12.409 9.16 18.579.24 4.289-.856 9.553-1.545 12.459-.288 1.217-1.318 2.07-2.502 2.07h-18.605c-1.181 0-2.211-.853-2.502-2.07-.689-2.906-1.785-8.172-1.544-12.459.344-6.172 7.603-15.731 9.159-18.579 1.556-2.849 2.246-23.967 2.246-27.528 0-2.922-1.223-9.283-1.767-11.5-.096-.39.181-.768.56-.768h6.301Z",
    fill: "#0707A5"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M322.423 228.866c.377 0 .651.381.556.768-.54 2.217-1.753 8.571-1.753 11.491 0 3.561.685 24.679 2.229 27.528 1.543 2.85 8.745 12.409 9.087 18.579.238 4.289-.848 9.535-1.533 12.441-.286 1.217-1.309 2.069-2.482 2.069h-18.459c-1.173 0-2.196-.852-2.482-2.069-.685-2.906-1.771-8.154-1.533-12.441.342-6.172 7.544-15.731 9.087-18.579 1.542-2.847 2.229-23.967 2.229-27.528 0-2.922-1.213-9.274-1.753-11.491-.095-.39.179-.768.556-.768h6.251Z",
    fill: "#0708A6"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M322.398 228.875c.372 0 .647.381.552.768-.536 2.217-1.74 8.562-1.74 11.482 0 3.561.68 24.679 2.211 27.529 1.531 2.849 8.677 12.408 9.017 18.579.236 4.288-.842 9.516-1.52 12.422-.283 1.217-1.297 2.07-2.461 2.07H310.14c-1.163 0-2.177-.853-2.461-2.07-.68-2.906-1.758-8.136-1.519-12.422.34-6.173 7.485-15.732 9.016-18.579 1.531-2.848 2.212-23.968 2.212-27.529 0-2.922-1.205-9.265-1.74-11.482-.093-.389.179-.768.551-.768h6.199Z",
    fill: "#0809A7"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M322.376 228.884c.369 0 .639.381.546.768-.53 2.217-1.726 8.551-1.726 11.473 0 3.561.676 24.679 2.194 27.528 1.519 2.85 8.608 12.409 8.946 18.579.233 4.289-.835 9.498-1.509 12.405-.281 1.217-1.288 2.069-2.443 2.069h-18.171c-1.154 0-2.159-.852-2.443-2.069-.674-2.907-1.744-8.116-1.508-12.405.338-6.172 7.426-15.732 8.946-18.579 1.52-2.847 2.193-23.967 2.193-27.528 0-2.922-1.195-9.256-1.726-11.473-.093-.39.177-.768.547-.768h6.154Z",
    fill: "#0809A8"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M322.351 228.893c.367 0 .635.381.542.769-.526 2.216-1.713 8.541-1.713 11.463 0 3.561.669 24.679 2.178 27.529 1.506 2.849 8.54 12.408 8.873 18.579.234 4.288-.827 9.479-1.497 12.386-.279 1.217-1.277 2.069-2.422 2.069h-18.026c-1.146 0-2.144-.852-2.423-2.069-.669-2.907-1.728-8.098-1.497-12.386.336-6.173 7.367-15.732 8.874-18.579 1.506-2.85 2.177-23.968 2.177-27.529 0-2.922-1.186-9.244-1.712-11.463-.093-.39.174-.769.542-.769h6.104Z",
    fill: "#090AA9"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M322.326 228.902c.365 0 .63.381.537.769-.521 2.217-1.699 8.532-1.699 11.454 0 3.561.665 24.679 2.16 27.528 1.495 2.85 8.47 12.409 8.803 18.58.231 4.288-.821 9.461-1.486 12.367-.276 1.218-1.268 2.07-2.404 2.07h-17.883c-1.137 0-2.126-.852-2.405-2.07-.664-2.906-1.715-8.079-1.486-12.367.332-6.173 7.309-15.732 8.804-18.58 1.495-2.849 2.159-23.967 2.159-27.528 0-2.922-1.177-9.235-1.699-11.454-.091-.39.175-.769.538-.769h6.061Z",
    fill: "#090BAA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M322.301 228.911c.361 0 .626.381.535.769-.517 2.217-1.685 8.523-1.685 11.445 0 3.561.66 24.679 2.141 27.528 1.481 2.85 8.402 12.409 8.733 18.579.229 4.289-.814 9.442-1.472 12.348-.275 1.217-1.257 2.07-2.384 2.07h-17.738c-1.127 0-2.11-.853-2.384-2.07-.658-2.906-1.701-8.061-1.472-12.348.329-6.172 7.249-15.731 8.73-18.579 1.482-2.847 2.142-23.967 2.142-27.528 0-2.922-1.166-9.226-1.686-11.445-.09-.39.173-.769.536-.769h6.004Z",
    fill: "#0A0CAB"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M322.278 228.92c.359 0 .619.381.531.769-.513 2.217-1.672 8.514-1.672 11.436 0 3.561.653 24.679 2.126 27.528 1.472 2.85 8.333 12.409 8.66 18.579.227 4.289-.808 9.424-1.461 12.33-.274 1.217-1.247 2.069-2.366 2.069h-17.593c-1.118 0-2.091-.852-2.365-2.069-.654-2.906-1.688-8.043-1.461-12.33.326-6.172 7.19-15.731 8.66-18.579 1.47-2.847 2.126-23.967 2.126-27.528 0-2.922-1.157-9.217-1.672-11.436-.091-.39.172-.769.531-.769h5.956Z",
    fill: "#0A0DAC"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M322.254 228.929c.356 0 .614.381.526.769-.511 2.217-1.658 8.505-1.658 11.427 0 3.561.648 24.679 2.107 27.529 1.458 2.849 8.266 12.408 8.59 18.579.224 4.289-.801 9.405-1.45 12.311-.272 1.217-1.236 2.07-2.345 2.07h-17.448c-1.109 0-2.073-.853-2.345-2.07-.649-2.906-1.674-8.022-1.45-12.311.325-6.173 7.132-15.732 8.59-18.579 1.459-2.85 2.108-23.968 2.108-27.529 0-2.922-1.148-9.208-1.658-11.427-.089-.39.17-.769.526-.769h5.907Z",
    fill: "#0B0EAD"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M322.228 228.938c.352 0 .611.381.522.769-.506 2.217-1.644 8.496-1.644 11.416 0 3.561.642 24.679 2.089 27.528s8.197 12.409 8.517 18.579c.222 4.289-.794 9.387-1.436 12.293-.27 1.218-1.227 2.07-2.325 2.07h-17.305c-1.1 0-2.057-.852-2.325-2.07-.641-2.906-1.66-8.004-1.435-12.293.322-6.173 7.072-15.732 8.517-18.579 1.447-2.849 2.089-23.967 2.089-27.528 0-2.922-1.138-9.199-1.644-11.416-.089-.39.168-.769.521-.769h5.859Z",
    fill: "#0B0FAE"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M322.203 228.948c.35 0 .606.38.518.768-.502 2.217-1.629 8.487-1.629 11.407 0 3.561.637 24.679 2.071 27.528 1.434 2.85 8.13 12.409 8.447 18.579.222 4.289-.787 9.369-1.424 12.275-.268 1.218-1.216 2.07-2.307 2.07h-17.16c-1.091 0-2.039-.852-2.307-2.07-.637-2.906-1.647-7.986-1.424-12.275.32-6.172 7.013-15.732 8.447-18.579 1.433-2.847 2.071-23.967 2.071-27.528 0-2.922-1.13-9.19-1.629-11.407-.088-.39.168-.768.517-.768h5.809Z",
    fill: "#0C0FAF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M322.179 228.959c.347 0 .598.381.512.768-.497 2.217-1.615 8.478-1.615 11.398 0 3.561.633 24.679 2.055 27.528 1.422 2.85 8.059 12.409 8.377 18.579.22 4.289-.78 9.351-1.413 12.255-.266 1.217-1.207 2.07-2.287 2.07h-17.014c-1.082 0-2.023-.853-2.287-2.07-.63-2.906-1.633-7.968-1.413-12.255.316-6.172 6.955-15.731 8.377-18.579 1.422-2.847 2.055-23.967 2.055-27.528 0-2.922-1.118-9.181-1.615-11.398-.086-.39.166-.768.513-.768h5.755Z",
    fill: "#0C10B0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M322.156 228.968c.342 0 .594.381.508.768-.492 2.217-1.602 8.469-1.602 11.389 0 3.561.626 24.679 2.037 27.529 1.411 2.849 7.991 12.408 8.305 18.579.217 4.289-.776 9.33-1.402 12.236-.263 1.217-1.196 2.07-2.269 2.07h-16.869c-1.071 0-2.005-.853-2.268-2.07-.626-2.906-1.62-7.95-1.402-12.236.313-6.173 6.896-15.732 8.304-18.579 1.411-2.85 2.037-23.968 2.037-27.529 0-2.922-1.109-9.172-1.601-11.389-.086-.389.165-.768.508-.768h5.714Z",
    fill: "#0D11B1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M322.131 228.977c.34 0 .59.381.503.768-.487 2.217-1.587 8.46-1.587 11.38 0 3.561.621 24.679 2.018 27.528 1.398 2.85 7.924 12.409 8.234 18.579.216 4.289-.769 9.313-1.388 12.219-.261 1.217-1.186 2.069-2.248 2.069h-16.726c-1.062 0-1.99-.852-2.248-2.069-.622-2.906-1.604-7.932-1.388-12.219.31-6.172 6.836-15.731 8.234-18.579 1.397-2.847 2.018-23.967 2.018-27.528 0-2.922-1.1-9.163-1.587-11.38-.087-.39.163-.768.503-.768h5.662Z",
    fill: "#0D12B2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M322.106 228.986c.338 0 .585.381.499.768-.484 2.217-1.575 8.449-1.575 11.371 0 3.561.617 24.679 2.003 27.528 1.386 2.85 7.855 12.409 8.164 18.579.213 4.289-.762 9.294-1.377 12.201-.258 1.217-1.175 2.069-2.23 2.069h-16.581c-1.052 0-1.971-.852-2.23-2.069-.614-2.907-1.59-7.912-1.377-12.201.309-6.172 6.776-15.732 8.164-18.579 1.388-2.847 2.003-23.967 2.003-27.528 0-2.922-1.091-9.154-1.574-11.371-.084-.39.161-.768.499-.768h5.612Z",
    fill: "#0E13B3"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M322.081 228.995c.335 0 .578.381.494.769-.481 2.217-1.56 8.439-1.56 11.361 0 3.561.61 24.679 1.984 27.529 1.375 2.849 7.787 12.408 8.091 18.579.214 4.288-.755 9.276-1.365 12.182-.256 1.217-1.166 2.069-2.209 2.069H311.08c-1.044 0-1.954-.852-2.21-2.069-.61-2.906-1.576-7.894-1.365-12.182.306-6.173 6.716-15.732 8.091-18.579 1.374-2.848 1.984-23.968 1.984-27.529 0-2.922-1.082-9.142-1.56-11.361-.084-.39.161-.769.494-.769h5.567Z",
    fill: "#0E14B4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M322.056 229.004c.331 0 .574.381.49.769-.477 2.217-1.547 8.43-1.547 11.352 0 3.561.605 24.679 1.966 27.529 1.361 2.849 7.717 12.408 8.021 18.579.211 4.288-.748 9.257-1.352 12.163-.254 1.218-1.154 2.07-2.189 2.07h-16.293c-1.034 0-1.937-.852-2.189-2.07-.606-2.906-1.563-7.875-1.352-12.163.302-6.173 6.658-15.732 8.021-18.579 1.363-2.848 1.967-23.968 1.967-27.529 0-2.922-1.071-9.133-1.547-11.352-.084-.39.158-.769.49-.769h5.514Z",
    fill: "#0F15B5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M322.033 229.013c.329 0 .569.381.486.769-.472 2.217-1.534 8.421-1.534 11.343 0 3.561.599 24.679 1.951 27.528 1.35 2.85 7.649 12.409 7.948 18.58.209 4.288-.742 9.239-1.341 12.143-.251 1.217-1.145 2.07-2.17 2.07h-16.148c-1.026 0-1.919-.853-2.171-2.07-.599-2.906-1.549-7.857-1.341-12.143.3-6.173 6.599-15.732 7.948-18.58 1.35-2.847 1.951-23.967 1.951-27.528 0-2.922-1.061-9.124-1.533-11.343-.082-.39.156-.769.485-.769h5.469Z",
    fill: "#0F15B6"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M322.008 229.022c.327 0 .565.381.481.769-.467 2.217-1.52 8.412-1.52 11.334 0 3.561.595 24.679 1.933 27.529 1.338 2.849 7.581 12.408 7.878 18.579.206 4.289-.735 9.219-1.329 12.125-.25 1.217-1.135 2.07-2.151 2.07h-16.003c-1.016 0-1.903-.853-2.15-2.07-.594-2.906-1.536-7.839-1.329-12.125.297-6.173 6.539-15.732 7.878-18.579 1.338-2.847 1.932-23.968 1.932-27.529 0-2.922-1.052-9.115-1.52-11.334-.081-.39.157-.769.481-.769h5.419Z",
    fill: "#1016B7"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M321.983 229.031c.323 0 .558.381.479.769-.463 2.217-1.506 8.403-1.506 11.325 0 3.561.59 24.679 1.914 27.528 1.325 2.85 7.513 12.409 7.808 18.579.204 4.289-.728 9.202-1.318 12.108-.247 1.217-1.125 2.069-2.132 2.069H311.37c-1.007 0-1.885-.852-2.132-2.069-.588-2.906-1.522-7.821-1.318-12.108.295-6.172 6.481-15.731 7.807-18.579 1.325-2.849 1.915-23.967 1.915-27.528 0-2.922-1.043-9.106-1.506-11.325-.082-.39.154-.769.478-.769h5.369Z",
    fill: "#1017B8"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M321.959 229.041c.319 0 .553.38.474.768-.459 2.217-1.493 8.394-1.493 11.316 0 3.561.583 24.679 1.899 27.529 1.313 2.849 7.444 12.408 7.735 18.579.201 4.289-.722 9.183-1.305 12.089-.245 1.217-1.113 2.069-2.111 2.069h-15.715c-.998 0-1.869-.852-2.112-2.069-.583-2.906-1.508-7.8-1.304-12.089.292-6.173 6.421-15.732 7.735-18.579 1.313-2.85 1.898-23.968 1.898-27.529 0-2.922-1.034-9.097-1.492-11.316-.082-.39.154-.768.474-.768h5.317Z",
    fill: "#1118B9"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M321.936 229.049c.317 0 .549.381.469.769-.453 2.217-1.479 8.385-1.479 11.305 0 3.561.579 24.679 1.881 27.528s7.374 12.409 7.664 18.579c.202 4.289-.714 9.165-1.292 12.071-.243 1.217-1.105 2.07-2.094 2.07h-15.57c-.989 0-1.851-.853-2.093-2.07-.579-2.906-1.495-7.782-1.293-12.071.29-6.172 6.362-15.732 7.664-18.579 1.302-2.849 1.881-23.967 1.881-27.528 0-2.922-1.023-9.088-1.479-11.305-.08-.39.152-.769.469-.769h5.272Z",
    fill: "#1119BA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M321.911 229.058c.315 0 .544.381.465.769-.452 2.217-1.465 8.376-1.465 11.295 0 3.562.573 24.68 1.862 27.529 1.288 2.849 7.306 12.409 7.594 18.579.2 4.289-.708 9.147-1.282 12.053-.24 1.217-1.093 2.07-2.073 2.07h-15.424c-.98 0-1.833-.853-2.073-2.07-.572-2.906-1.479-7.764-1.282-12.053.286-6.173 6.304-15.732 7.594-18.579 1.289-2.849 1.863-23.967 1.863-27.529 0-2.921-1.014-9.078-1.466-11.295-.079-.39.15-.769.465-.769h5.222Z",
    fill: "#121ABB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M321.886 229.07c.31 0 .537.38.46.768-.447 2.217-1.452 8.367-1.452 11.287 0 3.561.568 24.679 1.845 27.528 1.277 2.85 7.238 12.409 7.521 18.579.198 4.289-.701 9.127-1.268 12.033-.238 1.217-1.084 2.069-2.055 2.069h-15.281c-.971 0-1.817-.852-2.055-2.069-.567-2.906-1.466-7.746-1.268-12.033.283-6.172 6.244-15.732 7.521-18.579 1.277-2.849 1.844-23.967 1.844-27.528 0-2.922-1.004-9.07-1.451-11.287-.08-.39.149-.768.46-.768h5.179Z",
    fill: "#121BBC"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M321.861 229.079c.308 0 .533.381.456.768-.443 2.217-1.438 8.358-1.438 11.278 0 3.561.562 24.679 1.828 27.528 1.266 2.85 7.17 12.409 7.451 18.579.195 4.289-.694 9.109-1.256 12.015-.236 1.217-1.073 2.069-2.035 2.069h-15.136c-.962 0-1.799-.852-2.035-2.069-.563-2.906-1.452-7.728-1.257-12.015.282-6.172 6.186-15.731 7.452-18.579 1.265-2.849 1.828-23.967 1.828-27.528 0-2.922-.996-9.061-1.438-11.278-.077-.39.147-.768.456-.768h5.124Z",
    fill: "#131BBD"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M321.836 229.088c.306 0 .528.381.451.768-.438 2.217-1.424 8.349-1.424 11.269 0 3.561.558 24.679 1.81 27.528 1.252 2.85 7.102 12.409 7.381 18.579.193 4.289-.687 9.09-1.245 11.997-.234 1.217-1.064 2.069-2.015 2.069h-14.991c-.953 0-1.783-.852-2.014-2.069-.556-2.907-1.438-7.71-1.245-11.997.279-6.172 6.126-15.731 7.381-18.579 1.252-2.849 1.81-23.967 1.81-27.528 0-2.922-.987-9.052-1.425-11.269-.077-.39.145-.768.452-.768h5.074Z",
    fill: "#131CBE"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M321.813 229.097c.302 0 .524.381.447.768-.433 2.217-1.411 8.338-1.411 11.26 0 3.561.552 24.679 1.792 27.528 1.241 2.85 7.034 12.409 7.309 18.579.19 4.289-.683 9.072-1.232 11.978-.231 1.218-1.052 2.07-1.996 2.07h-14.846c-.944 0-1.765-.852-1.996-2.07-.551-2.906-1.425-7.689-1.232-11.978.277-6.172 6.068-15.732 7.309-18.579 1.24-2.847 1.792-23.967 1.792-27.528 0-2.922-.978-9.043-1.411-11.26-.077-.39.145-.768.447-.768h5.028Z",
    fill: "#131DBF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M321.788 229.106c.3 0 .517.381.443.768-.429 2.217-1.398 8.329-1.398 11.251 0 3.561.547 24.679 1.776 27.528 1.23 2.85 6.964 12.409 7.238 18.579.191 4.289-.675 9.054-1.22 11.96-.229 1.218-1.043 2.07-1.976 2.07h-14.703c-.934 0-1.749-.852-1.975-2.07-.547-2.906-1.411-7.671-1.221-11.96.272-6.172 6.009-15.732 7.238-18.579 1.23-2.847 1.776-23.967 1.776-27.528 0-2.922-.966-9.031-1.397-11.251-.075-.389.143-.768.443-.768h4.976Z",
    fill: "#141EC0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M321.763 229.115c.297 0 .513.381.438.768-.424 2.217-1.384 8.32-1.384 11.242 0 3.561.54 24.679 1.758 27.528 1.218 2.85 6.896 12.409 7.166 18.579.188 4.289-.669 9.036-1.209 11.94-.227 1.217-1.032 2.069-1.958 2.069h-14.558c-.925 0-1.73-.852-1.957-2.069-.54-2.906-1.398-7.653-1.209-11.94.27-6.172 5.95-15.732 7.165-18.579 1.218-2.849 1.758-23.967 1.758-27.528 0-2.922-.957-9.022-1.383-11.242-.075-.389.142-.768.437-.768h4.936Z",
    fill: "#141FC1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M321.738 229.124c.293 0 .508.381.434.768-.422 2.217-1.368 8.311-1.368 11.233 0 3.561.535 24.679 1.74 27.528 1.204 2.85 6.827 12.409 7.095 18.579.186 4.289-.663 9.016-1.198 11.922-.224 1.217-1.021 2.069-1.937 2.069h-14.413c-.916 0-1.712-.852-1.937-2.069-.535-2.906-1.384-7.635-1.198-11.922.268-6.172 5.891-15.732 7.096-18.579 1.204-2.849 1.739-23.967 1.739-27.528 0-2.922-.948-9.013-1.367-11.233-.075-.389.14-.768.433-.768h4.881Z",
    fill: "#1520C2"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M321.713 229.133c.291 0 .504.381.429.769-.417 2.217-1.354 8.301-1.354 11.223 0 3.561.531 24.679 1.724 27.528 1.193 2.85 6.759 12.409 7.025 18.579.183 4.289-.656 8.998-1.184 11.904-.223 1.217-1.012 2.069-1.919 2.069h-14.27c-.908 0-1.697-.852-1.919-2.069-.529-2.906-1.37-7.617-1.184-11.904.265-6.172 5.831-15.731 7.025-18.579 1.193-2.847 1.723-23.967 1.723-27.528 0-2.922-.939-9.004-1.354-11.223-.072-.39.139-.769.429-.769h4.829Z",
    fill: "#1521C3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M321.691 229.142c.288 0 .496.381.426.769-.413 2.217-1.34 8.292-1.34 11.214 0 3.561.524 24.679 1.705 27.528 1.182 2.85 6.692 12.409 6.953 18.579.181 4.289-.649 8.979-1.173 11.886-.22 1.217-1 2.069-1.899 2.069h-14.124c-.899 0-1.679-.852-1.899-2.069-.524-2.907-1.354-7.597-1.173-11.886.264-6.172 5.773-15.731 6.953-18.579 1.179-2.847 1.706-23.967 1.706-27.528 0-2.922-.93-8.995-1.341-11.214-.073-.39.138-.769.426-.769h4.78Z",
    fill: "#1621C4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M321.666 229.151c.285 0 .492.381.422.769-.409 2.217-1.327 8.283-1.327 11.203 0 3.561.519 24.679 1.687 27.528 1.168 2.85 6.621 12.409 6.882 18.579.182 4.289-.642 8.961-1.161 11.867-.218 1.217-.991 2.07-1.878 2.07h-13.98c-.889 0-1.662-.853-1.878-2.07-.519-2.906-1.341-7.578-1.161-11.867.258-6.172 5.714-15.732 6.882-18.579 1.168-2.849 1.687-23.967 1.687-27.528 0-2.922-.918-8.986-1.327-11.203-.072-.39.136-.769.422-.769h4.73Z",
    fill: "#1622C5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M321.641 229.16c.281 0 .488.381.417.769-.404 2.217-1.313 8.274-1.313 11.194 0 3.561.515 24.679 1.669 27.528 1.157 2.849 6.553 12.409 6.812 18.579.179 4.289-.635 8.943-1.148 11.849-.215 1.217-.98 2.07-1.86 2.07h-13.834c-.878 0-1.645-.853-1.86-2.07-.513-2.906-1.327-7.56-1.148-11.849.256-6.172 5.655-15.732 6.812-18.579 1.157-2.849 1.669-23.967 1.669-27.528 0-2.922-.909-8.977-1.313-11.194-.07-.39.134-.769.417-.769h4.68Z",
    fill: "#1723C6"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M321.616 229.172c.279 0 .483.38.413.768-.399 2.217-1.3 8.265-1.3 11.185 0 3.561.508 24.679 1.654 27.528 1.145 2.85 6.485 12.409 6.739 18.579.177 4.289-.629 8.925-1.137 11.829-.213 1.217-.97 2.069-1.839 2.069h-13.692c-.868 0-1.628-.852-1.839-2.069-.508-2.906-1.314-7.542-1.137-11.829.254-6.172 5.596-15.732 6.739-18.579 1.144-2.847 1.654-23.967 1.654-27.528 0-2.922-.901-8.968-1.3-11.185-.07-.39.134-.768.413-.768h4.632Z",
    fill: "#1724C7"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M321.593 229.181c.277 0 .477.38.409.768-.395 2.217-1.287 8.256-1.287 11.176 0 3.561.504 24.679 1.636 27.528 1.132 2.85 6.417 12.409 6.669 18.579.174 4.289-.622 8.904-1.125 11.811-.211 1.217-.96 2.069-1.822 2.069h-13.546c-.86 0-1.611-.852-1.822-2.069-.503-2.907-1.299-7.524-1.125-11.811.252-6.172 5.537-15.732 6.669-18.579 1.132-2.847 1.636-23.967 1.636-27.528 0-2.922-.892-8.959-1.287-11.176-.07-.39.132-.768.409-.768h4.586Z",
    fill: "#1825C8"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M321.568 229.19c.273 0 .472.381.404.768-.392 2.217-1.272 8.247-1.272 11.167 0 3.561.499 24.679 1.617 27.528 1.12 2.85 6.349 12.409 6.596 18.579.173 4.289-.615 8.886-1.114 11.793-.208 1.217-.95 2.069-1.801 2.069h-13.401c-.85 0-1.592-.852-1.801-2.069-.497-2.907-1.286-7.506-1.114-11.793.25-6.172 5.478-15.731 6.597-18.579 1.118-2.847 1.617-23.967 1.617-27.528 0-2.922-.882-8.95-1.273-11.167-.068-.389.132-.768.404-.768h4.541Z",
    fill: "#1826C9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M321.543 229.199c.27 0 .468.381.4.768-.388 2.217-1.259 8.236-1.259 11.158 0 3.561.492 24.679 1.601 27.528 1.109 2.85 6.281 12.409 6.526 18.579.17 4.289-.608 8.868-1.1 11.774-.207 1.217-.939 2.07-1.783 2.07H312.67c-.842 0-1.577-.853-1.783-2.07-.492-2.906-1.273-7.485-1.1-11.774.247-6.172 5.419-15.732 6.526-18.579 1.109-2.849 1.601-23.967 1.601-27.528 0-2.922-.871-8.941-1.259-11.158-.068-.39.129-.768.399-.768h4.489Z",
    fill: "#1927CA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M321.518 229.208c.268 0 .463.381.395.768-.383 2.217-1.245 8.227-1.245 11.149 0 3.561.487 24.679 1.583 27.528 1.095 2.85 6.21 12.409 6.455 18.579.171 4.289-.601 8.85-1.088 11.756-.205 1.218-.93 2.07-1.763 2.07h-13.113c-.832 0-1.558-.852-1.762-2.07-.488-2.906-1.259-7.467-1.089-11.756.243-6.172 5.36-15.731 6.455-18.579 1.096-2.849 1.584-23.967 1.584-27.528 0-2.922-.862-8.929-1.246-11.149-.068-.389.127-.768.395-.768h4.439Z",
    fill: "#1927CB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M321.493 229.217c.263 0 .456.381.391.769-.379 2.216-1.232 8.217-1.232 11.139 0 3.561.481 24.679 1.565 27.528 1.084 2.85 6.143 12.409 6.383 18.579.168 4.289-.597 8.832-1.077 11.738-.202 1.217-.919 2.07-1.743 2.07h-12.967c-.824 0-1.543-.853-1.742-2.07-.481-2.906-1.244-7.449-1.078-11.738.241-6.172 5.299-15.732 6.383-18.579 1.084-2.849 1.565-23.967 1.565-27.528 0-2.922-.853-8.92-1.231-11.139-.066-.39.127-.769.39-.769h4.393Z",
    fill: "#1A28CC"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M321.471 229.226c.26 0 .451.381.385.769-.374 2.217-1.218 8.208-1.218 11.13 0 3.561.476 24.679 1.549 27.528 1.073 2.85 6.075 12.409 6.313 18.579.166 4.289-.59 8.812-1.064 11.718-.199 1.217-.909 2.069-1.724 2.069H312.89c-.815 0-1.525-.852-1.724-2.069-.477-2.906-1.23-7.431-1.064-11.718.238-6.172 5.24-15.732 6.313-18.579 1.072-2.849 1.549-23.967 1.549-27.528 0-2.922-.844-8.911-1.218-11.13-.066-.39.124-.769.385-.769h4.34Z",
    fill: "#1A29CD"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M321.446 229.235c.258 0 .447.381.381.769-.37 2.217-1.205 8.199-1.205 11.121 0 3.561.472 24.679 1.531 27.528 1.06 2.85 6.007 12.409 6.243 18.58.163 4.288-.583 8.793-1.053 11.699-.197 1.217-.898 2.069-1.703 2.069h-12.68c-.805 0-1.508-.852-1.704-2.069-.469-2.906-1.215-7.413-1.052-11.699.236-6.173 5.181-15.732 6.242-18.58 1.06-2.849 1.531-23.967 1.531-27.528 0-2.922-.834-8.902-1.204-11.121-.066-.39.125-.769.381-.769h4.292Z",
    fill: "#1B2ACE"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M321.421 229.244c.256 0 .442.381.376.769-.365 2.217-1.191 8.19-1.191 11.112 0 3.561.465 24.679 1.513 27.528 1.048 2.85 5.939 12.409 6.17 18.579.161 4.289-.576 8.775-1.041 11.681-.195 1.218-.889 2.07-1.685 2.07h-12.535c-.796 0-1.49-.852-1.685-2.07-.465-2.906-1.203-7.394-1.041-11.681.233-6.172 5.121-15.732 6.169-18.579 1.048-2.849 1.513-23.967 1.513-27.528 0-2.922-.823-8.893-1.191-11.112-.063-.39.123-.769.377-.769h4.251Z",
    fill: "#1B2BCE"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M321.396 229.253c.252 0 .438.381.374.769-.36 2.217-1.177 8.181-1.177 11.103 0 3.561.461 24.679 1.497 27.528 1.037 2.85 5.868 12.409 6.1 18.579.158 4.289-.57 8.757-1.03 11.663-.193 1.217-.878 2.07-1.665 2.07h-12.39c-.787 0-1.472-.853-1.665-2.07-.46-2.906-1.188-7.374-1.029-11.663.229-6.172 5.063-15.732 6.099-18.579 1.037-2.847 1.497-23.967 1.497-27.528 0-2.922-.814-8.884-1.177-11.103-.064-.39.12-.769.374-.769h4.192Z",
    fill: "#1C2CCF"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M321.371 229.262c.249 0 .431.381.37.769-.359 2.217-1.164 8.172-1.164 11.092 0 3.561.456 24.679 1.479 27.528 1.023 2.85 5.8 12.409 6.029 18.579.159 4.289-.563 8.739-1.016 11.645-.191 1.217-.869 2.07-1.647 2.07h-12.244c-.778 0-1.457-.853-1.647-2.07-.454-2.906-1.175-7.356-1.016-11.645.227-6.172 5.004-15.732 6.029-18.579 1.025-2.847 1.479-23.967 1.479-27.528 0-2.922-.805-8.875-1.164-11.092-.063-.39.12-.769.37-.769h4.142Z",
    fill: "#1C2DD0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M321.348 229.274c.247 0 .427.381.365.768-.353 2.217-1.15 8.163-1.15 11.083 0 3.561.45 24.679 1.461 27.528 1.012 2.85 5.732 12.409 5.957 18.579.156 4.289-.556 8.721-1.005 11.627-.188 1.217-.858 2.07-1.626 2.07h-12.102c-.769 0-1.438-.853-1.626-2.07-.449-2.906-1.162-7.338-1.005-11.627.224-6.172 4.945-15.732 5.956-18.579 1.012-2.849 1.461-23.967 1.461-27.528 0-2.922-.796-8.866-1.15-11.083-.061-.39.118-.768.365-.768h4.099Z",
    fill: "#1D2ED1"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M321.323 229.283c.243 0 .422.381.361.768-.349 2.217-1.136 8.154-1.136 11.074 0 3.561.444 24.679 1.442 27.528.998 2.85 5.664 12.409 5.887 18.579.154 4.289-.549 8.7-.994 11.607-.186 1.217-.848 2.069-1.608 2.069h-11.956c-.76 0-1.423-.852-1.609-2.069-.444-2.907-1.147-7.32-.993-11.607.222-6.172 4.886-15.732 5.886-18.579 1-2.847 1.443-23.967 1.443-27.528 0-2.922-.787-8.857-1.137-11.074-.061-.39.116-.768.361-.768h4.053Z",
    fill: "#1D2ED2"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M321.298 229.292c.241 0 .418.381.356.768-.344 2.217-1.122 8.145-1.122 11.065 0 3.561.437 24.679 1.426 27.528.989 2.85 5.596 12.409 5.814 18.58.152 4.288-.542 8.682-.98 11.588-.184 1.217-.837 2.069-1.588 2.069h-11.811c-.75 0-1.404-.852-1.587-2.069-.438-2.906-1.135-7.302-.98-11.588.22-6.173 4.827-15.732 5.813-18.58.987-2.847 1.427-23.967 1.427-27.528 0-2.922-.778-8.848-1.123-11.065-.061-.389.116-.768.356-.768h3.999Z",
    fill: "#1E2FD3"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M321.274 229.301c.238 0 .41.381.351.768-.34 2.217-1.109 8.134-1.109 11.056 0 3.561.433 24.679 1.409 27.528.975 2.85 5.527 12.409 5.743 18.579.15 4.289-.535 8.664-.969 11.57-.181 1.218-.828 2.07-1.567 2.07h-11.668c-.742 0-1.386-.852-1.568-2.07-.433-2.906-1.118-7.281-.968-11.57.218-6.172 4.768-15.731 5.743-18.579.976-2.847 1.409-23.967 1.409-27.528 0-2.922-.767-8.839-1.107-11.056-.059-.389.113-.768.351-.768h3.95Z",
    fill: "#1E30D4"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M321.251 229.31c.233 0 .406.381.347.768-.336 2.217-1.093 8.125-1.093 11.047 0 3.561.428 24.679 1.39 27.528.964 2.85 5.458 12.409 5.673 18.579.15 4.289-.528 8.646-.957 11.552-.179 1.217-.817 2.07-1.549 2.07h-11.523c-.733 0-1.37-.853-1.55-2.07-.428-2.906-1.104-7.263-.957-11.552.213-6.172 4.709-15.732 5.673-18.579.964-2.849 1.391-23.967 1.391-27.528 0-2.922-.758-8.83-1.094-11.047-.059-.39.114-.768.347-.768h3.902Z",
    fill: "#1F31D5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M321.226 229.319c.231 0 .401.381.342.769-.331 2.217-1.08 8.115-1.08 11.037 0 3.561.422 24.679 1.375 27.528.95 2.85 5.389 12.409 5.6 18.579.148 4.289-.521 8.628-.945 11.534-.177 1.217-.808 2.07-1.529 2.07h-11.378c-.724 0-1.352-.853-1.529-2.07-.422-2.906-1.091-7.245-.946-11.534.211-6.172 4.65-15.731 5.601-18.579.95-2.849 1.374-23.967 1.374-27.528 0-2.922-.748-8.818-1.079-11.037-.059-.39.111-.769.342-.769h3.852Z",
    fill: "#1F32D6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M321.201 229.328c.229 0 .397.381.338.769-.329 2.217-1.066 8.106-1.066 11.028 0 3.561.417 24.679 1.356 27.528.939 2.85 5.322 12.409 5.53 18.579.146 4.289-.515 8.61-.932 11.514-.175 1.217-.796 2.069-1.511 2.069h-11.232c-.715 0-1.336-.852-1.511-2.069-.417-2.906-1.077-7.227-.932-11.514.208-6.172 4.591-15.732 5.53-18.579.939-2.849 1.356-23.967 1.356-27.528 0-2.922-.739-8.809-1.066-11.028-.056-.39.109-.769.338-.769h3.802Z",
    fill: "#2033D7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M321.176 229.337c.226 0 .39.381.333.769-.324 2.217-1.052 8.097-1.052 11.019 0 3.561.412 24.679 1.338 27.528.928 2.85 5.253 12.409 5.46 18.579.143 4.289-.508 8.589-.921 11.496-.173 1.217-.787 2.069-1.491 2.069h-11.089c-.706 0-1.318-.852-1.49-2.069-.411-2.907-1.064-7.209-.921-11.496.206-6.172 4.532-15.732 5.459-18.579.928-2.849 1.339-23.967 1.339-27.528 0-2.922-.731-8.8-1.053-11.019-.057-.39.109-.769.334-.769h3.754Z",
    fill: "#2034D8"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M321.151 229.346c.222 0 .385.381.329.769-.32 2.217-1.039 8.088-1.039 11.01 0 3.561.406 24.679 1.322 27.528.914 2.85 5.186 12.409 5.388 18.579.14 4.289-.504 8.571-.91 11.477-.17 1.218-.776 2.07-1.472 2.07h-10.945c-.696 0-1.302-.852-1.472-2.07-.406-2.906-1.05-7.19-.909-11.477.204-6.172 4.473-15.732 5.387-18.579.914-2.849 1.322-23.967 1.322-27.528 0-2.922-.719-8.791-1.039-11.01-.056-.39.107-.769.329-.769h3.709Z",
    fill: "#2134D9"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M321.128 229.355c.22 0 .381.381.325.769-.316 2.217-1.026 8.079-1.026 11.001 0 3.561.402 24.679 1.305 27.528.902 2.85 5.115 12.409 5.317 18.579.138 4.289-.497 8.553-.896 11.459-.168 1.217-.767 2.07-1.452 2.07h-10.8c-.685 0-1.283-.853-1.451-2.07-.402-2.906-1.037-7.17-.896-11.459.199-6.172 4.414-15.732 5.317-18.579.902-2.849 1.304-23.967 1.304-27.528 0-2.922-.71-8.782-1.025-11.001-.055-.39.104-.769.324-.769h3.654Z",
    fill: "#2135DA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M321.103 229.365c.218 0 .377.38.32.768-.311 2.217-1.012 8.07-1.012 10.99 0 3.561.397 24.679 1.286 27.528.892 2.85 5.047 12.409 5.245 18.579.138 4.289-.49 8.535-.885 11.441-.166 1.217-.755 2.07-1.431 2.07h-10.657c-.676 0-1.265-.853-1.431-2.07-.395-2.906-1.023-7.152-.885-11.441.198-6.172 4.355-15.732 5.245-18.579.891-2.849 1.286-23.967 1.286-27.528 0-2.922-.701-8.773-1.012-10.99-.054-.39.104-.768.32-.768h3.611Z",
    fill: "#2236DB"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M321.078 229.374c.214 0 .37.38.318.768-.306 2.217-.998 8.061-.998 10.981 0 3.561.39 24.679 1.27 27.528.878 2.85 4.979 12.409 5.174 18.579.136 4.289-.483 8.517-.873 11.423-.163 1.217-.746 2.069-1.413 2.069h-10.512c-.666 0-1.249-.852-1.413-2.069-.39-2.906-1.009-7.134-.873-11.423.195-6.172 4.296-15.732 5.174-18.579.878-2.849 1.27-23.967 1.27-27.528 0-2.922-.692-8.764-.998-10.981-.054-.39.102-.768.318-.768h3.556Z",
    fill: "#2237DC"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M321.053 229.385c.211 0 .365.381.313.768-.301 2.217-.984 8.052-.984 10.972 0 3.561.385 24.679 1.252 27.528.866 2.85 4.911 12.409 5.104 18.579.133 4.289-.477 8.496-.86 11.403-.161 1.217-.735 2.069-1.393 2.069h-10.366c-.658 0-1.232-.852-1.393-2.069-.385-2.907-.993-7.116-.859-11.403.192-6.172 4.237-15.732 5.103-18.579.867-2.849 1.252-23.967 1.252-27.528 0-2.922-.682-8.755-.984-10.972-.052-.39.102-.768.313-.768h3.502Z",
    fill: "#2338DD"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M321.028 229.394c.209 0 .361.381.309.768-.3 2.217-.971 8.043-.971 10.963 0 3.561.379 24.679 1.234 27.528.855 2.85 4.843 12.409 5.031 18.579.132 4.289-.469 8.478-.848 11.384-.159 1.218-.724 2.07-1.375 2.07h-10.221c-.649 0-1.216-.852-1.374-2.07-.379-2.906-.98-7.097-.849-11.384.191-6.172 4.178-15.732 5.031-18.579.856-2.849 1.234-23.967 1.234-27.528 0-2.922-.671-8.746-.971-10.963-.052-.39.1-.768.309-.768h3.461Z",
    fill: "#2339DE"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M321.006 229.403c.204 0 .356.381.304.768-.295 2.217-.958 8.034-.958 10.954 0 3.561.375 24.679 1.216 27.528.842 2.85 4.773 12.409 4.961 18.579.129 4.289-.463 8.46-.837 11.366-.157 1.218-.715 2.07-1.354 2.07H314.26c-.64 0-1.198-.852-1.354-2.07-.375-2.906-.967-7.079-.837-11.366.188-6.172 4.119-15.732 4.96-18.579.842-2.849 1.216-23.967 1.216-27.528 0-2.922-.662-8.737-.957-10.954-.052-.39.097-.768.304-.768h3.414Z",
    fill: "#233ADF"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M320.981 229.412c.202 0 .349.381.299.768-.29 2.217-.943 8.023-.943 10.945 0 3.561.369 24.679 1.2 27.528.83 2.85 4.704 12.409 4.89 18.579.129 4.289-.456 8.442-.826 11.348-.154 1.217-.703 2.07-1.336 2.07h-9.933c-.63 0-1.181-.853-1.336-2.07-.369-2.906-.952-7.059-.825-11.348.183-6.172 4.06-15.732 4.89-18.579.83-2.849 1.2-23.967 1.2-27.528 0-2.922-.653-8.728-.943-10.945-.05-.39.097-.768.299-.768h3.364Z",
    fill: "#243AE0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M320.956 229.421c.199 0 .345.381.295.769-.286 2.217-.93 8.013-.93 10.935 0 3.561.363 24.679 1.181 27.528.819 2.85 4.637 12.409 4.818 18.579.127 4.289-.449 8.424-.812 11.33-.152 1.217-.694 2.07-1.315 2.07h-9.788c-.622 0-1.164-.853-1.316-2.07-.363-2.906-.939-7.041-.812-11.33.182-6.172 4.002-15.731 4.818-18.579.819-2.849 1.182-23.967 1.182-27.528 0-2.922-.644-8.716-.93-10.935-.05-.39.095-.769.295-.769h3.314Z",
    fill: "#243BE1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M320.931 229.43c.197 0 .34.381.29.769-.281 2.217-.916 8.004-.916 10.926 0 3.561.358 24.679 1.163 27.528.806 2.85 4.569 12.409 4.748 18.579.125 4.289-.442 8.406-.801 11.312-.149 1.217-.682 2.07-1.295 2.07h-9.645c-.612 0-1.145-.853-1.295-2.07-.358-2.906-.925-7.023-.801-11.312.18-6.172 3.943-15.731 4.748-18.579.805-2.849 1.164-23.967 1.164-27.528 0-2.922-.636-8.707-.917-10.926-.05-.39.093-.769.291-.769h3.266Z",
    fill: "#253CE2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M320.906 229.439c.193 0 .336.381.286.769-.277 2.217-.903 7.995-.903 10.917 0 3.561.354 24.679 1.148 27.528.794 2.85 4.5 12.409 4.677 18.579.122 4.289-.436 8.385-.789 11.292-.148 1.217-.674 2.069-1.278 2.069h-9.499c-.604 0-1.13-.852-1.277-2.069-.352-2.907-.912-7.005-.79-11.292.177-6.172 3.881-15.732 4.678-18.579.794-2.849 1.147-23.967 1.147-27.528 0-2.922-.623-8.698-.902-10.917-.048-.39.093-.769.285-.769h3.217Z",
    fill: "#253DE3"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M320.883 229.448c.191 0 .329.381.281.769-.272 2.217-.889 7.986-.889 10.908 0 3.561.347 24.679 1.13 27.528.782 2.85 4.432 12.409 4.605 18.579.12 4.289-.429 8.367-.776 11.273-.145 1.218-.663 2.07-1.257 2.07h-9.354c-.595 0-1.112-.852-1.257-2.07-.347-2.906-.898-6.986-.776-11.273.175-6.172 3.822-15.732 4.605-18.579.783-2.849 1.13-23.967 1.13-27.528 0-2.922-.615-8.689-.89-10.908-.047-.39.091-.769.282-.769h3.166Z",
    fill: "#263EE4"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M320.858 229.457c.188 0 .324.381.277.769-.27 2.217-.876 7.977-.876 10.899 0 3.561.343 24.679 1.112 27.528.769 2.85 4.362 12.409 4.534 18.579.118 4.289-.422 8.349-.764 11.255-.143 1.217-.654 2.07-1.239 2.07h-9.209c-.585 0-1.096-.853-1.239-2.07-.342-2.906-.884-6.966-.764-11.255.17-6.172 3.763-15.732 4.534-18.579.769-2.849 1.112-23.967 1.112-27.528 0-2.922-.606-8.68-.876-10.899-.047-.39.091-.769.277-.769h3.121Z",
    fill: "#263FE5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M320.833 229.467c.184 0 .32.38.272.768-.265 2.217-.862 7.968-.862 10.888 0 3.561.336 24.679 1.096 27.528.758 2.85 4.294 12.409 4.462 18.579.118 4.289-.418 8.331-.753 11.237-.141 1.217-.642 2.07-1.218 2.07h-9.067c-.576 0-1.077-.853-1.218-2.07-.336-2.906-.869-6.948-.753-11.237.168-6.172 3.704-15.732 4.462-18.579.757-2.849 1.095-23.967 1.095-27.528 0-2.922-.596-8.671-.862-10.888-.045-.39.089-.768.273-.768h3.073Z",
    fill: "#2740E6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M320.808 229.475c.182 0 .316.381.268.769-.261 2.217-.848 7.959-.848 10.878 0 3.562.331 24.68 1.077 27.529s4.226 12.409 4.392 18.579c.115 4.289-.411 8.312-.742 11.219-.139 1.217-.633 2.069-1.2 2.069h-8.921c-.567 0-1.062-.852-1.2-2.069-.331-2.907-.855-6.93-.742-11.219.166-6.173 3.645-15.732 4.391-18.579.747-2.849 1.078-23.967 1.078-27.529 0-2.922-.588-8.661-.848-10.878-.046-.39.086-.769.267-.769h3.028Z",
    fill: "#2740E7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M320.785 229.487c.18 0 .309.381.266.768-.256 2.217-.833 7.95-.833 10.87 0 3.561.327 24.679 1.06 27.528.732 2.85 4.158 12.409 4.321 18.579.113 4.289-.404 8.295-.728 11.199-.136 1.217-.622 2.069-1.18 2.069h-8.78c-.558 0-1.044-.852-1.18-2.069-.327-2.907-.841-6.912-.728-11.199.163-6.172 3.586-15.732 4.321-18.579.733-2.849 1.059-23.967 1.059-27.528 0-2.922-.576-8.653-.832-10.87-.045-.39.086-.768.265-.768h2.969Z",
    fill: "#2841E8"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M320.761 229.496c.177 0 .304.381.261.768-.252 2.217-.819 7.941-.819 10.861 0 3.561.32 24.679 1.043 27.528.722 2.85 4.09 12.409 4.249 18.579.111 4.289-.397 8.274-.717 11.18-.134 1.218-.613 2.07-1.161 2.07h-8.631c-.549 0-1.026-.852-1.162-2.07-.32-2.906-.828-6.893-.716-11.18.161-6.172 3.527-15.732 4.248-18.579.721-2.849 1.043-23.967 1.043-27.528 0-2.922-.567-8.644-.818-10.861-.046-.39.084-.768.26-.768h2.92Z",
    fill: "#2842E9"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M320.736 229.505c.172 0 .299.381.256.768-.247 2.217-.805 7.932-.805 10.852 0 3.561.315 24.679 1.025 27.528.71 2.85 4.02 12.409 4.178 18.579.109 4.289-.39 8.256-.705 11.162-.132 1.218-.601 2.07-1.141 2.07h-8.488c-.54 0-1.009-.852-1.141-2.07-.315-2.906-.814-6.875-.705-11.162.158-6.172 3.468-15.732 4.178-18.579.71-2.849 1.025-23.967 1.025-27.528 0-2.922-.558-8.635-.805-10.852-.043-.39.081-.768.256-.768h2.872Z",
    fill: "#2943EA"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M320.711 229.514c.17 0 .295.381.252.768-.243 2.217-.792 7.921-.792 10.843 0 3.561.311 24.679 1.007 27.528.696 2.85 3.952 12.409 4.108 18.579.107 4.289-.383 8.238-.692 11.144-.129 1.217-.592 2.07-1.12 2.07h-8.343c-.531 0-.991-.853-1.121-2.07-.31-2.906-.8-6.855-.692-11.144.155-6.172 3.41-15.732 4.108-18.579.697-2.849 1.007-23.967 1.007-27.528 0-2.922-.548-8.626-.791-10.843-.043-.39.082-.768.252-.768h2.817Z",
    fill: "#2944EB"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M320.686 229.523c.168 0 .288.381.247.768-.24 2.217-.778 7.912-.778 10.834 0 3.561.304 24.679.989 27.528.685 2.85 3.883 12.409 4.035 18.579.107 4.289-.376 8.22-.68 11.126-.127 1.217-.581 2.07-1.103 2.07h-8.197c-.522 0-.976-.853-1.103-2.07-.304-2.906-.787-6.837-.68-11.126.152-6.172 3.35-15.732 4.035-18.579.685-2.849.989-23.967.989-27.528 0-2.922-.54-8.617-.778-10.834-.043-.389.079-.768.247-.768h2.777Z",
    fill: "#2A45EC"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M320.663 229.532c.163 0 .284.381.243.769-.236 2.217-.765 7.902-.765 10.824 0 3.561.3 24.679.974 27.528.673 2.85 3.815 12.409 3.965 18.579.104 4.289-.37 8.202-.67 11.108-.124 1.217-.571 2.07-1.082 2.07h-8.054c-.513 0-.958-.853-1.082-2.07-.3-2.906-.774-6.819-.669-11.108.149-6.172 3.291-15.731 3.965-18.579.673-2.849.973-23.967.973-27.528 0-2.922-.531-8.605-.765-10.824-.041-.39.08-.769.243-.769h2.724Z",
    fill: "#2A46ED"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M320.638 229.541c.161 0 .279.381.238.769-.231 2.217-.75 7.893-.75 10.815 0 3.561.295 24.679.955 27.528.66 2.85 3.747 12.409 3.894 18.579.102 4.289-.363 8.184-.657 11.088-.123 1.217-.561 2.069-1.064 2.069h-7.91c-.503 0-.941-.852-1.064-2.069-.292-2.907-.76-6.801-.658-11.088.148-6.172 3.233-15.731 3.895-18.579.66-2.849.955-23.967.955-27.528 0-2.922-.519-8.596-.751-10.815-.041-.39.077-.769.238-.769h2.679Z",
    fill: "#2B46EE"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M320.613 229.55c.159 0 .275.381.234.769-.227 2.217-.737 7.884-.737 10.806 0 3.561.288 24.679.937 27.528.648 2.85 3.679 12.409 3.822 18.579.099 4.289-.357 8.163-.645 11.069-.12 1.218-.551 2.07-1.043 2.07h-7.764c-.493 0-.924-.852-1.044-2.07-.288-2.906-.744-6.782-.644-11.069.145-6.172 3.173-15.732 3.822-18.579.649-2.849.937-23.967.937-27.528 0-2.922-.51-8.587-.737-10.806-.041-.39.075-.769.233-.769h2.629Z",
    fill: "#2B47EF"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M320.588 229.559c.155 0 .268.381.229.769-.222 2.217-.723 7.875-.723 10.797 0 3.561.283 24.679.921 27.528.637 2.85 3.609 12.409 3.752 18.579.097 4.289-.35 8.145-.633 11.051-.118 1.218-.54 2.07-1.026 2.07h-7.619c-.483 0-.905-.852-1.025-2.07-.284-2.906-.73-6.764-.633-11.051.141-6.172 3.114-15.732 3.752-18.579.637-2.849.921-23.967.921-27.528 0-2.922-.502-8.578-.724-10.797-.038-.39.075-.769.229-.769h2.579Z",
    fill: "#2C48F0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M320.563 229.568c.152 0 .263.381.225.769-.218 2.217-.71 7.866-.71 10.788 0 3.561.277 24.679.903 27.528.626 2.85 3.54 12.409 3.679 18.579.097 4.289-.343 8.127-.622 11.033-.115 1.217-.53 2.07-1.005 2.07h-7.476c-.474 0-.889-.853-1.005-2.07-.276-2.906-.717-6.744-.621-11.033.138-6.172 3.055-15.732 3.679-18.579.626-2.849.903-23.967.903-27.528 0-2.922-.493-8.569-.71-10.788-.039-.39.072-.769.224-.769h2.536Z",
    fill: "#2C49F1"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M320.541 229.577c.149 0 .258.381.22.769-.214 2.217-.697 7.857-.697 10.776 0 3.562.272 24.68.885 27.529.612 2.849 3.473 12.409 3.609 18.579.095 4.289-.336 8.109-.608 11.015-.114 1.217-.52 2.069-.985 2.069h-7.331c-.465 0-.871-.852-.984-2.069-.272-2.906-.703-6.726-.608-11.015.136-6.173 2.996-15.732 3.609-18.579.612-2.849.884-23.967.884-27.529 0-2.922-.483-8.559-.696-10.776-.038-.39.073-.769.22-.769h2.482Z",
    fill: "#2D4AF2"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M320.516 229.586c.147 0 .254.381.215.769-.211 2.217-.682 7.848-.682 10.767 0 3.562.267 24.68.868 27.529s3.405 12.409 3.539 18.579c.093 4.289-.329 8.09-.597 10.996-.111 1.218-.51 2.07-.966 2.07h-7.188c-.456 0-.855-.852-.967-2.07-.267-2.906-.689-6.707-.596-10.996.134-6.173 2.937-15.732 3.538-18.579.602-2.849.869-23.967.869-27.529 0-2.922-.472-8.55-.683-10.767-.036-.39.071-.769.216-.769h2.434Z",
    fill: "#2D4BF3"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M320.491 229.598c.143 0 .247.381.213.768-.206 2.217-.669 7.839-.669 10.759 0 3.561.261 24.679.85 27.528.59 2.85 3.337 12.409 3.466 18.579.091 4.289-.324 8.07-.585 10.976-.109 1.218-.499 2.07-.946 2.07h-7.043c-.447 0-.837-.852-.946-2.07-.261-2.906-.676-6.689-.585-10.976.132-6.172 2.879-15.731 3.466-18.579.59-2.849.851-23.967.851-27.528 0-2.922-.463-8.542-.669-10.759-.037-.39.068-.768.213-.768h2.384Z",
    fill: "#2E4CF4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M320.466 229.607c.14 0 .242.381.208.768-.201 2.217-.655 7.83-.655 10.75 0 3.561.256 24.679.832 27.528.576 2.85 3.267 12.409 3.396 18.579.088 4.289-.318 8.052-.572 10.958-.106 1.218-.49 2.07-.927 2.07h-6.898c-.438 0-.821-.852-.928-2.07-.256-2.906-.662-6.671-.572-10.958.127-6.172 2.82-15.732 3.396-18.579.576-2.849.832-23.967.832-27.528 0-2.922-.453-8.533-.655-10.75-.036-.39.068-.768.209-.768h2.334Z",
    fill: "#2E4CF5"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M320.443 229.616c.138 0 .238.381.204.769-.197 2.217-.642 7.82-.642 10.74 0 3.561.252 24.679.815 27.529.564 2.849 3.198 12.408 3.325 18.579.086 4.288-.311 8.033-.56 10.939-.105 1.218-.479 2.07-.908 2.07h-6.752c-.429 0-.803-.852-.908-2.07-.249-2.906-.648-6.653-.56-10.939.125-6.173 2.761-15.732 3.325-18.579.565-2.85.815-23.968.815-27.529 0-2.922-.445-8.523-.642-10.74-.034-.39.066-.769.204-.769h2.284Z",
    fill: "#2F4DF6"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M320.418 229.625c.134 0 .234.381.2.768-.193 2.217-.629 7.81-.629 10.732 0 3.561.245 24.679.799 27.528.553 2.85 3.13 12.409 3.253 18.579.086 4.289-.304 8.016-.549 10.922-.102 1.217-.47 2.07-.889 2.07h-6.608c-.42 0-.785-.853-.889-2.07-.245-2.906-.635-6.633-.549-10.922.122-6.172 2.701-15.732 3.253-18.579.553-2.849.798-23.967.798-27.528 0-2.922-.435-8.515-.628-10.732-.034-.389.063-.768.199-.768h2.239Z",
    fill: "#2F4EF7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M320.393 229.634c.132 0 .227.381.195.769-.188 2.217-.614 7.8-.614 10.722 0 3.561.24 24.679.78 27.528.54 2.85 3.062 12.409 3.182 18.58.084 4.288-.297 7.997-.537 10.903-.1 1.217-.458 2.07-.869 2.07h-6.465c-.41 0-.768-.853-.868-2.07-.241-2.906-.62-6.615-.538-10.903.12-6.173 2.643-15.732 3.183-18.58.539-2.849.78-23.967.78-27.528 0-2.922-.424-8.503-.615-10.722-.034-.39.064-.769.195-.769h2.191Z",
    fill: "#304FF8"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M320.368 229.643c.13 0 .223.381.191.769-.184 2.217-.601 7.791-.601 10.713 0 3.561.236 24.679.762 27.528.529 2.85 2.994 12.409 3.11 18.579.082 4.289-.29 7.98-.524 10.886-.098 1.217-.449 2.069-.848 2.069h-6.32c-.401 0-.751-.852-.848-2.069-.234-2.906-.606-6.597-.524-10.886.118-6.172 2.583-15.731 3.11-18.579.528-2.849.762-23.967.762-27.528 0-2.922-.415-8.494-.601-10.713-.032-.39.061-.769.19-.769h2.141Z",
    fill: "#3050F9"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M320.344 229.652c.124 0 .217.381.186.769-.18 2.217-.588 7.782-.588 10.704 0 3.561.229 24.679.746 27.528.517 2.85 2.926 12.409 3.04 18.579.079 4.289-.284 7.959-.513 10.865-.095 1.217-.438 2.07-.83 2.07h-6.174c-.393 0-.735-.853-.831-2.07-.229-2.906-.592-6.578-.512-10.865.116-6.172 2.524-15.732 3.039-18.579.518-2.849.747-23.967.747-27.528 0-2.922-.406-8.485-.588-10.704-.032-.39.061-.769.186-.769h2.092Z",
    fill: "#3151FA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M320.321 229.661c.122 0 .213.381.181.769-.177 2.217-.571 7.773-.571 10.695 0 3.561.224 24.679.728 27.528.503 2.85 2.855 12.409 2.969 18.579.077 4.289-.277 7.941-.501 10.847-.093 1.218-.427 2.07-.81 2.07h-6.032c-.383 0-.716-.852-.809-2.07-.225-2.906-.579-6.56-.502-10.847.111-6.172 2.464-15.731 2.969-18.579.504-2.849.729-23.967.729-27.528 0-2.922-.397-8.476-.572-10.695-.032-.39.059-.769.181-.769h2.04Z",
    fill: "#3152FB"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M320.296 229.67c.12 0 .206.381.177.769-.172 2.217-.558 7.764-.558 10.686 0 3.561.218 24.679.71 27.528.492 2.85 2.788 12.409 2.897 18.579.074 4.289-.27 7.923-.488 10.829-.091 1.217-.418 2.07-.792 2.07h-5.886c-.374 0-.699-.853-.792-2.07-.217-2.906-.564-6.54-.487-10.829.109-6.172 2.404-15.732 2.896-18.579.492-2.849.71-23.967.71-27.528 0-2.922-.388-8.467-.558-10.686-.029-.39.057-.769.177-.769h1.994Z",
    fill: "#3252FC"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M320.271 229.679c.118 0 .202.381.172.769-.168 2.217-.544 7.755-.544 10.674 0 3.562.213 24.68.694 27.529s2.72 12.409 2.826 18.579c.075 4.289-.263 7.905-.476 10.811-.089 1.217-.406 2.069-.771 2.069h-5.741c-.366 0-.683-.852-.772-2.069-.213-2.906-.551-6.522-.476-10.811.107-6.173 2.345-15.732 2.826-18.579.481-2.849.694-23.967.694-27.529 0-2.921-.376-8.457-.544-10.674-.029-.39.057-.769.172-.769h1.94Z",
    fill: "#3253FD"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M320.246 229.689c.113 0 .197.381.168.768-.163 2.217-.531 7.746-.531 10.666 0 3.561.209 24.679.676 27.528.467 2.85 2.652 12.409 2.756 18.579.073 4.289-.256 7.887-.465 10.793-.086 1.217-.397 2.069-.753 2.069h-5.596c-.356 0-.665-.852-.753-2.069-.209-2.906-.538-6.504-.465-10.793.104-6.172 2.286-15.732 2.756-18.579.467-2.849.676-23.967.676-27.528 0-2.922-.368-8.449-.531-10.666-.029-.39.055-.768.168-.768h1.894Z",
    fill: "#3354FE"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M320.221 229.7c.111 0 .193.381.163.768-.159 2.217-.517 7.737-.517 10.657 0 3.561.202 24.679.658 27.528.456 2.85 2.583 12.409 2.683 18.579.07 4.289-.249 7.869-.453 10.772-.084 1.218-.386 2.07-.733 2.07h-5.453c-.347 0-.649-.852-.733-2.07-.202-2.906-.524-6.485-.453-10.772.102-6.172 2.227-15.731 2.683-18.579.456-2.849.658-23.967.658-27.528 0-2.922-.359-8.44-.517-10.657-.028-.389.052-.768.163-.768h1.851Z",
    fill: "#3355FF"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M319.949 264.505c.213 6.284 3.234 15.94 3.311 22.349.055 4.452-1.113 8.779-1.27 11.796-.081 1.58-5.301 1.58-5.385 0-.156-3.017-1.324-7.344-1.27-11.796.079-6.409 2.851-15.88 3.312-22.349.215-2.97 1.2-2.976 1.302 0Z",
    fill: "#3355FF"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M319.937 264.736c.209 6.166 3.158 15.73 3.235 22.073.054 4.406-1.084 8.682-1.238 11.667-.082 1.655-5.188 1.655-5.27 0-.154-2.988-1.29-7.261-1.238-11.667.077-6.343 2.783-15.73 3.234-22.073.209-2.942 1.178-2.947 1.277 0Z",
    fill: "#3456FF"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M319.924 264.965c.206 6.046 3.082 15.517 3.157 21.798.052 4.364-1.055 8.582-1.207 11.541-.081 1.729-5.074 1.729-5.155 0-.15-2.956-1.259-7.177-1.207-11.541.075-6.279 2.717-15.578 3.157-21.798.209-2.911 1.157-2.917 1.255 0Z",
    fill: "#3457FF"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M319.912 265.196c.202 5.926 3.008 15.306 3.081 21.522.052 4.318-1.032 8.484-1.173 11.411-.086 1.804-4.956 1.804-5.042 0-.141-2.927-1.225-7.093-1.173-11.411.075-6.216 2.649-15.426 3.08-21.522.202-2.883 1.13-2.888 1.227 0Z",
    fill: "#3558FF"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M319.901 265.425c.198 5.808 2.931 15.095 3.003 21.247.05 4.273-1.004 8.388-1.141 11.282-.088 1.88-4.84 1.88-4.929 0-.136-2.897-1.19-7.009-1.141-11.282.073-6.152 2.584-15.276 3.004-21.247.197-2.852 1.107-2.856 1.204 0Z",
    fill: "#3659FF"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M319.89 265.654c.195 5.688 2.856 14.884 2.926 20.971.05 4.23-.978 8.287-1.109 11.155-.089 1.954-4.725 1.954-4.816 0-.131-2.868-1.157-6.925-1.109-11.155.07-6.087 2.518-15.125 2.926-20.971.195-2.82 1.084-2.827 1.182 0Z",
    fill: "#375AFF"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M319.876 265.885c.191 5.568 2.781 14.671 2.849 20.697.048 4.184-.95 8.19-1.077 11.026-.091 2.028-4.612 2.028-4.702 0-.127-2.836-1.125-6.842-1.078-11.026.068-6.023 2.45-14.975 2.849-20.697.195-2.792 1.064-2.797 1.159 0Z",
    fill: "#375BFF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M319.865 266.114c.186 5.45 2.704 14.46 2.772 20.42.047 4.139-.923 8.093-1.044 10.899-.09 2.104-4.495 2.104-4.586 0-.123-2.806-1.091-6.758-1.044-10.899.068-5.96 2.384-14.823 2.772-20.42.184-2.761 1.035-2.765 1.13 0Z",
    fill: "#385CFF"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M319.853 266.343c.184 5.329 2.629 14.249 2.695 20.146.046 4.096-.894 7.992-1.011 10.769-.093 2.179-4.383 2.179-4.474 0-.118-2.777-1.057-6.673-1.011-10.769.066-5.897 2.316-14.671 2.695-20.146.181-2.731 1.011-2.736 1.106 0Z",
    fill: "#395DFF"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M319.842 266.574c.179 5.21 2.554 14.039 2.618 19.869.045 4.051-.867 7.896-.98 10.641-.093 2.253-4.267 2.253-4.36 0-.113-2.745-1.025-6.59-.98-10.641.064-5.83 2.25-14.521 2.618-19.869.179-2.702.989-2.706 1.084 0Z",
    fill: "#395EFF"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M319.829 266.803c.177 5.089 2.479 13.826 2.54 19.595.043 4.008-.837 7.798-.948 10.514-.093 2.328-4.151 2.328-4.246 0-.109-2.716-.991-6.506-.948-10.514.061-5.767 2.182-14.37 2.54-19.595.177-2.672.969-2.674 1.062 0Z",
    fill: "#3A5FFF"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M319.817 267.032c.173 4.972 2.402 13.615 2.464 19.318.043 3.963-.81 7.699-.917 10.385-.095 2.405-4.037 2.405-4.133 0-.106-2.686-.957-6.422-.916-10.385.061-5.703 2.116-14.217 2.463-19.318.175-2.64.946-2.645 1.039 0Z",
    fill: "#3B60FF"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M319.806 267.263c.168 4.852 2.327 13.404 2.386 19.044.041 3.917-.78 7.601-.882 10.258-.096 2.48-3.922 2.48-4.02 0-.102-2.657-.923-6.338-.882-10.258.059-5.64 2.048-14.068 2.386-19.044.168-2.611.919-2.615 1.012 0Z",
    fill: "#3B61FF"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M319.795 267.493c.165 4.73 2.252 13.193 2.309 18.767.041 3.874-.753 7.503-.851 10.128-.095 2.555-3.808 2.555-3.904 0-.099-2.625-.891-6.254-.85-10.128.056-5.574 1.982-13.916 2.309-18.767.161-2.582.894-2.587.987 0Z",
    fill: "#3C62FF"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M319.781 267.721c.161 4.614 2.175 12.98 2.232 18.493.039 3.829-.724 7.404-.819 9.999a1.897 1.897 0 0 1-3.79 0c-.096-2.595-.858-6.17-.819-9.999.054-5.51 1.914-13.766 2.232-18.493.161-2.55.873-2.554.964 0Z",
    fill: "#3D63FF"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M319.77 267.953c.158 4.493 2.1 12.769 2.154 18.216.037 3.783-.694 7.306-.787 9.872-.097 2.704-3.579 2.704-3.677 0-.093-2.566-.823-6.086-.787-9.872.055-5.447 1.858-13.615 2.155-18.216.164-2.523.851-2.526.942 0Z",
    fill: "#3E64FF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M319.758 268.182c.155 4.372 2.026 12.558 2.078 17.939.036 3.741-.665 7.209-.753 9.743-.098 2.78-3.466 2.78-3.564 0-.088-2.534-.789-6.002-.753-9.743.053-5.383 1.792-13.462 2.078-17.939.157-2.492.824-2.496.914 0Z",
    fill: "#3E65FF"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M319.747 268.413c.15 4.252 1.948 12.347 2.001 17.665.034 3.695-.636 7.111-.722 9.616-.097 2.854-3.352 2.854-3.45 0-.086-2.505-.757-5.918-.721-9.616.05-5.318 1.724-13.313 2-17.665.152-2.464.801-2.466.892 0Z",
    fill: "#3F66FF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M319.733 268.642c.148 4.134 1.874 12.134 1.924 17.389.034 3.652-.608 7.011-.69 9.486-.097 2.929-3.237 2.929-3.336 0-.084-2.475-.724-5.834-.69-9.486.05-5.255 1.658-13.162 1.924-17.389.152-2.433.78-2.435.868 0Z",
    fill: "#4067FF"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M319.722 268.871c.143 4.014 1.799 11.923 1.846 17.114.032 3.607-.578 6.914-.657 9.358-.098 3.004-3.124 3.004-3.221 0-.08-2.444-.69-5.753-.658-9.358.047-5.191 1.59-13.009 1.846-17.114.148-2.401.756-2.405.844 0Z",
    fill: "#4067FF"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M319.711 269.102c.14 3.894 1.721 11.713 1.767 16.838.031 3.561-.549 6.816-.627 9.231-.097 3.078-3.01 3.078-3.107 0-.077-2.415-.658-5.67-.626-9.231.045-5.128 1.524-12.86 1.767-16.838.147-2.373.737-2.376.826 0Z",
    fill: "#4168FF"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M319.697 269.331c.136 3.776 1.647 11.502 1.69 16.564.029 3.518-.52 6.716-.592 9.101-.098 3.153-2.897 3.153-2.994 0-.075-2.385-.624-5.585-.593-9.101.044-5.062 1.459-12.708 1.69-16.564.143-2.342.713-2.346.799 0Z",
    fill: "#4269FF"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M319.686 269.56c.131 3.656 1.572 11.289 1.612 16.287.03 3.473-.49 6.619-.56 8.975-.097 3.228-2.783 3.228-2.881 0-.07-2.353-.589-5.502-.56-8.975.043-4.998 1.391-12.558 1.613-16.287.141-2.312.689-2.315.776 0Z",
    fill: "#426AFF"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M319.674 269.791c.13 3.536 1.495 11.078 1.536 16.013.027 3.427-.46 6.522-.528 8.845-.098 3.303-2.67 3.303-2.768 0-.068-2.323-.555-5.418-.528-8.845.041-4.935 1.324-12.406 1.535-16.013.139-2.283.667-2.285.753 0Z",
    fill: "#436BFF"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M319.663 270.02c.125 3.416 1.42 10.867 1.459 15.737.027 3.384-.431 6.424-.497 8.716-.098 3.377-2.557 3.377-2.652 0-.066-2.294-.524-5.334-.497-8.716.039-4.872 1.257-12.255 1.459-15.737.131-2.253.642-2.255.728 0Z",
    fill: "#446CFF"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M319.649 270.249c.121 3.298 1.345 10.656 1.382 15.462.025 3.339-.402 6.325-.463 8.589-.098 3.453-2.443 3.453-2.538 0-.064-2.264-.49-5.25-.463-8.589.036-4.806 1.189-12.105 1.381-15.462.127-2.221.617-2.224.701 0Z",
    fill: "#456DFF"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M319.638 270.48c.118 3.178 1.27 10.444 1.304 15.186.025 3.296-.372 6.227-.431 8.46-.095 3.529-2.329 3.529-2.425 0-.061-2.233-.456-5.166-.431-8.46.037-4.742 1.123-11.953 1.305-15.186.122-2.192.594-2.194.678 0Z",
    fill: "#456EFF"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M319.627 270.709c.113 3.058 1.193 10.233 1.227 14.911.023 3.251-.34 6.13-.399 8.333-.096 3.605-2.216 3.605-2.312 0-.059-2.203-.422-5.082-.399-8.333.034-4.678 1.055-11.803 1.227-14.911.12-2.162.572-2.165.656 0Z",
    fill: "#466FFF"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M319.615 270.941c.112 2.94 1.119 10.021 1.15 14.634.023 3.206-.31 6.03-.367 8.204-.095 3.679-2.103 3.679-2.198 0-.057-2.174-.39-4.998-.367-8.204.031-4.615.989-11.651 1.15-14.634.118-2.134.548-2.136.632 0Z",
    fill: "#4770FF"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M319.602 271.169c.106 2.82 1.043 9.809 1.073 14.361.02 3.162-.282 5.932-.336 8.074-.093 3.754-1.992 3.754-2.085 0-.052-2.142-.356-4.914-.335-8.074.029-4.55.921-11.5 1.073-14.361.115-2.103.528-2.106.61 0Z",
    fill: "#4771FF"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M319.59 271.398c.102 2.7.966 9.598.996 14.084.02 3.117-.252 5.835-.302 7.948-.093 3.828-1.878 3.828-1.969 0-.05-2.113-.322-4.831-.301-7.948.029-4.486.853-11.35.995-14.084.107-2.072.499-2.074.581 0Z",
    fill: "#4872FF"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M319.579 271.629c.1 2.58.891 9.387.919 13.81.018 3.072-.223 5.737-.27 7.818-.091 3.904-1.765 3.904-1.856 0-.047-2.083-.288-4.746-.27-7.818.028-4.423.785-11.198.919-13.81.102-2.044.476-2.044.558 0Z",
    fill: "#4973FF"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M319.568 271.858c.095 2.462.816 9.177.841 13.534.018 3.028-.192 5.637-.238 7.691-.088 3.978-1.653 3.978-1.742 0-.045-2.052-.256-4.663-.238-7.691.025-4.36.717-11.049.841-13.534.1-2.012.454-2.015.536 0Z",
    fill: "#4974FF"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M319.554 272.087c.093 2.342.74 8.963.765 13.259.015 2.983-.164 5.54-.207 7.562-.086 4.053-1.542 4.053-1.628 0-.044-2.022-.223-4.579-.207-7.562.025-4.293.651-10.897.765-13.259.097-1.983.433-1.983.512 0Z",
    fill: "#4A75FF"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M319.543 272.319c.088 2.221.664 8.752.687 12.982.016 2.94-.129 5.442-.175 7.433-.079 4.128-1.436 4.128-1.515 0-.045-1.993-.188-4.495-.175-7.433.023-4.23.579-10.747.688-12.982.09-1.954.41-1.954.49 0Z",
    fill: "#4B76FF"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M319.531 272.547c.084 2.104.59 8.542.61 12.708.014 2.895-.099 5.343-.14 7.306-.08 4.203-1.323 4.203-1.402 0-.041-1.96-.156-4.411-.141-7.306.021-4.166.513-10.595.611-12.708.083-1.924.383-1.924.462 0Z",
    fill: "#4C77FF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M319.52 272.777c.082 1.983.513 8.33.533 12.431.014 2.849-.07 5.245-.109 7.177-.079 4.277-1.209 4.277-1.286 0-.038-1.932-.122-4.328-.109-7.177.018-4.103.445-10.443.533-12.431.078-1.893.359-1.893.438 0Z",
    fill: "#4C78FF"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M319.506 273.008c.077 1.863.438 8.117.456 12.157.012 2.806-.043 5.148-.077 7.05-.079 4.352-1.095 4.352-1.173 0-.034-1.902-.088-4.244-.077-7.05.018-4.038.379-10.294.456-12.157.077-1.864.338-1.864.415 0Z",
    fill: "#4D79FF"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M353.577 243.767a1.13 1.13 0 0 1 1.024 1.608c-.686 1.463-2.459 2.576-2.459 4.707 0 3.558-1.102 3.701.55 6.546 2.558 4.414 9.489 5.701 9.948 13.436.548 9.221-2.425 17.217-5.162 26.013-.802 2.573-2.644 4.664-5.341 4.664h-6.559c-2.699 0-4.529-2.093-5.341-4.664-3.151-9.987-5.714-16.754-5.162-26.013.46-7.735 7.39-9.024 9.949-13.436 1.651-2.847.549-2.988.549-6.546 0-2.129-1.77-3.244-2.458-4.707a1.13 1.13 0 0 1 1.023-1.608h9.439Z",
    fill: "#780037"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M353.515 243.794a1.126 1.126 0 0 1 1.017 1.6c-.679 1.461-2.428 2.569-2.428 4.698 0 3.556-1.088 3.694.543 6.538 2.53 4.41 9.375 5.844 9.829 13.572.54 9.135-2.389 17.113-5.086 25.851-.79 2.574-2.611 4.662-5.276 4.662h-6.51c-2.665 0-4.476-2.091-5.276-4.662-3.104-9.913-5.629-16.677-5.086-25.851.454-7.728 7.299-9.162 9.829-13.572 1.631-2.844.543-2.982.543-6.538 0-2.129-1.749-3.237-2.428-4.698a1.125 1.125 0 0 1 1.017-1.6h9.312Z",
    fill: "#790038"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M353.454 243.822a1.125 1.125 0 0 1 1.009 1.596c-.669 1.461-2.399 2.562-2.399 4.688 0 3.554-1.076 3.689.538 6.531 2.499 4.408 9.26 5.985 9.708 13.708.533 9.05-2.354 17.008-5.01 25.687-.779 2.573-2.58 4.659-5.215 4.659h-6.459c-2.632 0-4.427-2.088-5.215-4.659-3.056-9.837-5.545-16.599-5.01-25.687.45-7.723 7.212-9.3 9.708-13.708 1.612-2.842.538-2.977.538-6.531 0-2.126-1.73-3.227-2.399-4.688a1.124 1.124 0 0 1 1.009-1.596h9.197Z",
    fill: "#7A0039"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M353.392 243.848c.804.017 1.34.842 1.002 1.589-.662 1.458-2.371 2.555-2.371 4.679 0 3.551-1.061 3.682.531 6.521 2.468 4.403 9.146 6.127 9.589 13.843.526 8.964-2.337 16.899-4.934 25.526-.773 2.571-2.549 4.654-5.15 4.654h-6.409c-2.602 0-4.368-2.086-5.151-4.654-2.979-9.771-5.459-16.523-4.933-25.526.442-7.718 7.12-9.44 9.589-13.843 1.592-2.839.53-2.973.53-6.521 0-2.124-1.709-3.221-2.37-4.679a1.12 1.12 0 0 1 1.002-1.589h9.075Z",
    fill: "#7B0039"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M353.33 243.875c.797.021 1.33.837.995 1.581-.652 1.458-2.34 2.545-2.34 4.669 0 3.549-1.047 3.677.524 6.515 2.437 4.4 9.029 6.267 9.47 13.978.516 8.879-2.309 16.792-4.855 25.364-.764 2.571-2.519 4.652-5.087 4.652h-6.359c-2.568 0-4.312-2.083-5.086-4.652-2.925-9.697-5.374-16.445-4.855-25.364.438-7.711 7.033-9.578 9.47-13.978 1.571-2.838.523-2.969.523-6.515 0-2.124-1.687-3.211-2.339-4.669a1.116 1.116 0 0 1 .995-1.581h8.944Z",
    fill: "#7C003A"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M353.27 243.901c.79.028 1.319.83.988 1.577-.645 1.455-2.311 2.538-2.311 4.659 0 3.544-1.035 3.673.516 6.508 2.407 4.397 8.916 6.407 9.349 14.113.509 8.794-2.278 16.685-4.779 25.2-.754 2.569-2.485 4.648-5.022 4.648h-6.309c-2.537 0-4.258-2.081-5.022-4.648-2.868-9.623-5.291-16.368-4.779-25.2.433-7.706 6.943-9.718 9.349-14.113 1.551-2.835.516-2.961.516-6.508 0-2.121-1.666-3.204-2.311-4.659a1.114 1.114 0 0 1 .988-1.577h8.827Z",
    fill: "#7D003B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M353.209 243.927c.783.033 1.306.825.98 1.57-.638 1.455-2.28 2.53-2.28 4.65 0 3.541-1.021 3.665.509 6.5 2.376 4.393 8.802 6.55 9.23 14.249.502 8.708-2.249 16.578-4.703 25.038-.745 2.569-2.454 4.646-4.957 4.646h-6.26c-2.504 0-4.203-2.079-4.957-4.646-2.813-9.549-5.205-16.29-4.703-25.038.426-7.699 6.854-9.856 9.229-14.249 1.533-2.833.51-2.956.51-6.5 0-2.12-1.645-3.197-2.28-4.65a1.11 1.11 0 0 1 .98-1.57h8.702Z",
    fill: "#7E003C"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M353.146 243.953c.776.038 1.295.821.974 1.565-.628 1.453-2.252 2.524-2.252 4.641 0 3.539-1.009 3.66.505 6.49 2.344 4.391 8.687 6.691 9.108 14.385.493 8.622-2.218 16.474-4.624 24.877-.736 2.566-2.423 4.64-4.893 4.64h-6.21c-2.473 0-4.148-2.076-4.893-4.64-2.758-9.479-5.122-16.214-4.624-24.877.421-7.694 6.764-9.994 9.108-14.385 1.514-2.832.504-2.951.504-6.49 0-2.12-1.623-3.188-2.251-4.641a1.11 1.11 0 0 1 .973-1.565h8.575Z",
    fill: "#7F003D"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M353.085 243.979a1.11 1.11 0 0 1 .966 1.558c-.621 1.453-2.223 2.514-2.223 4.631 0 3.537-.995 3.653.497 6.484 2.316 4.386 8.573 6.833 8.99 14.52.485 8.537-2.188 16.366-4.549 24.715-.725 2.566-2.389 4.638-4.831 4.638h-6.157c-2.439 0-4.094-2.074-4.831-4.638-2.704-9.405-5.036-16.136-4.549-24.715.417-7.687 6.674-10.134 8.99-14.52 1.492-2.831.497-2.947.497-6.484 0-2.117-1.602-3.18-2.223-4.631a1.105 1.105 0 0 1 .966-1.558h8.457Z",
    fill: "#80003D"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M353.025 244.005c.762.05 1.271.809.959 1.551-.611 1.451-2.192 2.507-2.192 4.621 0 3.535-.983 3.649.491 6.477 2.284 4.384 8.458 6.974 8.87 14.656.478 8.453-2.159 16.259-4.472 24.551-.717 2.566-2.359 4.633-4.767 4.633h-6.107c-2.409 0-4.039-2.072-4.768-4.633-2.649-9.331-4.95-16.06-4.472-24.551.41-7.682 6.586-10.272 8.871-14.656 1.473-2.828.49-2.942.49-6.477 0-2.114-1.58-3.17-2.192-4.621-.314-.742.186-1.501.959-1.551h8.33Z",
    fill: "#81003E"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M352.963 244.031c.752.055 1.259.804.952 1.546-.604 1.451-2.163 2.5-2.163 4.612 0 3.532-.969 3.642.483 6.467 2.254 4.382 8.344 7.117 8.749 14.792.471 8.367-2.128 16.155-4.394 24.389-.706 2.564-2.327 4.631-4.702 4.631h-6.058c-2.375 0-3.984-2.07-4.702-4.631-2.595-9.257-4.867-15.981-4.394-24.389.405-7.675 6.495-10.41 8.749-14.792 1.454-2.825.483-2.937.483-6.467 0-2.114-1.559-3.163-2.163-4.612-.31-.742.183-1.491.952-1.546h8.208Z",
    fill: "#82003F"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M352.901 244.058c.745.061 1.25.796.945 1.538-.595 1.449-2.135 2.493-2.135 4.605 0 3.53-.956 3.637.479 6.46 2.223 4.376 8.23 7.257 8.63 14.927.461 8.282-2.097 16.048-4.318 24.227-.697 2.564-2.296 4.626-4.638 4.626h-6.007c-2.345 0-3.932-2.066-4.639-4.626-2.539-9.183-4.781-15.904-4.317-24.227.4-7.67 6.407-10.551 8.63-14.927 1.432-2.823.478-2.93.478-6.46 0-2.112-1.537-3.154-2.135-4.605-.304-.742.181-1.479.945-1.538h8.082Z",
    fill: "#830040"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M352.84 244.084c.737.066 1.237.792.935 1.534-.588 1.448-2.104 2.483-2.104 4.595 0 3.525-.942 3.632.471 6.453 2.192 4.374 8.099 7.399 8.511 15.063.438 8.196-2.066 15.942-4.241 24.063-.685 2.564-2.263 4.623-4.574 4.623h-5.958c-2.31 0-3.877-2.062-4.574-4.623-2.485-9.11-4.698-15.827-4.241-24.063.395-7.664 6.317-10.689 8.511-15.063 1.414-2.821.471-2.926.471-6.453 0-2.11-1.518-3.147-2.104-4.595-.3-.742.181-1.468.936-1.534h7.961Z",
    fill: "#840040"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M352.778 244.112c.73.072 1.225.788.928 1.527-.578 1.446-2.075 2.476-2.075 4.586 0 3.522-.931 3.625.464 6.443 2.161 4.369 7.984 7.54 8.389 15.199.428 8.11-2.035 15.835-4.165 23.901-.676 2.561-2.232 4.619-4.51 4.619h-5.907c-2.278 0-3.822-2.06-4.51-4.619-2.433-9.034-4.596-15.748-4.165-23.901.404-7.657 6.228-10.827 8.389-15.199 1.395-2.818.464-2.921.464-6.443 0-2.11-1.497-3.137-2.075-4.586-.297-.739.179-1.455.928-1.527h7.845Z",
    fill: "#850041"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M352.718 244.138c.724.079 1.214.781.921 1.523-.571 1.446-2.047 2.468-2.047 4.576 0 3.52-.916 3.62.457 6.436 2.13 4.367 7.869 7.682 8.271 15.334.421 8.025-2.002 15.731-4.087 23.739-.666 2.562-2.201 4.617-4.448 4.617h-5.857c-2.247 0-3.767-2.057-4.448-4.617-2.378-8.959-4.51-15.671-4.087-23.739.4-7.652 6.138-10.967 8.271-15.334 1.376-2.816.457-2.916.457-6.436 0-2.108-1.476-3.13-2.047-4.576-.293-.74.179-1.444.921-1.523h7.723Z",
    fill: "#860042"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M352.656 244.165c.717.083 1.202.775.914 1.515-.564 1.446-2.016 2.461-2.016 4.566 0 3.518-.904 3.613.453 6.429 2.101 4.362 7.754 7.823 8.149 15.47.411 7.939-1.971 15.624-4.011 23.575-.657 2.562-2.168 4.612-4.384 4.612h-5.807c-2.213 0-3.715-2.055-4.384-4.612-2.325-8.886-4.424-15.593-4.01-23.575.395-7.647 6.05-11.105 8.149-15.47 1.354-2.813.452-2.911.452-6.429 0-2.105-1.454-3.12-2.016-4.566-.288-.74.177-1.432.914-1.515h7.597Z",
    fill: "#870043"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M352.594 244.191c.71.088 1.19.771.907 1.508-.554 1.444-1.987 2.452-1.987 4.557 0 3.515-.89 3.608.445 6.419 2.071 4.36 7.637 7.966 8.03 15.606.402 7.856-1.94 15.519-3.934 23.413-.647 2.559-2.137 4.61-4.32 4.61h-5.757c-2.182 0-3.66-2.053-4.32-4.61-2.273-8.812-4.338-15.515-3.934-23.413.393-7.64 5.96-11.246 8.03-15.606 1.336-2.811.445-2.904.445-6.419 0-2.105-1.432-3.113-1.987-4.557-.283-.74.174-1.42.907-1.508h7.475Z",
    fill: "#880044"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M352.533 244.217c.702.095 1.18.764.899 1.503-.547 1.444-1.959 2.445-1.959 4.548 0 3.513-.878 3.603.438 6.412 2.04 4.358 7.524 8.106 7.911 15.741.396 7.77-1.906 15.415-3.855 23.252-.638 2.559-2.106 4.604-4.256 4.604h-5.707c-2.149 0-3.605-2.05-4.255-4.604-2.221-8.736-4.253-15.439-3.856-23.252.388-7.635 5.872-11.383 7.911-15.741 1.316-2.809.438-2.899.438-6.412 0-2.103-1.411-3.104-1.959-4.548-.28-.739.174-1.408.9-1.503h7.35Z",
    fill: "#890044"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M352.473 244.243c.695.1 1.169.759.893 1.496-.538 1.442-1.928 2.438-1.928 4.538 0 3.511-.864 3.597.43 6.406 2.009 4.352 7.407 8.246 7.79 15.876.386 7.685-1.873 15.308-3.779 23.088-.626 2.559-2.076 4.602-4.191 4.602h-5.658c-2.118 0-3.553-2.046-4.191-4.602-2.168-8.663-4.167-15.361-3.779-23.088.383-7.628 5.781-11.521 7.789-15.876 1.295-2.809.431-2.895.431-6.406 0-2.1-1.39-3.096-1.928-4.538-.276-.737.172-1.396.893-1.496h7.228Z",
    fill: "#8A0045"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M352.411 244.269c.688.105 1.157.754.885 1.492-.53 1.441-1.899 2.43-1.899 4.528 0 3.508-.849 3.592.426 6.396 1.978 4.35 7.293 8.389 7.671 16.009.376 7.6-1.842 15.203-3.703 22.926-.617 2.56-2.042 4.598-4.127 4.598h-5.607c-2.085 0-3.499-2.043-4.127-4.598-2.116-8.586-4.082-15.284-3.704-22.926.379-7.623 5.693-11.661 7.671-16.009 1.276-2.807.426-2.89.426-6.396 0-2.1-1.368-3.087-1.899-4.528-.271-.738.171-1.385.885-1.492h7.102Z",
    fill: "#8B0046"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M352.349 244.295c.678.112 1.145.747.878 1.485-.521 1.439-1.87 2.421-1.87 4.519 0 3.503-.838 3.584.419 6.388 1.946 4.346 7.175 8.529 7.549 16.145.369 7.514-1.809 15.099-3.625 22.764-.607 2.557-2.011 4.596-4.065 4.596h-5.557c-2.054 0-3.444-2.041-4.065-4.596-2.064-8.512-3.996-15.205-3.625-22.764.374-7.616 5.603-11.799 7.549-16.145 1.257-2.804.419-2.885.419-6.388 0-2.098-1.347-3.08-1.87-4.519-.267-.738.169-1.373.878-1.485h6.985Z",
    fill: "#8C0047"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M352.287 244.322c.671.116 1.133.742.871 1.477-.514 1.439-1.839 2.414-1.839 4.509 0 3.501-.824 3.58.411 6.382 1.916 4.343 7.062 8.671 7.431 16.28.359 7.428-1.776 14.994-3.549 22.6-.595 2.557-1.98 4.591-4.001 4.591h-5.507c-2.021 0-3.391-2.039-4.001-4.591-2.013-8.436-3.91-15.129-3.548-22.6.369-7.611 5.514-11.937 7.43-16.28 1.235-2.802.412-2.878.412-6.382 0-2.095-1.326-3.07-1.84-4.509-.262-.738.167-1.363.871-1.477h6.859Z",
    fill: "#8D0048"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M352.225 244.348c.664.121 1.121.737.864 1.472-.504 1.437-1.811 2.407-1.811 4.5 0 3.499-.811 3.575.405 6.372 1.887 4.341 6.947 8.812 7.311 16.416.352 7.343-1.742 14.887-3.472 22.439-.586 2.557-1.947 4.588-3.937 4.588h-5.457c-1.987 0-3.337-2.034-3.937-4.588-1.963-8.363-3.827-15.051-3.472-22.439.364-7.604 5.424-12.078 7.311-16.416 1.216-2.799.405-2.873.405-6.372 0-2.093-1.307-3.063-1.811-4.5-.26-.735.166-1.351.864-1.472h6.737Z",
    fill: "#8E0048"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M352.166 244.376c.657.129 1.111.73.857 1.465-.498 1.437-1.783 2.4-1.783 4.491 0 3.496-.797 3.568.4 6.365 1.856 4.336 6.831 8.955 7.19 16.551.343 7.257-1.709 14.783-3.396 22.277-.576 2.557-1.916 4.583-3.873 4.583h-5.407c-1.956 0-3.284-2.031-3.872-4.583-1.911-8.286-3.742-14.975-3.396-22.277.359-7.599 5.335-12.215 7.19-16.551 1.197-2.797.399-2.869.399-6.365 0-2.093-1.285-3.054-1.782-4.491-.255-.735.164-1.339.857-1.465h6.616Z",
    fill: "#8F0049"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M352.104 244.403c.65.133 1.1.725.85 1.46-.488 1.434-1.752 2.39-1.752 4.481 0 3.494-.785 3.563.393 6.358 1.825 4.333 6.716 9.095 7.071 16.687.335 7.171-1.676 14.677-3.318 22.112-.564 2.555-1.885 4.581-3.808 4.581h-5.357c-1.923 0-3.23-2.028-3.808-4.581-1.861-8.21-3.656-14.896-3.318-22.112.355-7.592 5.246-12.356 7.071-16.687 1.178-2.795.393-2.864.393-6.358 0-2.091-1.264-3.047-1.752-4.481-.25-.735.164-1.327.85-1.46h6.485Z",
    fill: "#90004A"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M352.042 244.429c.643.138 1.088.718.843 1.453-.481 1.434-1.723 2.383-1.723 4.471 0 3.492-.771 3.556.385 6.349 1.795 4.328 6.6 9.238 6.952 16.822.326 7.086-1.64 14.573-3.241 21.951-.555 2.555-1.854 4.576-3.744 4.576h-5.308c-1.892 0-3.177-2.026-3.743-4.576-1.811-8.136-3.57-14.82-3.242-21.951.35-7.587 5.158-12.494 6.952-16.822 1.157-2.793.386-2.859.386-6.349 0-2.088-1.243-3.039-1.723-4.471-.246-.735.161-1.315.842-1.453h6.364Z",
    fill: "#91004B"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M351.98 244.455c.636.145 1.076.713.833 1.446-.473 1.432-1.694 2.376-1.694 4.462 0 3.489-.759 3.551.378 6.341 1.764 4.326 6.486 9.378 6.831 16.958.319 7-1.607 14.469-3.166 21.789-.545 2.555-1.82 4.574-3.681 4.574h-5.258c-1.859 0-3.122-2.021-3.682-4.574-1.761-8.06-3.484-14.741-3.165-21.789.345-7.58 5.067-12.632 6.83-16.958 1.138-2.79.379-2.854.379-6.341 0-2.088-1.221-3.03-1.695-4.462-.242-.733.16-1.303.833-1.446h6.257Z",
    fill: "#92004C"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M351.918 244.481c.629.15 1.064.709.826 1.441-.464 1.432-1.663 2.367-1.663 4.455 0 3.485-.745 3.544.371 6.334 1.733 4.324 6.371 9.519 6.711 17.094.312 6.914-1.57 14.364-3.086 21.625-.534 2.554-1.79 4.569-3.618 4.569h-5.205c-1.828 0-3.07-2.019-3.618-4.569-1.711-7.984-3.401-14.666-3.086-21.625.34-7.575 4.978-12.772 6.711-17.094 1.119-2.788.371-2.847.371-6.334 0-2.086-1.199-3.023-1.663-4.455-.238-.732.159-1.291.826-1.441h6.123Z",
    fill: "#93004C"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M351.859 244.507c.621.155 1.052.702.819 1.434-.457 1.43-1.635 2.36-1.635 4.446 0 3.482-.733 3.539.366 6.324 1.702 4.319 6.255 9.661 6.59 17.23.303 6.831-1.537 14.258-3.01 21.463-.524 2.554-1.759 4.566-3.554 4.566h-5.157c-1.795 0-3.018-2.016-3.554-4.566-1.663-7.909-3.315-14.587-3.01-21.463.335-7.569 4.888-12.911 6.59-17.23 1.097-2.785.367-2.842.367-6.324 0-2.084-1.179-3.014-1.636-4.446-.233-.732.158-1.279.819-1.434h6.005Z",
    fill: "#94004D"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M351.797 244.533c.614.162 1.043.697.812 1.43-.448 1.429-1.607 2.352-1.607 4.436 0 3.479-.719 3.534.36 6.317 1.673 4.317 6.14 9.802 6.471 17.365.295 6.745-1.502 14.154-2.935 21.302-.511 2.554-1.728 4.562-3.489 4.562h-5.107c-1.764 0-2.963-2.013-3.489-4.562-1.614-7.833-3.23-14.511-2.935-21.302.331-7.563 4.801-13.048 6.471-17.365 1.078-2.785.36-2.838.36-6.317 0-2.084-1.157-3.007-1.607-4.436-.228-.733.157-1.268.812-1.43h5.883Z",
    fill: "#95004E"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M351.735 244.56c.605.166 1.031.692.805 1.422-.441 1.429-1.576 2.345-1.576 4.426 0 3.478-.707 3.527.352 6.31 1.643 4.312 6.027 9.945 6.353 17.501.288 6.66-1.466 14.05-2.856 21.137-.5 2.553-1.695 4.56-3.425 4.56h-5.058c-1.73 0-2.91-2.01-3.425-4.56-1.566-7.758-3.146-14.432-2.855-21.137.326-7.556 4.71-13.189 6.352-17.501 1.059-2.783.352-2.832.352-6.31 0-2.081-1.135-2.997-1.576-4.426-.226-.73.155-1.256.805-1.422h5.752Z",
    fill: "#96004F"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M351.673 244.586c.598.171 1.019.685.798 1.417-.431 1.427-1.547 2.336-1.547 4.417 0 3.475-.693 3.523.345 6.301 1.611 4.309 5.912 10.084 6.231 17.636.278 6.574-1.431 13.945-2.78 20.976-.491 2.552-1.664 4.554-3.361 4.554h-5.007c-1.697 0-2.859-2.007-3.361-4.554-1.518-7.683-3.061-14.357-2.78-20.976.322-7.552 4.622-13.327 6.231-17.636 1.04-2.781.345-2.828.345-6.301 0-2.079-1.114-2.99-1.547-4.417-.221-.73.153-1.244.798-1.417h5.635Z",
    fill: "#970050"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M351.614 244.612c.59.178 1.006.68.79 1.41-.424 1.427-1.516 2.329-1.516 4.408 0 3.472-.681 3.515.34 6.293 1.58 4.305 5.795 10.227 6.112 17.772.271 6.488-1.395 13.84-2.704 20.814-.478 2.552-1.632 4.552-3.298 4.552h-4.958c-1.666 0-2.806-2.003-3.299-4.552-1.47-7.607-2.977-14.278-2.703-20.814.314-7.545 4.531-13.465 6.112-17.772 1.018-2.778.34-2.821.34-6.293 0-2.079-1.095-2.981-1.516-4.408-.217-.73.152-1.232.79-1.41h5.51Z",
    fill: "#970050"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M351.552 244.64c.583.184.995.676.783 1.404-.414 1.424-1.488 2.321-1.488 4.397 0 3.471-.666 3.511.334 6.287 1.549 4.302 5.681 10.367 5.992 17.907.265 6.403-1.359 13.738-2.627 20.65-.467 2.552-1.599 4.548-3.235 4.548h-4.907c-1.633 0-2.751-2.001-3.234-4.548-1.424-7.53-2.892-14.199-2.628-20.65.309-7.54 4.441-13.605 5.993-17.907.999-2.776.333-2.816.333-6.287 0-2.076-1.073-2.973-1.487-4.397-.212-.731.149-1.223.783-1.404h5.388Z",
    fill: "#980051"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M351.49 244.667c.576.187.983.668.776 1.398-.407 1.425-1.459 2.314-1.459 4.388 0 3.466-.655 3.506.326 6.279 1.518 4.301 5.567 10.509 5.871 18.043.255 6.318-1.323 13.634-2.549 20.489-.456 2.552-1.568 4.545-3.17 4.545h-4.857c-1.602 0-2.699-1.996-3.17-4.545-1.376-7.455-2.806-14.124-2.549-20.489.304-7.532 4.353-13.742 5.871-18.043.981-2.773.326-2.811.326-6.279 0-2.074-1.052-2.963-1.459-4.388-.209-.728.15-1.211.776-1.398h5.267Z",
    fill: "#990052"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M351.428 244.693c.569.195.974.663.769 1.391-.4 1.422-1.428 2.305-1.428 4.379 0 3.463-.64 3.499.319 6.269 1.487 4.296 5.452 10.651 5.752 18.179.248 6.232-1.287 13.529-2.472 20.326-.446 2.552-1.538 4.541-3.106 4.541h-4.808c-1.568 0-2.647-1.993-3.106-4.541-1.328-7.378-2.723-14.044-2.473-20.326.3-7.528 4.263-13.883 5.753-18.179.959-2.77.319-2.806.319-6.269 0-2.074-1.031-2.957-1.428-4.379-.205-.728.147-1.199.768-1.391h5.141Z",
    fill: "#9A0053"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M351.366 244.719c.562.2.962.659.762 1.386-.39 1.423-1.4 2.298-1.4 4.37 0 3.46-.625 3.494.315 6.262 1.456 4.293 5.338 10.791 5.631 18.314.24 6.146-1.25 13.424-2.397 20.163-.433 2.552-1.506 4.538-3.042 4.538h-4.757c-1.538 0-2.594-1.991-3.042-4.538-1.283-7.3-2.637-13.969-2.396-20.163.292-7.523 4.174-14.021 5.631-18.314.94-2.768.314-2.802.314-6.262 0-2.072-1.009-2.947-1.4-4.37-.2-.727.145-1.186.762-1.386h5.019Z",
    fill: "#9B0053"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M351.307 244.745c.554.205.949.652.754 1.38-.383 1.42-1.371 2.29-1.371 4.359 0 3.459-.614 3.487.307 6.256 1.428 4.288 5.224 10.934 5.512 18.449.234 6.061-1.213 13.32-2.318 20.001-.421 2.55-1.473 4.533-2.977 4.533h-4.708c-1.504 0-2.542-1.986-2.977-4.533-1.235-7.223-2.554-13.89-2.318-20.001.288-7.515 4.084-14.159 5.512-18.449.921-2.766.307-2.797.307-6.256 0-2.069-.988-2.939-1.371-4.359-.195-.728.145-1.175.754-1.38h4.894Z",
    fill: "#9C0054"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M351.245 244.771c.547.21.938.647.747 1.373-.373 1.42-1.34 2.283-1.34 4.35 0 3.456-.6 3.482.3 6.246 1.397 4.286 5.11 11.074 5.393 18.585.226 5.975-1.176 13.217-2.242 19.839-.412 2.549-1.442 4.531-2.915 4.531h-4.658c-1.473 0-2.489-1.984-2.915-4.531-1.19-7.148-2.468-13.814-2.242-19.839.283-7.511 3.996-14.299 5.393-18.585.899-2.764.3-2.79.3-6.246 0-2.069-.967-2.93-1.34-4.35-.191-.728.142-1.163.747-1.373h4.772Z",
    fill: "#9D0055"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M351.183 244.797c.54.217.926.643.738 1.368-.367 1.418-1.312 2.274-1.312 4.341 0 3.453-.587 3.475.293 6.238 1.366 4.284 4.996 11.215 5.272 18.721.219 5.889-1.14 13.113-2.166 19.675-.4 2.55-1.411 4.526-2.851 4.526h-4.608c-1.44 0-2.437-1.979-2.851-4.526-1.145-7.071-2.385-13.736-2.166-19.675.279-7.504 3.906-14.437 5.272-18.721.88-2.761.293-2.785.293-6.238 0-2.067-.945-2.923-1.312-4.341-.188-.725.143-1.151.738-1.368h4.66Z",
    fill: "#9E0056"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M351.121 244.823c.531.222.914.636.731 1.361-.357 1.418-1.283 2.267-1.283 4.331 0 3.451-.574 3.47.288 6.232 1.335 4.279 4.881 11.357 5.153 18.856.211 5.804-1.102 13.008-2.09 19.513-.388 2.55-1.378 4.524-2.787 4.524h-4.558c-1.406 0-2.387-1.977-2.787-4.524-1.099-6.995-2.301-13.659-2.089-19.513.271-7.499 3.817-14.575 5.152-18.856.862-2.762.288-2.781.288-6.232 0-2.064-.923-2.913-1.282-4.331-.184-.725.14-1.139.73-1.361h4.534Z",
    fill: "#9F0057"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M351.062 244.85c.523.226.904.63.723 1.355-.35 1.416-1.252 2.26-1.252 4.322 0 3.446-.561 3.465.281 6.222 1.304 4.277 4.767 11.498 5.034 18.992.202 5.718-1.064 12.903-2.011 19.351-.376 2.55-1.347 4.519-2.723 4.519h-4.508c-1.375 0-2.335-1.971-2.722-4.519-1.055-6.919-2.216-13.581-2.012-19.351.267-7.492 3.727-14.715 5.034-18.992.843-2.759.281-2.776.281-6.222 0-2.065-.902-2.906-1.252-4.322-.178-.725.14-1.127.724-1.355h4.403Z",
    fill: "#A00057"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M351 244.876c.516.233.892.625.716 1.348-.34 1.416-1.223 2.253-1.223 4.312 0 3.444-.547 3.459.274 6.215 1.273 4.272 4.653 11.641 4.912 19.126.195 5.632-1.026 12.801-1.935 19.187-.364 2.549-1.316 4.516-2.658 4.516h-4.458c-1.342 0-2.283-1.969-2.659-4.516-1.011-6.841-2.132-13.505-1.935-19.187.26-7.488 3.639-14.854 4.913-19.126.821-2.756.273-2.771.273-6.215 0-2.062-.883-2.899-1.223-4.312-.174-.725.138-1.115.717-1.348H351Z",
    fill: "#A10058"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M350.938 244.904c.509.238.881.619.709 1.344-.333 1.413-1.195 2.243-1.195 4.305 0 3.442-.535 3.454.267 6.208 1.242 4.269 4.539 11.78 4.793 19.261.188 5.549-.987 12.696-1.858 19.025-.35 2.55-1.286 4.512-2.595 4.512h-4.405c-1.311 0-2.23-1.965-2.594-4.512-.966-6.764-2.049-13.426-1.859-19.025.255-7.481 3.549-14.992 4.793-19.261.802-2.754.267-2.764.267-6.208 0-2.06-.862-2.89-1.195-4.305-.171-.723.136-1.103.709-1.344h4.163Z",
    fill: "#A20059"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M350.876 244.93c.502.243.869.614.702 1.337-.326 1.413-1.164 2.236-1.164 4.296 0 3.439-.521 3.446.26 6.198 1.214 4.267 4.424 11.923 4.672 19.396.181 5.464-.948 12.592-1.781 18.864-.338 2.55-1.251 4.509-2.532 4.509h-4.355c-1.278 0-2.18-1.962-2.533-4.509-.923-6.688-1.963-13.35-1.78-18.864.248-7.475 3.461-15.132 4.672-19.396.783-2.752.26-2.759.26-6.198 0-2.06-.841-2.883-1.164-4.296-.167-.723.135-1.092.702-1.337h4.041Z",
    fill: "#A3005A"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M350.814 244.957c.495.249.857.608.695 1.329-.316 1.413-1.135 2.229-1.135 4.286 0 3.437-.509 3.442.255 6.191 1.182 4.262 4.31 12.064 4.552 19.532.174 5.378-.909 12.49-1.704 18.7-.326 2.549-1.221 4.504-2.468 4.504h-4.305c-1.247 0-2.128-1.959-2.468-4.504-.878-6.612-1.88-13.272-1.704-18.7.243-7.468 3.37-15.27 4.553-19.532.761-2.749.254-2.754.254-6.191 0-2.057-.818-2.873-1.135-4.286-.162-.723.133-1.082.695-1.329h3.915Z",
    fill: "#A4005B"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M350.755 244.983c.488.254.845.602.688 1.325-.31 1.41-1.107 2.221-1.107 4.276 0 3.435-.495 3.437.247 6.184 1.152 4.26 4.196 12.204 4.434 19.668.167 5.292-.868 12.384-1.628 18.537-.314 2.55-1.19 4.503-2.403 4.503h-4.256c-1.214 0-2.078-1.955-2.404-4.503-.835-6.533-1.797-13.195-1.628-18.537.236-7.464 3.282-15.41 4.434-19.668.743-2.747.248-2.749.248-6.184 0-2.055-.797-2.866-1.107-4.276-.157-.723.133-1.071.688-1.325h3.794Z",
    fill: "#A5005B"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M350.693 245.009c.48.259.835.597.68 1.318-.299 1.41-1.075 2.212-1.075 4.267 0 3.432-.484 3.429.24 6.174 1.121 4.255 4.084 12.347 4.313 19.803.161 5.207-.831 12.28-1.55 18.376-.302 2.55-1.156 4.498-2.339 4.498h-4.208c-1.183 0-2.028-1.953-2.34-4.498-.792-6.457-1.711-13.117-1.549-18.376.231-7.456 3.191-15.548 4.312-19.803.724-2.745.241-2.745.241-6.174 0-2.053-.776-2.857-1.076-4.267-.155-.721.131-1.059.681-1.318h3.67Z",
    fill: "#A6005C"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M350.631 245.035c.473.267.823.59.673 1.313-.292 1.408-1.047 2.205-1.047 4.258 0 3.429-.469 3.425.233 6.167 1.09 4.253 3.97 12.487 4.194 19.939.155 5.12-.79 12.177-1.473 18.211-.288 2.55-1.126 4.496-2.276 4.496h-4.155c-1.15 0-1.975-1.948-2.275-4.496-.752-6.381-1.628-13.041-1.474-18.211.224-7.452 3.104-15.686 4.194-19.939.705-2.742.233-2.738.233-6.167 0-2.053-.754-2.85-1.047-4.258-.15-.721.129-1.046.674-1.313h3.546Z",
    fill: "#A7005D"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M350.569 245.061c.466.271.812.585.666 1.306-.283 1.408-1.018 2.198-1.018 4.248 0 3.425-.457 3.418.228 6.16 1.059 4.251 3.856 12.63 4.075 20.074.147 5.036-.75 12.074-1.397 18.051-.276 2.549-1.095 4.49-2.211 4.49h-4.106c-1.116 0-1.925-1.945-2.211-4.49-.709-6.306-1.544-12.963-1.397-18.051.217-7.447 3.013-15.826 4.075-20.074.683-2.74.228-2.733.228-6.16 0-2.05-.733-2.84-1.018-4.248-.146-.721.128-1.035.666-1.306h3.42Z",
    fill: "#A8005E"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M350.509 245.087c.457.276.8.581.66 1.299-.276 1.406-.988 2.191-.988 4.238 0 3.423-.443 3.414.221 6.151 1.028 4.246 3.744 12.77 3.953 20.21.141 4.95-.709 11.968-1.32 17.888-.262 2.548-1.064 4.489-2.15 4.489h-4.055c-1.085 0-1.875-1.941-2.149-4.489-.667-6.226-1.461-12.886-1.321-17.888.209-7.44 2.925-15.964 3.953-20.21.664-2.737.221-2.728.221-6.151 0-2.047-.711-2.832-.987-4.238-.141-.721.126-1.023.659-1.299h3.303Z",
    fill: "#A9005F"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M350.448 245.114c.449.283.787.573.652 1.293-.267 1.406-.959 2.181-.959 4.229 0 3.421-.429 3.409.214 6.144.999 4.243 3.629 12.91 3.834 20.345.133 4.864-.669 11.866-1.242 17.725-.25 2.547-1.031 4.483-2.085 4.483h-4.006c-1.052 0-1.825-1.938-2.085-4.483-.626-6.151-1.378-12.808-1.242-17.725.205-7.435 2.835-16.102 3.834-20.345.645-2.738.214-2.723.214-6.144 0-2.048-.69-2.823-.959-4.229-.138-.718.126-1.01.652-1.293h3.178Z",
    fill: "#AA005F"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M350.386 245.14c.443.288.776.568.645 1.287-.26 1.403-.931 2.174-.931 4.219 0 3.418-.416 3.401.207 6.136.969 4.239 3.518 13.053 3.713 20.481.126 4.779-.628 11.762-1.166 17.563-.236 2.547-1 4.481-2.021 4.481h-3.955c-1.021 0-1.776-1.934-2.021-4.481-.585-6.075-1.295-12.732-1.166-17.563.197-7.428 2.746-16.242 3.713-20.481.623-2.735.207-2.718.207-6.136 0-2.045-.671-2.816-.931-4.219-.133-.719.124-.999.645-1.287h3.061Z",
    fill: "#AB0060"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M350.324 245.166c.435.293.764.564.635 1.282-.252 1.403-.899 2.167-.899 4.21 0 3.415-.403 3.396.202 6.127.938 4.236 3.403 13.193 3.594 20.616.119 4.693-.588 11.657-1.09 17.401-.224 2.548-.969 4.476-1.957 4.476h-3.905c-.988 0-1.726-1.931-1.957-4.476-.545-5.998-1.211-12.653-1.09-17.401.191-7.423 2.656-16.38 3.594-20.616.605-2.733.202-2.714.202-6.127 0-2.043-.649-2.807-.899-4.21-.129-.718.121-.987.635-1.282h2.935Z",
    fill: "#AC0061"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M350.262 245.195c.428.299.754.556.628 1.274-.242 1.401-.871 2.16-.871 4.201 0 3.413-.39 3.389.195 6.12.907 4.231 3.292 13.336 3.475 20.752.114 4.607-.547 11.552-1.011 17.236-.21 2.548-.938 4.474-1.892 4.474h-3.856c-.957 0-1.675-1.926-1.892-4.474-.505-5.92-1.128-12.577-1.012-17.236.184-7.416 2.568-16.521 3.475-20.752.586-2.731.195-2.707.195-6.12 0-2.043-.628-2.8-.871-4.201-.123-.718.122-.975.629-1.274h2.808Z",
    fill: "#AD0062"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M350.202 245.221c.422.304.743.552.622 1.27-.236 1.401-.843 2.15-.843 4.191 0 3.41-.376 3.384.188 6.112.876 4.229 3.177 13.477 3.354 20.888.107 4.521-.505 11.45-.936 17.075-.195 2.547-.904 4.471-1.828 4.471h-3.805c-.924 0-1.626-1.924-1.828-4.471-.464-5.844-1.045-12.499-.935-17.075.176-7.411 2.477-16.659 3.353-20.888.564-2.728.188-2.702.188-6.112 0-2.041-.607-2.79-.843-4.191-.121-.716.119-.963.622-1.27h2.691Z",
    fill: "#AE0062"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M350.141 245.247c.414.309.73.547.614 1.263-.226 1.398-.812 2.143-.812 4.181 0 3.406-.364 3.378.181 6.103.845 4.227 3.065 13.617 3.234 21.024.1 4.435-.461 11.345-.859 16.913-.181 2.547-.873 4.467-1.766 4.467h-3.755c-.893 0-1.578-1.92-1.766-4.467-.424-5.768-.962-12.423-.859-16.913.169-7.405 2.389-16.797 3.234-21.024.545-2.725.181-2.697.181-6.103 0-2.038-.586-2.783-.812-4.181-.116-.716.119-.954.614-1.263h2.571Z",
    fill: "#AF0063"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M350.079 245.273c.407.316.718.54.607 1.256-.219 1.398-.783 2.136-.783 4.172 0 3.403-.35 3.372.176 6.096.814 4.221 2.968 13.759 3.113 21.158.102 4.351-.422 11.241-.781 16.75-.166 2.547-.842 4.464-1.702 4.464h-3.705c-.859 0-1.528-1.917-1.702-4.464-.385-5.692-.885-12.345-.781-16.75.148-7.399 2.3-16.937 3.113-21.158.526-2.724.177-2.693.177-6.096 0-2.039-.564-2.774-.783-4.172-.112-.716.116-.942.606-1.256h2.445Z",
    fill: "#B00064"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M350.017 245.299c.4.321.707.535.6 1.251-.21 1.396-.752 2.126-.752 4.162 0 3.402-.338 3.368.169 6.089.785 4.22 2.853 13.9 2.994 21.295.095 4.264-.379 11.136-.705 16.587-.152 2.547-.809 4.46-1.637 4.46h-3.656c-.826 0-1.48-1.913-1.637-4.46-.348-5.615-.8-12.268-.705-16.587.14-7.395 2.211-17.075 2.994-21.295.507-2.721.169-2.687.169-6.089 0-2.036-.543-2.766-.752-4.162-.107-.716.114-.93.6-1.251h2.318Z",
    fill: "#B10065"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M349.955 245.325c.393.326.695.531.593 1.244-.203 1.396-.724 2.119-.724 4.155 0 3.399-.324 3.361.162 6.08.754 4.214 2.739 14.042 2.875 21.43.086 4.179-.336 11.033-.628 16.425-.138 2.548-.779 4.458-1.574 4.458h-3.605c-.795 0-1.431-1.91-1.573-4.458-.307-5.539-.717-12.189-.629-16.425.136-7.388 2.121-17.213 2.875-21.43.486-2.719.162-2.681.162-6.08 0-2.033-.521-2.759-.723-4.155-.103-.713.114-.918.592-1.244h2.197Z",
    fill: "#B20066"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M349.896 245.352c.383.333.685.523.585 1.239-.193 1.396-.695 2.112-.695 4.145 0 3.397-.312 3.356.155 6.073.723 4.212 2.625 14.182 2.753 21.565.079 4.093-.292 10.929-.552 16.262-.124 2.547-.747 4.452-1.509 4.452h-3.555c-.762 0-1.383-1.905-1.509-4.452-.269-5.464-.631-12.114-.552-16.262.13-7.383 2.03-17.353 2.753-21.565.467-2.717.155-2.676.155-6.073 0-2.033-.5-2.749-.695-4.145-.1-.714.112-.906.585-1.239h2.081Z",
    fill: "#B30066"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M349.834 245.378c.376.337.673.518.578 1.232-.186 1.394-.664 2.105-.664 4.136 0 3.394-.298 3.349.15 6.065.692 4.21 2.511 14.323 2.634 21.701.072 4.01-.242 10.824-.473 16.1-.105 2.547-.717 4.45-1.445 4.45h-3.506c-.73 0-1.339-1.903-1.444-4.45-.243-5.387-.548-12.035-.474-16.1.124-7.376 1.942-17.491 2.635-21.701.447-2.714.15-2.671.15-6.065 0-2.031-.479-2.742-.664-4.136-.095-.714.112-.895.578-1.232h1.945Z",
    fill: "#B40067"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M349.772 245.404c.369.342.661.514.571 1.225-.179 1.393-.636 2.095-.636 4.126 0 3.392-.285 3.344.143 6.058.662 4.205 2.397 14.466 2.516 21.837.064 3.924-.207 10.72-.398 15.938-.092 2.545-.683 4.445-1.382 4.445h-3.456c-.697 0-1.288-1.9-1.383-4.445-.195-5.311-.462-11.959-.397-15.938.119-7.371 1.851-17.629 2.515-21.837.426-2.711.143-2.666.143-6.058 0-2.028-.459-2.733-.635-4.126-.091-.714.109-.883.571-1.225h1.828Z",
    fill: "#B50068"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M349.76 245.418c.364.343.652.504.561 1.218-.173 1.394-.628 2.093-.628 4.122 0 3.392-.283 3.344.138 6.058.652 4.205 2.364 14.466 2.483 21.836.061 3.925-.203 10.516-.393 15.734-.093 2.545-.674 4.445-1.362 4.445h-3.405c-.688 0-1.271-1.9-1.362-4.445-.192-5.311-.454-11.754-.392-15.734.116-7.37 1.83-17.629 2.482-21.836.421-2.712.138-2.666.138-6.058 0-2.029-.452-2.728-.628-4.122-.091-.714.107-.873.561-1.218h1.807Z",
    fill: "#B50069"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M349.746 245.432c.359.343.642.495.554 1.209-.171 1.393-.619 2.088-.619 4.117 0 3.391-.281 3.344.136 6.058.643 4.205 2.332 14.466 2.449 21.836.062 3.925-.2 10.311-.386 15.529-.09 2.545-.664 4.446-1.342 4.446h-3.356c-.678 0-1.252-1.901-1.342-4.446-.188-5.311-.447-11.549-.386-15.529.117-7.37 1.807-17.629 2.449-21.836.415-2.712.134-2.667.134-6.058 0-2.029-.448-2.724-.619-4.117-.088-.714.107-.864.554-1.209h1.774Z",
    fill: "#B5006A"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M349.734 245.444c.354.343.633.486.547 1.199-.169 1.394-.612 2.084-.612 4.112 0 3.392-.278 3.345.131 6.058.633 4.206 2.302 14.466 2.416 21.837.059 3.925-.198 10.109-.381 15.327-.09 2.545-.654 4.445-1.323 4.445h-3.308c-.669 0-1.233-1.9-1.324-4.445-.185-5.311-.442-11.345-.38-15.327.114-7.371 1.782-17.629 2.415-21.837.41-2.711.129-2.666.129-6.058 0-2.028-.44-2.718-.612-4.112-.088-.713.105-.856.548-1.199h1.754Z",
    fill: "#B6006B"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M349.719 245.458c.348.343.624.476.538 1.19-.166 1.394-.602 2.079-.602 4.107 0 3.392-.276 3.344.126 6.058.624 4.205 2.271 14.466 2.383 21.837.059 3.924-.196 9.904-.374 15.122-.088 2.545-.645 4.446-1.302 4.446h-3.258c-.657 0-1.214-1.901-1.302-4.446-.183-5.311-.436-11.143-.374-15.122.112-7.371 1.759-17.629 2.383-21.837.402-2.711.126-2.666.126-6.058 0-2.028-.436-2.716-.602-4.107-.086-.714.102-.847.538-1.19h1.72Z",
    fill: "#B6006C"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M349.708 245.473c.342.342.614.468.53 1.179-.164 1.394-.595 2.074-.595 4.103 0 3.392-.273 3.344.124 6.058.614 4.205 2.237 14.466 2.349 21.837.06 3.924-.19 9.699-.369 14.918-.086 2.545-.635 4.445-1.283 4.445h-3.21c-.648 0-1.197-1.9-1.283-4.445-.181-5.312-.428-10.939-.369-14.918.11-7.371 1.735-17.629 2.351-21.837.398-2.711.122-2.666.122-6.058 0-2.029-.431-2.711-.595-4.103-.083-.713.102-.837.531-1.179h1.697Z",
    fill: "#B6006D"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M349.693 245.487c.338.343.605.459.521 1.173-.162 1.393-.585 2.069-.585 4.098 0 3.391-.271 3.344.119 6.058.604 4.205 2.206 14.465 2.316 21.836.057 3.925-.188 9.495-.365 14.714-.085 2.544-.626 4.445-1.263 4.445h-3.159c-.637 0-1.178-1.901-1.263-4.445-.179-5.312-.422-10.734-.365-14.714.11-7.371 1.714-17.629 2.319-21.836.39-2.712.116-2.667.116-6.058 0-2.029-.423-2.707-.585-4.098-.084-.714.1-.828.521-1.173h1.673Z",
    fill: "#B6006E"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M349.681 245.499c.334.343.595.45.514 1.163-.159 1.394-.578 2.065-.578 4.093 0 3.392-.269 3.345.114 6.058.595 4.206 2.176 14.466 2.283 21.837.057 3.925-.186 9.293-.357 14.511-.084 2.545-.617 4.445-1.243 4.445h-3.113c-.628 0-1.159-1.9-1.242-4.445-.176-5.311-.417-10.532-.357-14.511.107-7.371 1.69-17.629 2.285-21.837.383-2.711.112-2.666.112-6.058 0-2.028-.419-2.702-.579-4.093-.081-.713.098-.818.514-1.163h1.647Z",
    fill: "#B6006F"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M349.667 245.513c.326.343.586.44.505 1.154-.157 1.394-.572 2.059-.572 4.091 0 3.391-.266 3.344.112 6.058.586 4.205 2.145 14.465 2.249 21.836.058 3.925-.183 9.088-.352 14.307-.083 2.545-.604 4.445-1.223 4.445h-3.061c-.619 0-1.14-1.9-1.223-4.445-.171-5.311-.41-10.328-.352-14.307.104-7.371 1.666-17.629 2.251-21.836.379-2.712.107-2.667.107-6.058 0-2.029-.414-2.697-.571-4.091-.081-.714.098-.811.505-1.154h1.625Z",
    fill: "#B70070"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M349.655 245.528c.321.342.576.43.497 1.144-.154 1.393-.561 2.055-.561 4.086 0 3.392-.264 3.344.107 6.058.576 4.205 2.111 14.466 2.216 21.836.054 3.925-.179 8.884-.345 14.102-.081 2.545-.595 4.446-1.205 4.446h-3.01c-.607 0-1.124-1.901-1.205-4.446-.169-5.311-.402-10.122-.345-14.102.105-7.37 1.642-17.629 2.221-21.836.371-2.712.104-2.666.104-6.058 0-2.029-.407-2.693-.561-4.086-.079-.714.095-.802.497-1.144h1.59Z",
    fill: "#B70071"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M349.641 245.539c.316.343.566.424.488 1.135-.153 1.394-.555 2.05-.555 4.081 0 3.392-.262 3.344.105 6.058.566 4.205 2.08 14.466 2.182 21.837.055 3.924-.176 8.681-.34 13.9-.081 2.545-.585 4.445-1.183 4.445h-2.961c-.597 0-1.104-1.9-1.182-4.445-.167-5.311-.396-9.919-.341-13.9.103-7.371 1.619-17.629 2.187-21.837.367-2.711.1-2.666.1-6.058 0-2.029-.402-2.687-.554-4.081-.079-.714.093-.792.488-1.135h1.566Z",
    fill: "#B70072"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M349.629 245.554c.312.342.557.414.481 1.125-.15 1.394-.545 2.048-.545 4.076 0 3.392-.26 3.345.1 6.058.557 4.205 2.049 14.466 2.149 21.837.052 3.924-.174 8.477-.336 13.695-.078 2.545-.576 4.446-1.164 4.446h-2.91c-.588 0-1.086-1.901-1.164-4.446-.164-5.311-.388-9.716-.336-13.695.1-7.371 1.597-17.629 2.154-21.837.36-2.711.095-2.666.095-6.058 0-2.028-.395-2.682-.545-4.076-.076-.714.093-.783.481-1.125h1.54Z",
    fill: "#B70073"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M349.615 245.568c.307.342.547.404.473 1.118-.147 1.394-.538 2.043-.538 4.072 0 3.391-.257 3.344.095 6.058.548 4.205 2.019 14.465 2.116 21.836.053 3.925-.171 8.273-.328 13.491-.076 2.545-.567 4.445-1.145 4.445h-2.863c-.578 0-1.066-1.9-1.145-4.445-.162-5.311-.383-9.512-.328-13.491.097-7.371 1.573-17.629 2.12-21.836.355-2.712.091-2.667.091-6.058 0-2.029-.391-2.678-.538-4.072-.076-.714.09-.773.473-1.118h1.517Z",
    fill: "#B70074"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M349.603 245.582c.3.343.538.395.464 1.109-.145 1.393-.528 2.038-.528 4.067 0 3.392-.255 3.344.092 6.058.538 4.205 1.985 14.466 2.083 21.836.052 3.925-.167 8.068-.324 13.287-.076 2.544-.557 4.445-1.126 4.445h-2.813c-.569 0-1.049-1.901-1.125-4.445-.16-5.312-.376-9.307-.324-13.287.097-7.37 1.549-17.629 2.087-21.836.348-2.712.086-2.666.086-6.058 0-2.029-.386-2.674-.529-4.067-.073-.714.089-.764.465-1.109h1.492Z",
    fill: "#B80075"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M349.588 245.594c.296.342.529.385.457 1.099-.142 1.394-.521 2.033-.521 4.062 0 3.392-.252 3.344.088 6.058.529 4.205 1.954 14.466 2.049 21.837.05 3.924-.164 7.865-.318 13.084-.074 2.545-.548 4.445-1.105 4.445h-2.763c-.557 0-1.03-1.9-1.104-4.445-.155-5.311-.369-9.105-.319-13.084.095-7.371 1.525-17.629 2.056-21.837.34-2.711.081-2.666.081-6.058 0-2.029-.378-2.668-.521-4.062-.074-.714.088-.757.457-1.099h1.463Z",
    fill: "#B80076"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M349.576 245.608c.291.343.519.376.448 1.09-.141 1.394-.512 2.029-.512 4.057 0 3.392-.25 3.345.086 6.058.519 4.205 1.923 14.466 2.016 21.837.05 3.924-.162 7.661-.312 12.879-.074 2.545-.538 4.446-1.085 4.446h-2.714c-.547 0-1.011-1.901-1.085-4.446-.152-5.311-.362-8.9-.312-12.879.093-7.371 1.502-17.629 2.023-21.837.336-2.711.079-2.666.079-6.058 0-2.028-.374-2.666-.512-4.057-.071-.714.086-.747.448-1.09h1.432Z",
    fill: "#B80077"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M349.562 245.623c.286.342.51.368.441 1.079-.136 1.394-.505 2.024-.505 4.053 0 3.392-.248 3.344.081 6.058.509 4.205 1.89 14.466 1.982 21.837.05 3.924-.159 7.456-.307 12.675-.071 2.545-.528 4.445-1.066 4.445h-2.665c-.538 0-.993-1.9-1.067-4.445-.15-5.311-.357-8.696-.307-12.675.093-7.371 1.481-17.629 1.99-21.837.328-2.711.074-2.666.074-6.058 0-2.029-.369-2.661-.505-4.053-.069-.713.086-.737.441-1.079h1.413Z",
    fill: "#B80078"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M349.55 245.637c.281.342.5.359.431 1.073-.133 1.393-.497 2.019-.497 4.048 0 3.391-.248 3.344.076 6.058.502 4.205 1.859 14.466 1.949 21.836.048 3.925-.157 7.255-.3 12.471-.071 2.545-.516 4.445-1.045 4.445h-2.615c-.528 0-.976-1.9-1.045-4.445-.148-5.311-.35-8.491-.3-12.471.091-7.37 1.457-17.629 1.957-21.836.323-2.712.069-2.667.069-6.058 0-2.029-.362-2.657-.498-4.048-.069-.714.083-.728.431-1.073h1.387Z",
    fill: "#B80079"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M349.536 245.649c.274.342.49.349.424 1.063-.131 1.394-.488 2.014-.488 4.043 0 3.392-.245 3.344.074 6.058.492 4.205 1.827 14.466 1.915 21.837.048 3.924-.152 7.05-.295 12.268-.069 2.545-.507 4.445-1.025 4.445h-2.566c-.519 0-.957-1.9-1.026-4.445-.145-5.311-.343-8.289-.295-12.268.088-7.371 1.433-17.629 1.925-21.837.317-2.711.065-2.666.065-6.058 0-2.029-.357-2.652-.488-4.043-.067-.714.081-.718.423-1.063h1.357Z",
    fill: "#B9007A"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M349.524 245.663c.269.343.481.34.417 1.054-.129 1.394-.481 2.01-.481 4.041 0 3.391-.243 3.344.069 6.058.483 4.205 1.797 14.466 1.882 21.836.046 3.925-.149 6.846-.29 12.064-.069 2.545-.497 4.445-1.007 4.445h-2.515c-.51 0-.938-1.9-1.007-4.445-.143-5.311-.336-8.084-.29-12.064.085-7.37 1.409-17.629 1.892-21.836.312-2.712.059-2.667.059-6.058 0-2.029-.35-2.647-.481-4.041-.066-.714.081-.711.417-1.054h1.335Z",
    fill: "#B9007B"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M349.51 245.677c.264.343.471.331.407 1.045-.126 1.393-.471 2.005-.471 4.036 0 3.392-.241 3.344.064 6.058.474 4.205 1.763 14.466 1.849 21.837.045 3.924-.147 6.64-.283 11.859-.067 2.544-.488 4.445-.985 4.445h-2.466c-.497 0-.919-1.901-.985-4.445-.138-5.312-.329-7.88-.284-11.859.086-7.371 1.386-17.63 1.859-21.837.305-2.712.057-2.666.057-6.058 0-2.029-.345-2.643-.471-4.036-.064-.714.079-.702.407-1.045h1.302Z",
    fill: "#B9007C"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M349.498 245.689c.259.343.462.324.4 1.035-.124 1.394-.464 2-.464 4.031 0 3.392-.238 3.344.062 6.058.464 4.205 1.732 14.466 1.815 21.837.046 3.924-.145 6.438-.278 11.657-.064 2.545-.478 4.445-.966 4.445h-2.418c-.488 0-.902-1.9-.967-4.445-.135-5.311-.323-7.675-.278-11.657.083-7.371 1.364-17.629 1.825-21.837.3-2.711.053-2.666.053-6.058 0-2.028-.341-2.637-.464-4.031-.065-.714.076-.692.4-1.035h1.28Z",
    fill: "#B9007D"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M349.484 245.704c.252.342.452.314.39 1.027-.121 1.394-.454 1.998-.454 4.027 0 3.392-.236 3.344.057 6.058.454 4.205 1.701 14.466 1.782 21.836.043 3.925-.14 6.234-.271 11.453-.064 2.545-.469 4.445-.947 4.445h-2.368c-.479 0-.883-1.9-.948-4.445-.133-5.311-.316-7.473-.271-11.453.081-7.37 1.34-17.629 1.792-21.836.293-2.712.048-2.666.048-6.058 0-2.029-.333-2.633-.455-4.027-.062-.713.076-.683.391-1.027h1.254Z",
    fill: "#B9007E"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M349.472 245.718c.247.342.442.304.383 1.018-.119 1.394-.447 1.993-.447 4.022 0 3.391-.234 3.344.054 6.058.445 4.205 1.671 14.466 1.75 21.836.042 3.925-.138 6.03-.267 11.248-.062 2.545-.459 4.445-.926 4.445h-2.318c-.469 0-.864-1.9-.926-4.445-.131-5.311-.309-7.268-.266-11.248.081-7.37 1.316-17.629 1.761-21.836.285-2.712.043-2.667.043-6.058 0-2.029-.329-2.628-.448-4.022-.062-.714.074-.673.383-1.018h1.224Z",
    fill: "#BA007F"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M349.457 245.732c.243.342.436.295.374 1.008-.116 1.394-.44 1.989-.44 4.018 0 3.391-.231 3.344.05 6.058.435 4.205 1.637 14.465 1.716 21.836.04 3.925-.136 5.825-.262 11.043-.062 2.545-.45 4.446-.907 4.446h-2.268c-.459 0-.845-1.901-.907-4.446-.128-5.311-.302-7.064-.261-11.043.078-7.371 1.292-17.629 1.727-21.836.281-2.712.038-2.667.038-6.058 0-2.029-.323-2.624-.44-4.018-.059-.713.072-.666.374-1.008h1.206Z",
    fill: "#BA0080"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M349.446 245.744c.238.342.426.285.366.999-.114 1.394-.431 1.983-.431 4.012 0 3.392-.228 3.344.046 6.058.426 4.205 1.606 14.466 1.682 21.837.041 3.924-.133 5.623-.254 10.841-.06 2.545-.441 4.445-.888 4.445h-2.221c-.447 0-.828-1.9-.887-4.445-.126-5.311-.298-6.862-.255-10.841.076-7.371 1.269-17.629 1.695-21.837.273-2.711.035-2.666.035-6.058 0-2.029-.316-2.621-.431-4.012-.059-.714.072-.657.367-.999h1.176Z",
    fill: "#BA0081"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M349.431 245.758c.234.343.417.279.36.99-.112 1.394-.424 1.979-.424 4.007 0 3.392-.226 3.345.043 6.058.417 4.206 1.576 14.466 1.649 21.837.041 3.925-.128 5.418-.25 10.637-.059 2.545-.428 4.445-.868 4.445h-2.171c-.438 0-.809-1.9-.868-4.445-.122-5.312-.291-6.658-.25-10.637.073-7.371 1.247-17.629 1.661-21.837.269-2.711.031-2.666.031-6.058 0-2.028-.312-2.616-.424-4.007-.057-.714.069-.647.36-.99h1.151Z",
    fill: "#BA0081"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M349.419 245.772c.227.343.407.269.35.983-.109 1.394-.414 1.974-.414 4.003 0 3.391-.224 3.344.038 6.058.407 4.205 1.545 14.465 1.616 21.836.038 3.925-.126 5.214-.242 10.432-.058 2.545-.419 4.446-.848 4.446h-2.12c-.429 0-.79-1.901-.848-4.446-.119-5.311-.283-6.452-.242-10.432.073-7.371 1.223-17.629 1.628-21.836.261-2.712.026-2.667.026-6.058 0-2.029-.305-2.612-.414-4.003-.055-.714.066-.638.349-.983h1.121Z",
    fill: "#BA0082"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M349.405 245.784c.222.343.398.26.343.973-.107 1.394-.407 1.97-.407 3.998 0 3.392-.221 3.345.033 6.058.398 4.205 1.512 14.466 1.583 21.837.038 3.924-.124 5.011-.238 10.23-.057 2.545-.409 4.445-.828 4.445h-2.071c-.419 0-.771-1.9-.828-4.445-.117-5.311-.276-6.248-.238-10.23.071-7.371 1.199-17.629 1.597-21.837.257-2.711.021-2.666.021-6.058 0-2.028-.3-2.606-.407-3.998-.054-.713.067-.628.343-.973h1.097Z",
    fill: "#BB0083"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M349.393 245.799c.217.342.388.249.334.963-.105 1.394-.398 1.964-.398 3.993 0 3.392-.219 3.344.031 6.058.388 4.205 1.48 14.466 1.549 21.837.038 3.924-.121 4.807-.233 10.025-.055 2.545-.4 4.445-.809 4.445h-2.023c-.409 0-.755-1.9-.809-4.445-.115-5.311-.269-6.046-.234-10.025.07-7.371 1.176-17.629 1.564-21.837.25-2.711.017-2.666.017-6.058 0-2.029-.295-2.602-.398-3.993-.052-.714.065-.621.334-.963h1.075Z",
    fill: "#BB0084"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M349.379 245.813c.212.342.378.24.326.954-.102 1.394-.39 1.96-.39 3.991 0 3.392-.217 3.344.026 6.058.378 4.205 1.449 14.466 1.516 21.836.036 3.925-.117 4.603-.226 9.821-.053 2.545-.39 4.445-.788 4.445h-1.973c-.397 0-.735-1.9-.788-4.445-.112-5.311-.264-5.841-.226-9.821.069-7.37 1.152-17.629 1.531-21.836.242-2.712.014-2.666.014-6.058 0-2.029-.288-2.597-.391-3.991-.052-.714.062-.612.327-.954h1.042Z",
    fill: "#BB0085"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M349.367 245.827c.205.343.369.233.317.944-.098 1.394-.381 1.955-.381 3.987 0 3.391-.214 3.344.024 6.058.369 4.205 1.418 14.465 1.482 21.836.036 3.925-.114 4.398-.221 9.616-.052 2.545-.381 4.446-.769 4.446h-1.923c-.388 0-.716-1.901-.768-4.446-.11-5.311-.258-5.636-.222-9.616.067-7.371 1.131-17.629 1.497-21.836.238-2.712.01-2.667.01-6.058 0-2.029-.283-2.593-.381-3.987-.05-.713.062-.601.316-.944h1.019Z",
    fill: "#BB0086"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M349.353 245.839c.2.343.359.224.309.935-.095 1.394-.373 1.953-.373 3.981 0 3.392-.212 3.345.019 6.058.359 4.205 1.385 14.466 1.449 21.837.033 3.924-.112 4.196-.217 9.414-.049 2.545-.371 4.445-.749 4.445h-1.871c-.378 0-.697-1.9-.75-4.445-.104-5.311-.249-5.435-.216-9.414.064-7.371 1.107-17.629 1.466-21.837.231-2.711.005-2.666.005-6.058 0-2.028-.279-2.587-.374-3.981-.05-.714.06-.592.309-.935h.993Z",
    fill: "#BB0087"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M349.341 245.853c.195.343.35.214.302.928-.093 1.394-.366 1.948-.366 3.977 0 3.391-.21 3.344.014 6.058.35 4.205 1.354 14.465 1.416 21.836.033 3.925-.109 3.991-.209 9.21-.05 2.545-.362 4.445-.729 4.445h-1.825c-.369 0-.681-1.9-.728-4.445-.103-5.311-.243-5.231-.21-9.21.062-7.371 1.083-17.629 1.433-21.836.226-2.712 0-2.667 0-6.058 0-2.029-.271-2.583-.367-3.977-.047-.714.058-.583.303-.928h.966Z",
    fill: "#BC0088"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M349.327 245.868c.19.342.34.204.292.918-.09 1.394-.357 1.943-.357 3.972 0 3.391-.207 3.344.012 6.058.341 4.205 1.324 14.466 1.385 21.836.034 3.925-.104 3.787-.204 9.005-.048 2.545-.353 4.446-.71 4.446h-1.775c-.359 0-.662-1.901-.709-4.446-.1-5.311-.238-5.025-.205-9.005.062-7.37 1.059-17.629 1.4-21.836.218-2.712-.005-2.667-.005-6.058 0-2.029-.267-2.578-.357-3.972-.048-.714.057-.573.293-.918h.94Z",
    fill: "#BC0089"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M349.315 245.879c.185.343.331.195.285.909-.088 1.394-.35 1.938-.35 3.967 0 3.392-.204 3.344.008 6.058.33 4.205 1.292 14.466 1.351 21.837.031 3.924-.102 3.584-.197 8.8-.048 2.545-.34 4.446-.69 4.446h-1.726c-.347 0-.642-1.901-.69-4.446-.098-5.311-.231-4.821-.198-8.8.06-7.371 1.036-17.629 1.367-21.837.214-2.711-.008-2.666-.008-6.058 0-2.029-.259-2.573-.349-3.967-.046-.714.054-.566.285-.909h.912Z",
    fill: "#BC008A"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M349.3 245.894c.179.342.322.185.277.899-.086 1.394-.341 1.934-.341 3.962 0 3.392-.202 3.344.005 6.058.321 4.205 1.259 14.466 1.318 21.837.031 3.924-.1 3.38-.192 8.598-.046 2.545-.331 4.445-.671 4.445h-1.676c-.338 0-.626-1.9-.671-4.445-.095-5.311-.224-4.619-.193-8.598.057-7.371 1.014-17.629 1.333-21.837.207-2.711-.012-2.666-.012-6.058 0-2.028-.255-2.571-.34-3.962-.046-.714.052-.557.276-.899h.887Z",
    fill: "#BC008B"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M349.289 245.908c.173.342.311.178.268.89-.083 1.393-.333 1.928-.333 3.957 0 3.392-.202 3.344 0 6.058.312 4.205 1.228 14.466 1.285 21.837.031 3.924-.097 3.175-.188 8.393-.042 2.545-.321 4.446-.649 4.446h-1.626c-.328 0-.607-1.901-.65-4.446-.092-5.311-.216-4.414-.188-8.393.058-7.371.99-17.629 1.302-21.837.2-2.711-.016-2.666-.016-6.058 0-2.029-.25-2.566-.334-3.957-.042-.714.053-.548.269-.89h.86Z",
    fill: "#BC008C"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M349.274 245.922c.169.343.303.169.26.883-.081 1.394-.324 1.924-.324 3.953 0 3.391-.2 3.344-.005 6.058.303 4.205 1.197 14.466 1.252 21.836.029 3.925-.095 2.971-.181 8.189-.043 2.545-.311 4.446-.63 4.446h-1.578c-.319 0-.588-1.901-.631-4.446-.088-5.311-.212-4.209-.181-8.189.055-7.37.966-17.629 1.269-21.836.195-2.712-.022-2.667-.022-6.058 0-2.029-.243-2.562-.323-3.953-.041-.714.049-.538.259-.883h.835Z",
    fill: "#BD008D"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M349.262 245.934c.165.343.293.16.253.873-.079 1.394-.317 1.92-.317 3.948 0 3.392-.197 3.345-.007 6.058.293 4.206 1.166 14.466 1.218 21.837.029 3.925-.09 2.769-.176 7.987-.04 2.545-.302 4.445-.611 4.445h-1.528c-.31 0-.569-1.9-.612-4.445-.086-5.311-.205-4.005-.176-7.987.052-7.371.942-17.629 1.235-21.837.188-2.711-.026-2.666-.026-6.058 0-2.028-.238-2.556-.317-3.948-.04-.713.048-.528.253-.873h.811Z",
    fill: "#BD008E"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M349.248 245.948c.157.343.283.15.245.864-.076 1.394-.307 1.915-.307 3.946 0 3.391-.195 3.344-.012 6.058.284 4.205 1.133 14.466 1.186 21.836.026 3.925-.089 2.564-.169 7.783-.041 2.545-.293 4.445-.591 4.445h-1.478c-.297 0-.552-1.9-.59-4.445-.083-5.311-.197-3.803-.169-7.783.05-7.37.919-17.629 1.202-21.836.183-2.712-.031-2.667-.031-6.058 0-2.029-.233-2.552-.307-3.946-.038-.714.048-.521.245-.864h.776Z",
    fill: "#BD008F"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M349.236 245.963c.153.342.274.14.236.854-.074 1.393-.3 1.909-.3 3.941 0 3.391-.193 3.344-.017 6.058.274 4.205 1.102 14.465 1.152 21.836.026 3.925-.085 2.36-.164 7.578-.038 2.545-.283 4.445-.571 4.445h-1.428c-.288 0-.533-1.9-.571-4.445-.081-5.311-.191-3.599-.165-7.578.05-7.371.898-17.629 1.171-21.836.176-2.712-.033-2.667-.033-6.058 0-2.029-.226-2.548-.3-3.941-.038-.714.045-.512.236-.854h.754Z",
    fill: "#BD0090"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M349.222 245.975c.148.342.264.133.228.844-.071 1.394-.292 1.905-.292 3.936 0 3.392-.191 3.344-.019 6.058.264 4.205 1.071 14.466 1.118 21.837.026 3.924-.083 2.155-.159 7.373-.038 2.545-.274 4.446-.552 4.446h-1.381c-.278 0-.514-1.901-.552-4.446-.078-5.311-.183-3.394-.159-7.373.047-7.371.873-17.629 1.137-21.837.172-2.711-.038-2.666-.038-6.058 0-2.029-.221-2.542-.293-3.936-.035-.714.043-.502.229-.844h.733Z",
    fill: "#BD0091"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M349.21 245.989c.143.343.255.124.219.837-.069 1.394-.283 1.903-.283 3.932 0 3.392-.188 3.344-.024 6.058.255 4.205 1.04 14.466 1.085 21.836.024 3.925-.078 1.953-.152 7.172-.036 2.544-.264 4.445-.531 4.445h-1.33c-.269 0-.495-1.901-.531-4.445-.074-5.312-.178-3.192-.152-7.172.045-7.37.849-17.629 1.104-21.836.164-2.712-.043-2.666-.043-6.058 0-2.029-.214-2.538-.283-3.932-.036-.713.043-.492.219-.837h.702Z",
    fill: "#BE0092"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M349.196 246.003c.138.343.245.114.212.828-.067 1.394-.276 1.898-.276 3.927 0 3.391-.186 3.344-.027 6.058.246 4.205 1.007 14.465 1.052 21.836.024 3.925-.076 1.749-.147 6.967-.036 2.545-.252 4.445-.512 4.445h-1.28c-.26 0-.479-1.9-.512-4.445-.071-5.311-.171-2.987-.148-6.967.046-7.371.826-17.629 1.071-21.836.157-2.712-.047-2.667-.047-6.058 0-2.029-.21-2.533-.276-3.927-.034-.714.04-.483.212-.828h.678Z",
    fill: "#BE0093"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M349.184 246.018c.131.342.235.104.202.818-.064 1.394-.266 1.893-.266 3.922 0 3.392-.184 3.344-.031 6.058.235 4.205.975 14.466 1.018 21.836.022 3.925-.074 1.544-.14 6.762-.033 2.545-.243 4.446-.493 4.446h-1.23c-.248 0-.46-1.901-.493-4.446-.069-5.311-.164-2.782-.14-6.762.043-7.37.802-17.629 1.037-21.836.153-2.712-.052-2.666-.052-6.058 0-2.029-.205-2.528-.267-3.922-.033-.714.039-.476.203-.818h.652Z",
    fill: "#BE0094"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M349.17 246.029c.126.343.226.095.195.809-.06 1.394-.26 1.888-.26 3.917 0 3.392-.181 3.344-.035 6.058.226 4.205.944 14.466.985 21.837.021 3.924-.071 1.341-.136 6.56-.031 2.545-.233 4.445-.471 4.445h-1.18c-.238 0-.441-1.9-.472-4.445-.066-5.311-.157-2.579-.135-6.56.04-7.371.778-17.629 1.006-21.837.146-2.711-.054-2.666-.054-6.058 0-2.029-.198-2.526-.26-3.917-.031-.714.038-.466.195-.809h.622Z",
    fill: "#BE0095"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M349.158 246.044c.121.342.216.088.188.799-.057 1.394-.25 1.884-.25 3.912 0 3.392-.179 3.345-.038 6.058.216 4.206.911 14.466.952 21.837.021 3.925-.067 1.137-.131 6.355-.031 2.545-.224 4.446-.452 4.446h-1.133c-.229 0-.421-1.901-.452-4.446-.065-5.311-.153-2.376-.131-6.355.038-7.371.757-17.629.973-21.837.141-2.711-.059-2.666-.059-6.058 0-2.028-.193-2.521-.25-3.912-.029-.714.035-.457.188-.799h.595Z",
    fill: "#BE0096"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M349.143 246.058c.117.342.207.078.179.792-.055 1.394-.243 1.879-.243 3.908 0 3.391-.176 3.344-.043 6.058.207 4.205.881 14.465.919 21.836.019 3.925-.064.933-.124 6.151-.028 2.545-.214 4.445-.433 4.445h-1.083c-.219 0-.404-1.9-.433-4.445-.062-5.311-.145-2.171-.124-6.151.038-7.371.733-17.629.94-21.836.134-2.712-.064-2.667-.064-6.058 0-2.029-.188-2.517-.243-3.908-.028-.714.034-.447.179-.792h.573Z",
    fill: "#BF0097"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M349.131 246.07c.11.342.198.069.172.782-.053 1.394-.236 1.875-.236 3.903 0 3.392-.174 3.345-.045 6.058.197 4.205.85 14.466.885 21.837.019 3.924-.062.728-.119 5.946-.028 2.545-.204 4.446-.414 4.446h-1.033c-.209 0-.385-1.901-.414-4.446-.057-5.311-.138-1.967-.119-5.946.036-7.371.709-17.629.907-21.837.128-2.711-.069-2.666-.069-6.058 0-2.028-.181-2.511-.236-3.903-.026-.713.034-.437.172-.782h.549Z",
    fill: "#BF0098"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M349.117 246.084c.105.342.188.059.162.773-.05 1.394-.226 1.869-.226 3.898 0 3.392-.171 3.344-.05 6.058.188 4.205.819 14.466.852 21.837.019 3.924-.06.526-.114 5.744-.026 2.545-.195 4.445-.393 4.445h-.983c-.197 0-.366-1.9-.393-4.445-.054-5.311-.13-1.765-.114-5.744.033-7.371.686-17.629.874-21.837.121-2.711-.074-2.666-.074-6.058 0-2.029-.176-2.507-.226-3.898-.026-.714.031-.431.162-.773h.523Z",
    fill: "#BF0099"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1989_1050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 775.982,
    y: 214.477,
    width: 65.9128,
    height: 60.7767,
    transform: "rotate(-0.922495 775.982 214.477)",
    fill: "#908ACF"
  }))), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M800.783 234.24h16.482v32.214h-16.482V234.24Z",
    fill: "#353447"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M803.281 225h11.487l2.497 9.24h-16.482l2.498-9.24Z",
    fill: "#48475D"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M802.531 236.237h13.485v2.747h-13.485v-2.747Z",
    fill: "#0B0B10"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 263.457h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 263.457h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 263.457h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 263.457h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 263.457h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 263.457h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 264.456h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 264.456h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 264.456h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 264.456h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 264.456h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 264.456h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 263.956h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 263.956h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 263.956h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 263.956h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 263.956h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 263.956h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.28 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.778 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.274 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.769 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 264.706h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 264.706h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 263.707h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 263.707h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 264.206h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 264.206h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 261.959h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 261.959h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 261.959h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 261.959h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 261.959h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 261.959h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 262.958h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 262.958h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 262.958h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 262.958h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 262.958h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 262.958h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.032 262.458h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.531 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.031 262.458h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.53 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.03 262.458h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.529 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.029 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.528 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.027 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.527 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.026 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.526 262.458h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.025 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.524 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.024 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.523 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.023 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.522 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.022 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.521 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.021 262.458h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.52 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.019 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.519 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.018 262.458h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.28 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.778 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.274 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.769 261.709h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 261.709h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 263.208h.249v.249h-.249v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 263.208h.25v.249h-.25v-.249Z",
    fill: "#18171E"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.276 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 262.208h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 262.208h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.782 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.282 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.781 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.28 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.78 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.279 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.779 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.278 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.777 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.277 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.776 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.275 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.775 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.275 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.774 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.273 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.773 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.272 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.772 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.271 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.771 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.271 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.77 262.708h.249v.25h-.249v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.269 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.768 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.268 262.708h.25v.25h-.25v-.25Z",
    fill: "#18171E"
  }))), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M815.517 238.11a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z",
    fill: "#FF375B"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M815.517 237.111a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z",
    fill: "#2FD60A"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.891 240.982h-13.235v-.25h13.235v.25Z",
    fill: "#565570"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.891 243.23h-13.235v-.25h13.235v.25Z",
    fill: "#565570"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.891 245.477h-13.235v-.25h13.235v.25Z",
    fill: "#565570"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.891 247.725h-13.235v-.25h13.235v.25Z",
    fill: "#565570"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.891 250.222h-13.235v-.25h13.235v.25Z",
    fill: "#0B0B10"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M813.269 250.097c0 .207-1.844.375-4.12.375s-4.12-.168-4.12-.375 1.844-.375 4.12-.375 4.12.168 4.12.375Z",
    fill: "#0B0B10"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M810.273 254.966a.999.999 0 1 1-1.997 0 .999.999 0 0 1 1.997 0Z",
    fill: "black"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M809.274 254.092a.874.874 0 1 0 0 1.749.874.874 0 0 0 0-1.749Zm-1.124.875a1.124 1.124 0 1 1 2.249 0 1.124 1.124 0 0 1-2.249 0Z",
    fill: "black"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1989_1050)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 808.097,
    cy: 214.455,
    r: 2.56803,
    transform: "rotate(6.51456 808.097 214.455)",
    fill: "#FFA800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 808.098,
    cy: 214.455,
    r: 1.71202,
    transform: "rotate(6.51456 808.098 214.455)",
    stroke: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M252.457 257.597c.09-1.019.224-2.059.564-3.04.263-1.244.822-2.412 1.527-3.592.45-.751.879-1.591.328-2.38-.366-.513-1.021-.808-1.701-.975-3.477-.872-7.122.167-10.663.109l-1.2.135c-2.413-.263-5.095-.61-5.64-.783-3.253-1.013-4.453-2.45-7.937-3.021-3.343-.545-5.652-.379-8.469 1.187-1.296.718-2.38 2.296-1.238 3.175.577.449 1.462.455 2.265.455 4.439.013 6.473 1.02 8.591 4.208.911 1.366 1.155 2.957 1.289 4.51 1.091 12.495-3.586 24.824-4.715 37.32-.148 1.603-.154 3.399 1.161 4.599 1.001.911 2.541 1.251 4.004 1.514a80.453 80.453 0 0 0 10.689 1.167 81.464 81.464 0 0 0 10.689-1.167c1.463-.263 3.003-.603 4.004-1.514 1.315-1.2 1.309-2.989 1.161-4.599-1.123-12.483-5.8-24.812-4.709-37.308Z",
    fill: "#54C4F1"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M263.839 254.204c-1.642-1.174-3.792-1.507-5.774-1.135-3.17.59-5.935 3.002-6.955 6.061-.321.956-.706 2.059-.713 3.067 0 .66.193 1.443.815 1.661.424.147.911-.045 1.206-.379.296-.333.437-.782.507-1.225.167-1.071-.019-2.181.238-3.233.462-1.86 2.207-3.117 3.991-3.816 1.154-.456 2.463-.744 3.618-.302 1.001.385 1.733 1.257 2.323 2.155.481.738.905 1.527 1.136 2.38.68 2.534-.411 5.177-1.572 7.525-3.189 6.44-7.963 12.861-7.899 20.045.007.654.757 1.129 1.399 1.007.642-.122 1.129-.68 1.36-1.295.231-.61.251-1.277.295-1.931.161-2.54.661-5.068 1.637-7.416 1.103-2.662 2.797-5.035 4.298-7.498 1.502-2.463 2.843-5.119 3.125-7.993.276-2.867-.686-6.004-3.035-7.678Z",
    fill: "#54C4F1"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M255.973 255.205c-1.778.705-3.529 1.963-3.991 3.816-.263 1.052-.071 2.162-.238 3.233-.07.443-.205.892-.506 1.226a1.33 1.33 0 0 1-.289.237c.077.058.16.109.256.141.424.148.912-.045 1.207-.378.295-.334.436-.783.507-1.226.166-1.071-.02-2.181.237-3.233.462-1.86 2.207-3.117 3.991-3.816.558-.218 1.155-.404 1.758-.481-.969-.141-2.002.115-2.932.481Z",
    fill: "#51AEF4"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M263.839 254.204c-1.38-.981-3.118-1.373-4.819-1.257 1.303.096 2.58.5 3.638 1.257 2.349 1.674 3.311 4.811 3.029 7.685-.283 2.867-1.624 5.523-3.125 7.992-1.501 2.464-3.189 4.837-4.299 7.499-.975 2.348-1.476 4.882-1.636 7.415-.045.655-.064 1.322-.295 1.931-.18.488-.526.937-.982 1.161.244.128.533.18.802.128.642-.121 1.129-.68 1.36-1.295.231-.61.251-1.277.296-1.931.16-2.54.66-5.068 1.636-7.415 1.103-2.662 2.797-5.036 4.299-7.499 1.501-2.463 2.842-5.119 3.124-7.993.283-2.867-.68-6.004-3.028-7.678Z",
    fill: "#51AEF4"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M252.457 257.598c.09-1.02.225-2.059.565-3.041.263-1.244.821-2.412 1.527-3.592.449-.751.879-1.591.327-2.38-.366-.513-1.02-.808-1.7-.975-2.207-.552-4.479-.34-6.75-.122-.642 1.61-1.046 3.4-1.36 5.029-.931 4.76-.283 9.199-.283 13.952.905 7.576 3.048 14.946 4.158 22.496.244 1.668.43 3.413-.154 4.991-1.033 2.803-4.132 4.233-7.032 4.945a30.585 30.585 0 0 1-7.199.879c-2.297.006-4.786-.34-6.416-1.956-1.829-1.816-2.028-4.664-2.021-7.243 0-.327.006-.66.006-.987a82.772 82.772 0 0 0-.667 5.324c-.148 1.603-.154 3.399 1.161 4.599 1.001.911 2.541 1.251 4.004 1.514a80.453 80.453 0 0 0 10.689 1.167 81.48 81.48 0 0 0 10.69-1.167c1.463-.263 3.002-.603 4.003-1.514 1.316-1.2 1.309-2.989 1.162-4.599-1.123-12.496-5.801-24.825-4.71-37.32Z",
    fill: "#54B9F7"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M230.205 250.208c-.577-.687-1.411-1.091-2.245-1.412a18.95 18.95 0 0 0-9.246-1.135 9.355 9.355 0 0 0-1.11.199c.071.205.205.391.417.558.578.449 1.463.455 2.265.455 4.44.013 6.474 1.02 8.591 4.208.911 1.367 1.155 2.957 1.29 4.51.09 1.013.141 2.027.154 3.04.609-2.469 1.078-4.958.879-7.473-.084-1.045-.315-2.142-.995-2.95Z",
    fill: "#54B9F7"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M253.175 247.61c-3.477-.872-7.122.167-10.663.109-3.741-.071-6.295-.475-6.84-.648-3.253-1.013-4.453-2.45-7.937-3.021-3.343-.545-5.652-.379-8.469 1.187-1.296.718-2.38 2.296-1.238 3.175.045.032.089.064.141.096a2.299 2.299 0 0 0 .481-.77c1.02-2.649 5.094-2.713 7.905-2.29 2.81.424 5.421 1.649 8.078 2.643 3.894 1.456 8.11 2.438 12.21 1.713 1.36-.238 2.694-.667 4.074-.719 1.379-.057 2.874.334 3.721 1.424.032.045.071.09.103.135.366-.661.616-1.379.135-2.053-.366-.519-1.027-.808-1.701-.981Z",
    fill: "#2DA1F7"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M249.492 259.669a85.77 85.77 0 0 0 1.021 16.518c1.084 6.799 2.99 13.682 1.77 20.456-.089.513-.211 1.046-.551 1.437-.372.43-.944.622-1.489.802-2.554.821-4.754 1.456-7.481 1.559l5.697-.212c1.662-.064 3.472-.173 4.729-1.264 1.007-.872 1.469-2.232 1.534-3.56.064-1.328-.225-2.643-.501-3.945a263.429 263.429 0 0 1-4.729-31.791Z",
    fill: "#51AEF4"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M238.251 261.061c-.199-1.212-.603-3.444-2.22-3.579-1.847-.154-2.232 1.976-2.284 3.259a120.18 120.18 0 0 1-3.253 23.811c-.359 1.488-.744 2.982-.757 4.509-.013 1.527.391 3.118 1.444 4.259 1.469 1.604 3.875 2.04 6.095 2.066 1.649.019 3.555-.289 4.376-1.662.404-.673.455-1.481.481-2.257.167-5.408-.699-10.796-1.565-16.146-.777-4.753-1.547-9.506-2.317-14.26Z",
    fill: "#54D2EF"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M252.842 270.555a82.088 82.088 0 0 1-7.636.545c-5.222.134-10.445-.154-15.636-.5-.019.115-.032.224-.051.339 2.194.154 4.388.302 6.589.404 5.281.244 10.613.256 15.855-.301.359-.039.712-.077 1.071-.122-.019-.128-.038-.256-.058-.378a.857.857 0 0 0-.134.013Z",
    fill: "#2DA1F7"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M232.105 271.819c-.898-.071-1.79-.148-2.682-.238-.064.417-.128.828-.199 1.245 4.382.436 8.809.641 13.237.609a122.5 122.5 0 0 0 10.875-.584 76.54 76.54 0 0 1-.199-1.244c-6.949.693-14.051.75-21.032.212Z",
    fill: "#2DA1F7"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M244.732 262.94c-4.812.109-9.65.122-14.45-.179 0 .109-.006.218-.012.327 1.982.128 3.971.198 5.967.237 4.998.09 10.092.064 15.058-.34.328-.025.655-.058.982-.09-.006-.115-.006-.237-.006-.352-2.496.243-5.031.34-7.539.397Z",
    fill: "#2DA1F7"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M230.289 260.741c.006.423.006.84 0 1.263 1.764.122 3.529.212 5.3.27 5.1.179 10.227.09 15.289-.398.462-.045.924-.096 1.38-.148 0-.429 0-.853.013-1.282-7.231.853-14.674.795-21.982.295Z",
    fill: "#2DA1F7"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M235.005 271.1c-.032-.057-.058-.115-.09-.173l-.115.173h.205Z",
    fill: "#2DA1F7"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M241.408 271.286c-.051-.07-.102-.147-.154-.218-.025.084-.057.167-.083.251.083-.007.16-.02.237-.033Z",
    fill: "#2DA1F7"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M232.368 266.354c.032.064.064.134.102.199.032-.065.058-.135.09-.199h-.192Z",
    fill: "#2DA1F7"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M247.555 271.1c-.058-.07-.11-.147-.167-.218-.039.071-.071.148-.116.218h.283Z",
    fill: "#2DA1F7"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M249.268 265.93a24.219 24.219 0 0 0-1.008 2.431c-.288.84-.474 1.726-.879 2.521.058.071.109.148.167.218h-.282l.115-.218a59.899 59.899 0 0 0-3.682-4.388c-.065-.07-.167-.038-.212.026a16.798 16.798 0 0 0-2.233 4.542c.051.07.103.147.154.218-.077.013-.16.019-.237.032.025-.084.051-.167.083-.25-1.072-1.508-2.137-3.022-3.208-4.529-.051-.077-.161-.083-.212 0-.969 1.462-1.944 2.925-2.913 4.388.032.057.058.115.09.173h-.199l.116-.173c-.79-1.566-1.579-3.124-2.362-4.69-.032-.07-.153-.077-.192 0-.667 1.495-1.328 3.009-1.829 4.568-.019.057.071.096.097.038.628-1.424 1.199-2.874 1.835-4.291-.032-.064-.064-.135-.103-.199h.192c-.032.064-.057.135-.089.199.782 1.552 1.559 3.111 2.342 4.663.038.084.154.071.198 0l2.939-4.4c-.038-.052-.07-.103-.109-.154h.212c-.032.051-.071.102-.103.154 1.078 1.533 2.162 3.066 3.24 4.599.064.09.206.083.238-.032a16.384 16.384 0 0 1 2.2-4.574c-.038-.038-.077-.083-.115-.122.07-.006.141-.019.212-.025a2.582 2.582 0 0 1-.103.154 52.814 52.814 0 0 1 3.651 4.451c.07.097.212.116.282 0 .436-.744.642-1.571.911-2.379.315-.95.687-1.873 1.117-2.778.089-.199-.219-.378-.321-.173Z",
    fill: "#2DA1F7"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M243.513 266.687c.038.038.077.083.115.122.032-.051.064-.103.103-.154-.077.019-.148.025-.218.032Z",
    fill: "#2DA1F7"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M237.834 266.661c.039.052.071.103.109.154.033-.051.071-.102.103-.154h-.212Z",
    fill: "#2DA1F7"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M252.149 269.618a20.64 20.64 0 0 0-.809-1.199c-.532-.725-1.277-1.366-1.61-2.213-.084-.212-.424-.122-.347.096.289.763.847 1.328 1.335 1.969.269.353.526.719.77 1.084.25.372.718.886.795 1.328.045.257.43.148.392-.109-.064-.34-.34-.661-.526-.956Z",
    fill: "#2DA1F7"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "m232.708 263.3.096.193c.039-.064.084-.128.122-.193h-.218Z",
    fill: "#2DA1F7"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M240.606 267.521c-.051-.09-.109-.18-.166-.276a3.44 3.44 0 0 0-.122.276h.288Z",
    fill: "#2DA1F7"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M246.83 267.406c-.058-.109-.122-.212-.18-.315-.045.103-.096.212-.141.315h.321Z",
    fill: "#2DA1F7"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M235.082 267.348a8.962 8.962 0 0 0-.205-.417c-.045.154-.084.308-.122.462.109-.019.218-.032.327-.045Z",
    fill: "#2DA1F7"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "m249.422 263.14.154.212.154-.174a36.898 36.898 0 0 1-.308-.038Z",
    fill: "#2DA1F7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "m251.084 264.782-1.322-1.841c-.071-.096-.212-.141-.308-.039a15.084 15.084 0 0 0-2.804 4.189l.18.315h-.328c.045-.11.097-.212.142-.315a23.466 23.466 0 0 0-2.939-4.022c-.064-.07-.18-.064-.25 0a13.525 13.525 0 0 0-3.022 4.17c.057.09.109.179.167.276h-.289c.038-.09.083-.186.122-.276a27.434 27.434 0 0 0-3.196-4.304c-.051-.058-.173-.065-.224 0-.975 1.161-1.726 2.521-2.143 3.983.07.141.135.282.205.417-.109.013-.218.026-.327.045.038-.154.077-.308.122-.462a63.587 63.587 0 0 0-1.957-3.753c-.045-.083-.167-.076-.218 0-.834 1.373-1.72 2.727-2.477 4.144-.013.02.019.032.032.02.905-1.238 1.707-2.553 2.541-3.849a34.777 34.777 0 0 1-.096-.193h.218c-.039.065-.083.129-.122.193a153.553 153.553 0 0 1 1.976 4.035c.064.141.289.096.327-.045.379-1.553 1.033-2.951 2.041-4.183l-.116-.134h.225c-.039.045-.071.089-.109.134a26.734 26.734 0 0 1 3.176 4.388c.058.103.237.115.289 0a13.321 13.321 0 0 1 2.97-4.24 2.11 2.11 0 0 0-.115-.128h.25c-.045.045-.09.083-.135.128a22.513 22.513 0 0 1 2.926 4.144c.064.115.269.134.327 0a15.203 15.203 0 0 1 2.746-4.247l-.154-.211.308.038-.154.173c.411.578.828 1.148 1.239 1.726.423.59.808 1.231 1.341 1.725.102.097.231-.025.179-.141-.301-.66-.808-1.251-1.244-1.86Z",
    fill: "#2DA1F7"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "m237.019 263.166.116.134c.038-.045.07-.09.109-.134h-.225Z",
    fill: "#2DA1F7"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M243.461 263.319c.039.045.077.084.116.129.045-.045.09-.09.135-.129h-.251Z",
    fill: "#2DA1F7"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M232.22 269.214c-.571 0-.571.885 0 .885.571.006.571-.885 0-.885Z",
    fill: "#2DA1F7"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "m237.822 269.67-.084-.064a.421.421 0 0 0-.385-.02.325.325 0 0 0-.135.09.374.374 0 0 0-.089.135.348.348 0 0 0-.039.166.654.654 0 0 1 .013.116.42.42 0 0 0 .109.185l.083.065a.436.436 0 0 0 .219.057.38.38 0 0 0 .166-.038.304.304 0 0 0 .135-.09.364.364 0 0 0 .09-.135.347.347 0 0 0 .038-.166c-.006-.039-.012-.077-.012-.116a.43.43 0 0 0-.109-.185Z",
    fill: "#2DA1F7"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M243.634 269.74c-.442 0-.449.692 0 .692.443 0 .443-.692 0-.692Z",
    fill: "#2DA1F7"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M250.044 269.439a2.611 2.611 0 0 0-.083-.064.4.4 0 0 0-.212-.058.355.355 0 0 0-.16.038.325.325 0 0 0-.135.09.4.4 0 0 0-.09.135.352.352 0 0 0-.038.16c.006.038.013.077.013.109a.42.42 0 0 0 .109.186l.083.064a.408.408 0 0 0 .212.057.34.34 0 0 0 .16-.038.304.304 0 0 0 .135-.09.382.382 0 0 0 .09-.134.36.36 0 0 0 .038-.161c-.006-.038-.013-.076-.013-.108a.442.442 0 0 0-.109-.186Z",
    fill: "#2DA1F7"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M234.504 264.006c-.462 0-.462.711 0 .711.456 0 .456-.711 0-.711Z",
    fill: "#2DA1F7"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "m240.555 264.23-.084-.064a.394.394 0 0 0-.365-.026.35.35 0 0 0-.135.084.294.294 0 0 0-.084.134.287.287 0 0 0-.032.16c.007.039.013.071.013.109a.454.454 0 0 0 .103.18l.083.064a.402.402 0 0 0 .366.025.363.363 0 0 0 .135-.083.3.3 0 0 0 .083-.134.274.274 0 0 0 .032-.161c-.006-.038-.013-.07-.013-.109a.341.341 0 0 0-.102-.179Z",
    fill: "#2DA1F7"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "m246.874 264.313-.064-.083-.083-.064-.096-.039a.277.277 0 0 0-.161-.006.18.18 0 0 0-.102.026.348.348 0 0 0-.135.083c-.007.006-.007.013-.013.013a.252.252 0 0 0-.077.122.286.286 0 0 0-.032.147c.006.032.006.07.013.102a.447.447 0 0 0 .096.173c.006.007.006.013.013.013l.083.064.097.039a.273.273 0 0 0 .16.006.192.192 0 0 0 .103-.025c.032-.013.064-.026.089-.052a.19.19 0 0 0 .071-.07.179.179 0 0 0 .051-.09.27.27 0 0 0 .032-.16c-.006-.039-.012-.071-.012-.109a.185.185 0 0 0-.033-.09Z",
    fill: "#2DA1F7"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M252.694 248.45c-.385-.122-1.61-.346-1.931.026-.083.096-.038.334-.083.494-.09.333-.263.654-.373.988-.436 1.315-.654 2.694-.757 4.073-.128 1.867-.032 3.746.065 5.619.205-3.291.891-6.62 2.572-9.449.231-.384.475-.763.681-1.167.07-.141.134-.327.038-.455-.045-.071-.128-.103-.212-.129Z",
    fill: "#51AEF4"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M253.176 247.61c-2.195-.552-4.453-.34-6.712-.122.064.225.129.468.109.751-.064.987-1.18 1.167-1.976 1.154-4.016-.038-7.911-1.334-11.671-2.745-3.471-1.296-7.154-2.733-10.785-1.969-1.232.256-2.439.789-3.298 1.706a4.063 4.063 0 0 0-1.001 1.873c.051.058.109.109.173.16.045.032.09.064.141.096a2.294 2.294 0 0 0 .481-.769c1.02-2.65 5.095-2.714 7.905-2.29 2.81.423 5.422 1.648 8.078 2.642 3.895 1.457 8.11 2.438 12.21 1.713 1.36-.237 2.695-.667 4.074-.718 1.38-.058 2.875.333 3.722 1.424.032.045.07.09.102.134.366-.66.616-1.379.135-2.052-.353-.526-1.014-.815-1.687-.988Z",
    fill: "#4177EF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M240.234 250.945c-.405-.263-.892-.346-1.373-.41-.841-.116-1.694-.18-2.522-.359-3.253-.699-5.973-2.989-9.207-3.791-1.341-.334-2.74-.392-4.113-.334-.616.026-1.36-.013-1.957.154-.667.186-.147.597.315.584a18.61 18.61 0 0 1 6.493.981c1.206.411 2.406.969 3.278 1.905.879.943 1.386 2.22 2.406 3.002.604.462 1.348.719 2.092.886 1.54.346 3.279.32 4.556-.61.269-.199.526-.455.609-.776.116-.475-.173-.969-.577-1.232Z",
    fill: "#54D2EF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M236.776 264.012c.012-.885.577-3.958-1.059-3.445-1.328.417-.937 3.272-.982 4.337a197.068 197.068 0 0 1-1.892 19.628c-.353 2.387-.745 4.786-.546 7.191.064.783.231 1.629.834 2.136.899.757 2.374.321 3.099-.603.725-.924.886-2.162.969-3.335.353-4.882-.16-9.783-.359-14.677-.148-3.746-.116-7.486-.064-11.232Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M235.262 270.683c-.61 1.001-.514 2.483-.527 3.618a116.512 116.512 0 0 1-1.276 15.741c-.058.392-.116.802.032 1.161.147.366.577.648.936.488.263-.116.392-.411.482-.68.654-1.892.718-3.932.77-5.94.064-2.643.109-5.286.134-7.928.007-1.129.68-6.03-.551-6.46Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M230.321 297.182c-1.489-2.207-2.008-4.946-1.976-7.601.032-2.663.584-5.28 1.071-7.897.899-4.792 1.739-9.673 2.105-14.535-.937 2.232-1.688 4.503-2.079 6.902-.488 3.021-.693 6.074-1.168 9.096-.276 1.789-.648 3.566-.924 5.362-.237 1.521-.404 3.066-.224 4.593.179 1.527.731 3.047 1.783 4.17 1.001 1.071 2.496 1.719 3.94 1.539-1.02.077-1.938-.763-2.528-1.629Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M232.849 298.805c.07-.007.141-.019.218-.032-.077.013-.148.019-.218.032Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m250.865 263.184-.057-.91.057.91Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M250.885 263.396Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M250.885 263.396c.59 8.179 2.675 16.152 3.875 24.266.366 2.464.655 4.94.809 7.429.051.801.083 1.629-.135 2.405-.218.776-.738 1.507-1.495 1.79 1.084-.032 1.995-.918 2.374-1.931.379-1.014.34-2.13.257-3.214-.815-10.404-4.896-20.36-5.685-30.745Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M237.584 251.087c-1.854-.449-3.862-.597-5.447-1.655-.52-.353-.982-.789-1.489-1.161a7.105 7.105 0 0 0-4.093-1.354c.077 0 .301.199.404.238.18.064.378.07.565.096.295.032.596.038.885.115.667.18 1.315.545 1.886.924 1.309.847 2.413 1.969 3.67 2.893.802.59 1.694 1.11 2.682 1.206.514.051 1.078-.032 1.444-.398a.547.547 0 0 0 .167-.288c.058-.334-.347-.533-.674-.616Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M263.666 255.917c-.385-.411-.649-.924-1.059-1.315-.565-.539-1.341-.789-2.111-.917a9.079 9.079 0 0 0-3.574.121c-.417.103-1.161.212-1.495.514-.436.391.064.615.494.455 1.052-.398 2.156-.706 3.279-.725 1.123-.019 2.284.27 3.163.969.501.398.898.911 1.29 1.417.179.238.365.475.545.706.122-.212.064-.481-.064-.686-.116-.199-.302-.36-.468-.539Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M265.033 259.009c-.43-.084-.411.564-.366.834a9.451 9.451 0 0 1-1.039 6.151c-.527.95-1.232 1.835-1.489 2.887.507-.007.815-.539 1.027-.994 1.155-2.515 2.316-5.138 2.271-7.91-.006-.243-.077-.898-.404-.968Z",
    fill: "white"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.292 406.6h-26.3v5h26.3v-5Z",
    fill: "url(#paint33_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.992 406.6 3.4-4.3h19.8l3.1 4.3h-26.3Z",
    fill: "url(#paint34_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.792 367.3s4.1 4.3 6.2 7.8c2.1 3.5 3 7.7 4.2 13.3.4 1.9 1.3 16.4 1.3 16.4h3.2s-2.7-21.8-4.3-28.2c-1.6-6.4-2.4-8.5-2.4-8.5l-8.2-.8Z",
    fill: "url(#paint35_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.292 374.4s-.6 4-1.3 6.6c-.7 2.5-2.2 5.2-2.2 5.2s.6-7.2 0-11.2c-.5-3.5-1.6-6.9-1.6-6.9l5.1 6.3Z",
    fill: "url(#paint36_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.492 352s2.2 3.5 3 6.2c.8 2.7-.1 7.3-1.7 12.7-1.6 5.4-4 11.2-5.2 14-1.2 2.8-3.4 8.7-4.5 12.2-1.2 3.5-2.1 7.6-2.1 7.6l-2.9-1.8s.5-3.1 1.9-8.4c1.4-5.3 9.5-23.6 10-30 1-6.3 1.5-12.5 1.5-12.5Z",
    fill: "url(#paint37_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.892 378.8s-1.6 7.6-3.1 11.5c-1.5 3.9-4.2 14.5-4.2 14.5l-4.6-.1s2.2-10.6 5.9-16 6-9.9 6-9.9Z",
    fill: "url(#paint38_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.693 404.801 2.908-.304s-.209-5.497.691-10.497c.9-5 3.7-13.6 3.7-16.4 0-2.8-2-11.3-2-11.3l-1 12.3s-5.3 17.2-5.5 18.4c-.2 1.2 1.201 7.801 1.201 7.801Z",
    fill: "url(#paint39_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "m164.192 364.8-4.2 1.5-7.7 21.5-2.879 8.223s10.579-18.623 12.079-21.823c1.5-3.2 2.7-9.4 2.7-9.4Z",
    fill: "url(#paint40_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.892 402.7s-.8-7-1.6-8.6c-.4-.8-.8-1.1-.8-1.1s-.9 4.6-1 5.5c-.1.9.1 6 .1 6l3.3-1.8Z",
    fill: "url(#paint41_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.292 374.4-5.1-6.3-8.4-.8 4.7-6.3-1.9-7.4 7.8 2.3 7.1-3.9.5 7.6 6.2 5.2-8.2 2.8-2.7 6.8Z",
    fill: "url(#paint42_linear_1989_1050)"
  }))), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M166.251 297.438h-15.303v2.733a.91.91 0 0 0 .902.913h15.308v-2.734a.916.916 0 0 0-.907-.912Z",
    fill: "#DA9A64"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M165.054 297.438h-12.769c-1.206 0-1.35.191-1.35 1.505v1.228a.91.91 0 0 0 .903.913h13.228c.533 0 .87-.419.87-1.087 0-.776.016-1.647.016-1.647a.904.904 0 0 0-.898-.912Z",
    fill: "#EAB781"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M159.049 297.724h-.747a.017.017 0 0 1-.016-.016v-35.289c0-.009.008-.017.016-.017h.747c.008 0 .016.008.016.017v35.289c-.004.008-.008.016-.016.016Z",
    fill: "url(#paint43_linear_1989_1050)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M150.948 300.171v-2.733h-.132a.91.91 0 0 0-.902.912v2.866a.91.91 0 0 0 .902.913h15.44a.91.91 0 0 0 .902-.913v-.987s-.345.855-1.226.855H151.85a.91.91 0 0 1-.902-.913Z",
    fill: "#9A6948"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M147.494 255.944a.622.622 0 0 0-.201-.174c-.722-.457-.771-1.614-.263-2.028.111-.092.05-.22.128-.303.041.174.143.116.262.087.673-.145 1.251.124 1.604.738-.066.091-.041.178-.062.27-.024.099.07.278-.065.294-.292.029-.451.291-.726.374-.267.082-.55.684-.677.742Z",
    fill: "#EAB781"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M154.102 243.775c-.041-.154.057-.22.16-.307.669-.569 1.489-.701 2.309-.793.488-.053.501-.02.394-.493-.086-.382-.025-.751.074-1.12.992 0 1.985.004 2.978.004.061.432.131.863.02 1.298-.053.212.025.316.263.303.857-.041 1.661.174 2.428.556.041.021.976.394 1.427.477.591.104 1.194.39 1.485.838.082.095.14.211.111.348.041.353-.176.689-.172 1.029-.033.166-.316.406-.632.41l.021.05c-.329-.016-.591.141-.854.282-.213.112-.5.1-.631.353-.189-.037-.308-.241-.517-.216.127-1.012.193-2.032.246-3.057-.041.004-.061.004-.066.009-.016.054-.032.107-.045.161-.188.967-.533 1.867-1.165 2.634-.705.863-1.599 1.365-2.711 1.452h-1.128c-.71-.075-1.386-.257-1.956-.705-.919-.722-1.498-1.668-1.805-2.804-.066-.237-.16-.212-.234-.709Z",
    fill: "#EAB781"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M160.599 247.798c.152-.038.365-.108.353.191-.029.663-.037 1.534-.111 2.19-.065.576-.139 1.161-.365 1.696-.111.261-.16.643-.484.759-.316.112-.685.153-1.005.303h1.891c.103.249.205.502.23.775-.246-.215-.513-.423-.841-.477-.948-.149-1.895-.099-2.83.079-.296.058-.583.208-.722.585-.091.241-.013.523-.107.763-.324.826.644 1.643.784 1.668.504.049 2.169-.009 2.502.004.369.012.902-.042 1.222-.324.008.021-.271.44-.25.593-1.485.005-2.97.005-4.455.009-.418-.822-.476-1.701-.369-2.601.045-.373.119-.742.357-1.053h2.182c-.168-.075-.34-.059-.504-.079-.583-.079-1.083-.332-1.309-.9-.435-1.116-.558-2.506-.628-3.692-.041-.672-.016-.639.661-.556.422.063 2.498.378 3.798.067Z",
    fill: "#DA9A64"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M158.643 231.572c1.636-.042 2.818.892 2.887 2.588.041.983-.164 1.937-.34 2.891a43.248 43.248 0 0 1-.685 3.144c-.361.51-.894.398-1.399.402-.123 0-.25.013-.373-.004-.464-.062-.837-.269-1.03-.726-.307-.713-.357-1.493-.541-2.239a14.91 14.91 0 0 1-.3-1.572c-.102-.793-.278-1.572-.258-2.381.025-.859.41-1.473 1.12-1.904.279-.17.611-.145.919-.199Zm1.874 2.331c.004-.539-.123-1.016-.381-1.514-.398-.767-1.608-.718-2.129-.361-.587.402-.8 1.008-.845 1.68-.045.655.049 1.311.16 1.945.213 1.253.525 2.489.804 3.729.049.22.168.286.353.1a7.77 7.77 0 0 0 .853-1.004c.377-.531.595-1.099.8-1.709.311-.937.299-1.904.385-2.866Z",
    fill: "#DA9A64"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M162.954 265.874c.455 1.115.43 2.314.533 3.48.156 1.804.221 3.616.361 5.425.053.692.135 1.398-.099 2.086-.377.311-.841.365-1.292.465a.552.552 0 0 1-.611-.287 2.943 2.943 0 0 1-.373-1.132c-.07-.751-.246-1.485-.312-2.24-.09-1.057-.271-2.107-.381-3.16-.119-1.103-.304-2.194-.447-3.289-.095-.726.004-1.075.758-1.149.513-.05 1.018-.174 1.526-.262.209-.016.25-.078.337.063Zm-.144 2.314c-.066-.523.004-1.049-.156-1.568-.094-.311-.209-.415-.504-.406-.189.008-.353.074-.525.116-.275.062-.324.261-.288.46.107.531.763 8.827.882 9.801.033.253.103.502.456.482.328-.021.492-.2.574-.523.115-.452-.32-7.375-.439-8.362Z",
    fill: "#DA9A64"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M161.538 257.109c.361.664.505 1.398.661 2.128a17.24 17.24 0 0 1 .357 4.003c-.004.153.041.327-.144.419-.381.124-3.052.137-4.171.149-.312.004-1.539-.22-1.842-.286a1.052 1.052 0 0 1-.144-.581c-.004-.564.029-1.174.078-1.729.078-.888.361-3.547.677-3.903.103-.133.398.153.591.149.11-.004.221.095.213.187-.02.344.222 2.467.287 3.206.136 1.526 1.194 2.094 2.396 2.314.463.083.951.008 1.431.021.259.008.316-.095.254-.332-.11-.444-.106-.908-.164-1.36a73.56 73.56 0 0 0-.397-2.804c-.037-.212-.021-.427-.095-.643-.139-.427-.328-.817-.619-1.157H161.054c.173.066.304.049.484.219Z",
    fill: "#DA9A64"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M157.978 265.874c-.057.253.131.452.152.696.086 1.062-.074 2.112-.189 3.157a239.905 239.905 0 0 1-.512 4.193c-.119.908-.14 1.829-.398 2.717a1.42 1.42 0 0 1-.296.56c-.024.004-.045.008-.069.008-.017.021-.033.042-.054.062-.402.087-.812.079-1.218.079-.324 0-.496-.17-.558-.485-.131-.672-.094-1.352-.053-2.024.082-1.427.262-2.846.307-4.272.037-1.124.173-2.24.16-3.364 0-.116-.008-.249.14-.278.275-.054.344-.278.328-.49-.029-.344.14-.385.402-.352.103.012.189 0 .291-.008.328-.021 1.177.083 1.473.016-.082-.008-.127-.008-.164-.021-.054-.016-.103-.041-.152-.058.098-.145.291-.037.41-.136Zm-2.592 10.481v.622c0 .091-.004.178.111.22.406.149.927-.203.98-.647.111-.859.201-1.726.357-2.576.188-1.049.242-2.111.389-3.161.087-.618.099-1.248.226-1.854.144-.688.185-1.381.185-2.078 0-.34-.177-.501-.542-.518-.459-.025-.701.124-.755.448-.123.755-.155 1.522-.254 2.281-.127.971-.189 1.958-.291 2.933-.062.601-.099 1.207-.156 1.812-.074.838-.246 1.668-.25 2.518Z",
    fill: "#DA9A64"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M160.948 256.309c-.152.083-3.056.079-3.561.029-.59-.058-1.046-.854-.886-1.696.037-.266.124-.494.214-.739.139-.377.426-.531.722-.584.935-.179 1.886-.229 2.83-.079.328.05.591.257.841.477.246.531.242 1.124.176 1.667-.037.282-.053.772-.336.925Z",
    fill: "#EAB781"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M157.564 266.019c.049.02.435-.22.422-.166-.016.058.05.215-.102.249-.435.087-1.661 0-1.764-.013-.262-.033-.431.009-.402.353.016.211-.053.435-.328.489-.148.029-.14.162-.14.278.013 1.124-.123 2.24-.16 3.364-.045 1.427-.225 2.845-.307 4.272-.037.672-.078 1.352.053 2.024.062.315.238.481.558.485.41 0 .816.013 1.218-.078-.135.19-.34.203-.545.207-.632.021-1.26.046-1.875-.145-.279-.286-.32-.643-.324-1.02-.012-1.44.107-2.871.177-4.306.077-1.559.155-3.123.324-4.67.078-.693-.07-1.166-.579-1.639-.513-.489-.956-1.074-1.202-1.771-.008-.045-.02-.091-.028-.136-.013-.046-.021-.092-.033-.141.385-.345.775-.834 1.161-1.178.053.004.094.024.065.116-.045.045-.123.518-.471.634-.349.187-.3.428-.123.71a13.008 13.008 0 0 0 1.886 2.326.313.313 0 0 0 .345.079c.143-.054.176-.195.201-.336.037-.224-.066-.456.057-.672.017.1.029.204.045.303.041.282.156.382.439.369.476-.012.956.009 1.432.013Z",
    fill: "#9A6948"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M160.878 252.945h-1.891c.316-.149.636-.182.935-.332.361-.178.443-.472.554-.73.226-.539.3-1.124.365-1.696.074-.655.082-1.323.111-1.987.012-.298-.197-.207-.353-.191-.459.046-.919.096-1.374-.012 1.112-.087 2.002-.589 2.711-1.452.632-.771.977-1.667 1.165-2.633.013-.054.029-.108.045-.162 0-.004.021-.004.066-.009a44.286 44.286 0 0 1-.246 3.057c-.156 1.473-.258 2.949-.554 4.401-.045.212-.119.419-.184.626-.218.66-.628 1.083-1.35 1.12Z",
    fill: "#9A6948"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M158.097 247.993c-.439.158-.874.008-1.3-.046-.677-.083-.702-.116-.661.556.07 1.186.193 2.368.628 3.484.221.568.726.821 1.308.9.164.025.337.004.505.079h-2.182c-.558-.108-.972-.398-1.227-.929a4.502 4.502 0 0 1-.398-1.24c-.201-1.34-.295-2.692-.434-4.036-.082-.44-.349-2.107-.255-2.567 0-.054.013-.345.017-.419.106.381.168.472.234.709.307 1.136.886 2.082 1.804 2.804.575.448 1.251.634 1.961.705Z",
    fill: "#9A6948"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M158.643 231.572c-.312.054-.64.029-.923.199-.71.427-1.095 1.045-1.12 1.904-.021.809.156 1.593.258 2.381.07.526.168 1.057.3 1.572.184.746.238 1.526.541 2.239.193.457.566.664 1.03.726.123.017.25.004.373.004.5-.004 1.038.108 1.399-.402-.008.382-.152.684-.492.871-.993 0-1.986-.004-2.978-.004-.283-.083-.37-.328-.423-.572-.39-1.792-.812-3.576-1.075-5.392-.098-.677-.065-1.353.201-1.996.443-1.053 1.551-1.634 2.909-1.53Z",
    fill: "#9A6948"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M160.915 256.894c-1.066-.004-2.133-.013-3.199-.013-.3 0-.694.465-.714.498-.189.27-.234.821-.328 1.236-.197.875-.205 1.771-.283 2.659-.049.556-.123 1.091-.045 1.647.053.402.328.642.939.734.32.045.64.091.956.087 2.215.07 3.888-.174 4.171-.079l-.172.124a.853.853 0 0 1-.455.087c-.583-.004-1.169 0-1.752 0-.775 0-1.546.005-2.321.005-.845-.046-1.69.083-2.531-.083-.049-.287-.275-.49-.349-.764-.008-.792.033-1.576.131-2.36.144-1.136.341-2.26.763-3.33.132-.332.337-.593.677-.722 1.485-.004 2.97-.004 4.455-.008.299.062.516.249.681.498-.185-.017-.329-.216-.624-.216Z",
    fill: "#9A6948"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M162.621 265.807c-.508.091-1.013.212-1.526.262-.754.074-.853.423-.758 1.148.143 1.1 1.316 9.478 1.509 9.826a.55.55 0 0 0 .611.287c.447-.1.915-.154 1.292-.465-.012.137-.119.22-.18.328-.156.153-.357.178-.558.232a3.175 3.175 0 0 1-1.924-.029c-.279-.191-.303-.502-.361-.788-.262-1.319-.439-2.651-.594-3.99-.189-1.61-.509-3.202-.62-4.824a23.186 23.186 0 0 1-.049-1.207c-.004-.203.061-.382.283-.452.09-.008.18-.008.267-.021.865-.12 1.726-.319 2.608-.307Z",
    fill: "#9A6948"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M167.228 248.412c.09.182.738 1.634.935 2.028.262.518.55 1.024.804 1.543.09.187.221.39.193.601-.025.191-1.009.083-1.1-.049-.393-.569-.795-1.137-1.165-1.722-.611-.962-1.144-1.97-1.673-2.982-.218-.419-.57-.83-.349-1.373.062-.025.066-.079.07-.137l-.004.004c.234-.099.463-.207.623-.414.14-.009.242.037.353.145.398.377 1.243 2.215 1.313 2.356Z",
    fill: "#EAB781"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M164.11 291.631c-.742.415-1.513.373-2.297.141-.004-.021-.012-.041-.016-.066-.308-2.103-.537-4.214-.771-6.326-.222-1.995-.447-3.994-.394-6.014.008-.336.025-.672.295-.921.628.146 1.255.195 1.891.059.296-.063.566-.241.882-.183.021.062.037.129.058.191-.222 0-.763.572-1.982.323-.434-.074-.66.067-.656.494.004.688.025 1.377.082 2.061.09 1.091.213 2.178.324 3.269.094.9.164 1.8.291 2.696.123.879.345 3.418.456 3.795.143.481 1.686.27 1.903.361",
    fill: "#9A6948"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M153.622 291.706c-.164-.15-.197-.332-.197-.556-.033-2.791-.078-5.587 0-8.378.037-1.307.029-2.622.254-3.916.041-.232.095-.448.353-.535.537.116 1.075.22 1.633.212.365-.005.705-.133 1.066-.141.021.116.16.178.131.315-.233-.087-.451-.042-.66.079-.201.02-.406.041-.607.058-.455.07-.808-.038-1.206-.121-.07-.012-.164.021-.156.096.041.282-.139.514-.148.788-.041 1.145-.11 2.289-.127 3.438-.02 1.568-.012 3.14-.004 4.708.004 1.103-.049 2.207.062 3.306.02.211.069.39.27.477.312.137.628.24.968.103.046 0 .091 0 .136-.004.18-.02.357-.045.537-.066-.746.489-1.517.444-2.305.137Z",
    fill: "#9A6948"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 244.193c.004.228.061 1.1.069 1.236a.807.807 0 0 0-.09.556c.037.266-.07.427-.246.597-.386.378-.825.403-1.313.27-.48-.133-.894-.373-1.279-.68-.058-.046-.123-.179-.21-.029-.102.178-.291.236-.459.327.369-.298.332-.746.398-1.153.098-.626.956-1.149 1.489-1.207a4.958 4.958 0 0 1 1.641.083Z",
    fill: "#EAB781"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "m147.162 253.443.049-.129c.029-.049.102-.091.25-.066.271.025.546.046.816.071.283.149.554.199.763-.125.521-.805 1.071-1.597 1.51-2.451.094-.183.311-.473.418-.655.447-.768.882-1.543 1.268-2.344.229-.477.168-.46-.316-.664l-.004-.008c.012-.095-.144-.112-.099-.24.341.145.661.365.985.485.119.045.274.041.332.195.045.257-.074.473-.177.688-.697 1.464-1.607 2.8-2.465 4.165a78.832 78.832 0 0 1-1.312 1.97l-.07.062-.086-.124c-.349-.614-.927-.884-1.604-.739-.115.021-.217.079-.258-.091Z",
    fill: "#9A6948"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M168.434 252.825c.11-.004.221-.013.336-.017.209.034.431-.029.632.071.045.025.127.033.078.108-.025.033-.099.025-.152.037-.205-.091-.41-.07-.628-.037-.553.087-.894.439-1.165.891-1.419-1.999-2.719-4.073-3.847-6.25-.099-.191-.201-.39-.205-.614.131-.257 1.14-.701 1.468-.689-.004.054-.012.112-.069.137-.546.141-.649.336-.448.822.021.053.05.103.074.153.423.875.862 1.734 1.391 2.551.566.879 1.058 1.808 1.698 2.638.164.207.312.415.837.199Z",
    fill: "#9A6948"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M160.008 266.123c-.086.012-.287-.042-.344-.229-.148-.489-.107-.987.094-1.484.078-.191.296-.299.275-.536.583 0 1.169-.004 1.752 0 .16 0 .311-.008.455-.087.689.44.767 1.095.734 1.788-.004.1-.18.332-.365.344-.57.046-1.698.096-2.404.179-.069.004-.135.016-.197.025Z",
    fill: "#EAB781"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M155.181 263.796c.841.166 1.686.037 2.53.083-.049.145.066.232.124.34.287.531.414 1.078.147 1.659-.123.095-.131.149-.414.145-.476-.004-.956-.025-1.432-.004-.287.012-.402-.042-.439-.369a5.507 5.507 0 0 0-.045-.303c-.032-.56-.155-1.087-.471-1.551Z",
    fill: "#EAB781"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M151.489 262.493c-.135.021-.172-.099-.226-.174-1.275-1.812-2.534-3.637-3.552-5.616-.119-.228-.324-.452-.217-.759.045-.116.057-.344.394-.502.069.008-.082.12-.091.307-.012.266.115.494.238.709.825 1.469 1.748 2.879 2.712 4.26.254.365.525.614.791.966.14.183 1.329-.203 1.555-.311.029.121.053.237.082.357-.537.017-.976.237-1.403.581-.086.062-.185.12-.283.182Z",
    fill: "#9A6948"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M176.773 251.261c.082.004.16.009.242.009-.005.016-.005.033.008.045-.16.597-.131 1.174.209 1.709 0 .041-.332.39-.546.444-2.034.506-4.04 1.14-6.115 1.452-.234.033-.468.099-.706.016-.111-.112-.221-.216-.299-.361-.246-.444-.218-.921-.218-1.398.086 0 .111.063.115.129.017.241.074 1.095.324 1.128.058.174.214.129.316.116.829-.107 1.616-.286 2.42-.468 1.358-.303 2.711-.606 4.036-1.046.185-.062.082-.626.082-1.103 0-.298.029-.568.132-.672Z",
    fill: "#9A6948"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M147.461 253.248c-.123.008-.221.021-.25.066.217-.763.562-1.472.878-2.19.562-1.265 1.152-2.517 1.833-3.724.185-.332.369-.66.636-.934.164-.091.353-.149.459-.327.086-.15.148-.021.209.029.386.307.8.547 1.28.68.488.133.927.108 1.313-.27.172-.17.283-.331.246-.597a.858.858 0 0 1 .09-.556c.144.432.197.838.185 1.332-.32.224-.62.481-1.005.589-.099.029-.16.074-.201.161-.058-.153-.213-.157-.332-.194-.353-.104-.644-.341-.985-.486-.049.133.111.145.099.241-.197.025-.423-.262-.452-.278-.66-.382-.791-.336-1.124.365-.287.601-.561 1.211-.869 1.8a53.96 53.96 0 0 0-.825 1.672c-.299.626-.545 1.277-.89 1.887-.135.232-.258.464-.295.734Z",
    fill: "#DA9A64"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M169.352 253.182c-.004.477-.028.954.218 1.397.082.146.188.249.299.361-.078.004-.16.004-.221.071-.39.427-.866.481-1.37.274-.566-.233-.784-.693-.735-1.299.005-.033-.008-.07-.008-.103.271-.452.611-.809 1.165-.892.218-.033.423-.054.628.037.004.05.012.1.024.154Z",
    fill: "#EAB781"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M155.751 292.896c.783.348 1.234 1 1.522 1.775.057.158.094.365-.123.473-.201-.091-1.686.431-2.166.361-.439-.066-.903-.066-1.292-.34-.291-.208-.587-.419-.624-.805-.057-.614.41-1.277.997-1.485.168-.058.221-.07.345-.132.077-.104.303-.071.406-.054.311.058.644.066.935.207Zm-.972 2.14c.603-.016 1.066-.095 1.501-.298.431-.199.447-.37.287-.809-.111-.311-.349-.494-.558-.635-.512-.336-1.091-.527-1.731-.348-.841.232-1.062 1.078-.672 1.547.315.386.775.581 1.173.543Z",
    fill: "#DA9A64"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M163.897 292.925c1.021.519 1.341 1.182 1.522 1.875.078.294-.595.701-.743.755 0-.038.041-.121-.02-.1a3.255 3.255 0 0 1-1.727.137c-.365-.062-.706-.133-1.038-.311-.742-.398-.853-1.149-.299-1.854.127.079.049.174.029.27-.078.377-.087.725.283.991.303.216.615.365.984.406.509.058.984-.066 1.456-.224.427-.141.496-.373.402-.775-.197-.842-1.641-1.357-2.363-1.058-.106.046-.213.091-.303-.033.275-.245.644-.133.952-.257.295-.029.586.037.865.178Z",
    fill: "#DA9A64"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M154.561 292.68c-.131.15-.332.133-.496.195-.587.212-1.05.871-.997 1.485.037.386.333.602.624.805.295.186.754.269 1.251.274.636.004 2.006-.382 2.207-.291-.189.237-.456.336-.726.427a5.616 5.616 0 0 1-3.224.129 2.365 2.365 0 0 1-.476-.183c-.423-.207-.525-.418-.423-.887.181-.834.579-1.493 1.419-1.792.271-.104.546-.203.841-.162Z",
    fill: "#9A6948"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 292.751c-.307.129-.635.1-.947.294-.181.117-.369.195-.492.382-.554.705-.439 1.456.299 1.854.332.178.738.278 1.153.311.59.046 1.046.071 1.612-.137.061-.02.02.063.02.1-1.144.402-2.313.489-3.486.174-.792-.216-.964-.606-.669-1.369.263-.667.611-1.161 1.321-1.46.484-.203.8-.153 1.189-.149Z",
    fill: "#9A6948"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M163.7 278.321c-1.288.448-2.149.27-2.773.124-.074-.352-.127-.734.156-1.049.636.212 1.272.22 1.924.029.201-.058.402-.083.558-.232.139.108.217.423.242.647a.777.777 0 0 1-.107.481Z",
    fill: "#EAB781"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M156.731 278.392c-.361.008-.701.136-1.066.141-.558.004-1.096-.096-1.633-.212.017-.336-.111-.697.164-.991.615.195 1.247.166 1.875.145.201-.004.41-.017.545-.207a.17.17 0 0 0 .045-.021c.013.008.021.021.033.029.045.373.086.746.037 1.116Z",
    fill: "#EAB781"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M151.489 262.493c.094-.062.164-.133.271-.211.455-.345.873-.54 1.411-.556.34.133.422.448.504.759 0 .05-.771.829-1.152 1.174-.513-.133-.858-.419-.886-.992-.004-.099-.095-.12-.148-.174Z",
    fill: "#EAB781"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M177.236 253.024c-.34-.535-.373-1.112-.209-1.709.291-.278.73-.357.972-.22.025.108.082.191.201.208.209.377.398.763.414 1.211-.287.639-.812.638-1.378.51Z",
    fill: "#EAB781"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M163.027 292.751c-.389-.004-.779-.025-1.148.133-.164-.336-.25-.73-.066-1.112.784.232 1.555.274 2.297-.141.029.461.066.888-.221 1.29-.316-.141-.55-.153-.862-.17Z",
    fill: "#EAB781"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M153.72 292.838c-.078-.373-.151-.746-.094-1.132.783.307 1.555.352 2.297-.129.057-.083.086-.112.107-.29-.033.547.004 1.107-.279 1.609-.858-.323-1.76-.157-2.031-.058Z",
    fill: "#EAB781"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M156.665 277.209c.025-.004.046-.008.07-.008-.012.029-.029.054-.041.083-.012-.008-.02-.021-.033-.029 0-.016 0-.029.004-.046Z",
    fill: "#EAB781"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M178.081 250.967c.48-.627 1.108-.921 1.895-.913.554.004 1.087.079 1.641.174.16.029.603.141.619.361.033.403-.221.44-.377.506-.808.349-1.604.734-2.465.95-.62.158-.714.108-.923-.535.053.008.147.004.16.029.082.195.205.141.361.112.57-.095 1.074-.377 1.608-.572.315-.117.664-.158.943-.365.062-.046.148-.075.123-.179-.016-.062-.057-.112-.115-.116-.517-.037-1.021-.199-1.546-.137-.583.071-1.099.299-1.518.726-.074.075-.152.178-.287.149-.09-.024-.107-.07-.119-.19Z",
    fill: "#DA9A64"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M179.394 252.045c.857-.22 1.653-.601 2.465-.95.156-.066.389-.153.377-.377-.012-.224-.135-.324-.328-.39-.115-.041-.119-.05-.291-.099.098.008.529.124.783.219.406.15.46.415.173.73-.07.075-.144.15-.226.208a6.96 6.96 0 0 1-3.171 1.219c-.188.025-.385.033-.558-.091-.016-.419-.648-1.273-.619-1.41 0-.004.008-.004.008-.009.021-.02.017-.087.078-.132.041.078.689 1.24 1.309 1.082Z",
    fill: "#9A6948"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M160.517 233.903c.017.991-.074 1.929-.385 2.87-.201.61-.423 1.174-.8 1.709a7.51 7.51 0 0 1-.853 1.004c-.185.182-.304.12-.353-.1-.279-1.24-.591-2.476-.804-3.729-.107-.634-.201-1.29-.16-1.945.045-.672.258-1.282.845-1.68.525-.356 1.731-.406 2.129.361a3.1 3.1 0 0 1 .381 1.51Z",
    fill: "#EAB781"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M163.249 276.546c-.082.323-.246.502-.574.522-.353.025-.423-.223-.456-.481-.119-.974-.857-9.141-.902-9.66-.016-.203-.062-.543.213-.605.177-.042.435-.1.62-.108.299-.013.41.091.504.406.16.523.09 1.05.156 1.568.119.987.554 7.91.439 8.358Z",
    fill: "#EAB781"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M156.985 257.404c.177-.353.435-.523.735-.523 1.066 0 2.133.009 3.199.013.287.34.619.912.743 1.344.303 1.049.496 3.832.561 4.604.021.244-.016.414-.274.406-.476-.012-.981.004-1.44-.079-1.206-.22-2.26-.788-2.396-2.314-.065-.743-.307-2.866-.287-3.206.004-.096-.106-.183-.213-.187a5.385 5.385 0 0 1-.628-.058Z",
    fill: "#EAB781"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M155.386 276.355c.008-.85.18-1.68.258-2.522.058-.605.09-1.207.156-1.812.103-.979.164-1.962.291-2.933.099-.759.132-1.526.255-2.281.053-.324.295-.473.754-.448.365.021.546.178.542.518.102.851-.324 3.314-.41 3.932-.152 1.05-.201 2.112-.39 3.161-.152.85-.246 1.717-.357 2.576-.057.448-.578.796-.98.647-.115-.042-.111-.133-.111-.22-.012-.203-.008-.411-.008-.618Z",
    fill: "#EAB781"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M156.666 277.209c0 .013-.005.029-.005.041-.016.009-.028.017-.045.021.013-.021.033-.041.05-.062Z",
    fill: "#9A6948"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M155.648 265.339c.004-.556-.27-1.805-1.054-2.427-.242-.191-.5-.357-.816-.402-.008-.009-.017-.009-.029-.009h-.008v.005c-.049.054-.312.493-.39.568-.447.435-.373.576-.197.858a13.029 13.029 0 0 0 1.887 2.327.313.313 0 0 0 .345.079c.143-.054.176-.195.201-.336.041-.216.033-.448.061-.663Zm-1.353-.635c-.242-.286-.456-.593-.702-.875-.115-.133.497-.88.648-.714.271.291.644.494.8.871.259.627.415 1.282.419 2.033-.509-.398-.8-.892-1.165-1.315Z",
    fill: "#DA9A64"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M154.241 263.111c.271.291.644.494.8.871.259.627.414 1.282.419 2.033-.513-.394-.804-.888-1.165-1.311-.242-.286-.456-.593-.702-.875-.217-.249.464-.913.648-.718Z",
    fill: "#EAB781"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M176.773 251.261a.513.513 0 0 0-.333.004c-.594.187-1.214.274-1.825.386-1.596.295-3.199.539-4.738 1.083-.217.074-.352.045-.451-.191a58.88 58.88 0 0 0-.96-2.203c-.258-.56-1.735-3.446-2.038-3.994-.234-.419-.669-.809-.579-1.323.025-.133-.09-.319-.123-.365.041.353-.233.925-.233 1.265.024.025.32.025.43.133.394.377 2.043 3.986 2.24 4.38.262.518.55 1.024.804 1.543.09.186.147.468-.054.535-.377.124-.787.074-1.013-.245-.402-.564-.631-.871-1-1.456-.612-.962-1.145-1.97-1.674-2.982-.217-.419-.57-.83-.349-1.373-.545.141-.648.336-.447.821.021.054.049.104.074.154.423.875.861 1.734 1.391 2.551.566.879 1.058 1.808 1.698 2.638.291.618 1.083.029 1.809.248.049.017.127.034.078.108-.025.033-.099.025-.152.038.008.054.016.103.028.157.087 0 .099.067.115.129.632.008 6.022-1.298 6.35-1.34.349-.046.648-.095.882.228a1.405 1.405 0 0 1 .07-.929Z",
    fill: "#DA9A64"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M163.171 278.719c.406.299.394.772.398 1.178.012 1.012.135 2.012.168 3.02.057 1.783.115 3.567.144 5.354.012.83.11 1.722.151 2.551.017.353-.151.569-.451.763-.082 0-.168.005-.25.005a1.126 1.126 0 0 1-.295-.847c.024-.597-.05-1.186-.123-1.779a15.51 15.51 0 0 1-.119-1.302c-.025-.481-.747-8.014-.431-8.806.262-.041.533-.087.808-.137Z",
    fill: "#EAB781"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M164.274 287.305c-.024-.954-.053-1.908-.077-2.862-.005-.087-.255-5.749-.443-5.931-.222 0-.407.103-.587.211.406.299.394.772.398 1.178.012 1.012.135 2.012.168 3.02.057 1.783.115 3.567.144 5.354.012.83.016 1.664.057 2.493.016.336.041.606-.279.635-.139.012-.418-.013-.439-.158-.16-.933-.41-3.231-.426-3.579-.025-.481-.747-8.014-.431-8.806-.193-.008-.39.004-.574-.029-.435-.075-.661.066-.657.494.004.688.025 1.377.082 2.061.091 1.091.718 7.798.886 8.669.07.361.074.713.185 1.091.086.286.677.535 1.181.551.341.013.648-.166.722-.19.037-.025.095-3.609.09-4.202Z",
    fill: "#DA9A64"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M156.202 278.785c.246.229.275.511.287.834.053 1.253-.098 2.497-.152 3.741-.065 1.489-.274 2.97-.348 4.459-.049 1.025-.23 2.041-.259 3.069-.008.307-.898.39-.898.054.012-1.24.094-2.476.123-3.712.029-1.103.107-2.202.086-3.306 0-.103-.004-.207.004-.311.078-1.178.111-2.356.123-3.538.004-.439-.078-.949.423-1.232.205-.016.406-.037.611-.058Z",
    fill: "#EAB781"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M156.944 279.001a.537.537 0 0 0-.082-.294c-.233-.087-.451-.042-.66.079.246.228.275.51.287.833.053 1.253-.098 2.497-.152 3.742-.065 1.489-.274 2.969-.348 4.458-.05 1.025-.23 2.041-.259 3.07-.008.29-.898.373-.898.054.012-1.241.094-2.477.123-3.713.029-1.103.107-2.202.086-3.305 0-.104-.004-.208.004-.311.078-1.178.111-2.356.123-3.538.004-.44-.078-.95.423-1.232a5.687 5.687 0 0 1-1.239-.129c-.07-.012-.131.025-.156.095-.09.266-.106.527-.119.797-.041 1.145-.111 2.289-.127 3.438-.02 1.568-.012 3.14-.004 4.708.004 1.103-.082 2.24.025 3.339.02.211.073.332.225.493.41.453 1.551.009 1.723-.012a.416.416 0 0 0 .107-.29c.008-.092.406-3.907.578-5.629.086-.867.144-1.734.221-2.6.119-1.344.169-2.696.119-4.053Z",
    fill: "#DA9A64"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M147.461 253.248c.037-.27.16-.502.287-.73.345-.61.591-1.261.89-1.887.271-.56.538-1.12.825-1.672.307-.593.586-1.199.869-1.8.119-.245.292-.664.517-.668.419-.004.931.593 1.063.577l.004.008a1.373 1.373 0 0 1-.218.709c-.152.241-.299.49-.394.751-.213.589-.541 1.124-.849 1.655-.361.622-.693 1.269-1.115 1.858-.324.448-.554.979-1.063 1.265-.27-.02-.545-.045-.816-.066Z",
    fill: "#EAB781"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M149.11 254.393c-.004.166-.004.332-.008.497-.008.063-.004.117.065.141.189-.012.242.15.329.262 1.009 1.298 1.772 2.746 2.551 4.185.34.634.751 1.228 1.046 1.887-.226.108-.423.178-.673.166a.521.521 0 0 0-.016-.502c-.304-.535-.624-1.062-.931-1.597-.415-.73-.788-1.481-1.214-2.206-.374-.635-.726-1.282-1.178-1.863-.201-.261-.488-.24-.832.009-.275.199-.14.398-.021.593.501.817 1.001 1.634 1.506 2.447.352.568.738 1.124 1.086 1.692.349.56.895 1.137 1.26 1.684-.181.096-.517.037-.657-.145-.266-.353-.43-.56-.685-.925-.963-1.381-1.886-2.787-2.711-4.26-.119-.215-.25-.443-.238-.709.008-.187.037-.369.328-.572.214-.15.48-.316.772-.345.135-.012-.082-.518.127-.56.037.038.065.079.094.121Z",
    fill: "#DA9A64"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M148.277 253.314c.513-.286.739-.817 1.063-1.265.422-.589 2.567-4.72 2.572-4.977.52.124.553.282.324.759-.386.801-2.626 4.563-3.146 5.367-.206.328-.53.266-.813.116Z",
    fill: "#DA9A64"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M169.787 254.438c-.25-.033-.344-.887-.324-1.128.427-.066 6.022-1.298 6.35-1.339.348-.046.648-.096.882.228.024.112.045.228.069.34-.283.099-.562.215-.853.294-.738.199-1.481.386-2.219.573-1.181.298-2.363.593-3.54.9-.119.033-.143.037-.365.132Z",
    fill: "#EAB781"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M151.899 261.83c-.365-.548-.722-1.166-1.07-1.726-.353-.568-.735-1.12-1.087-1.692-.505-.813-1.009-1.63-1.506-2.447-.119-.195-.254-.394.021-.593.344-.249.627-.27.833-.009.451.581.803 1.228 1.177 1.863.426.726.795 1.476 1.214 2.206.303.535.627 1.062.931 1.597.09.162.144.178.513.415-.148.087-.841.377-1.026.386Z",
    fill: "#EAB781"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M169.787 254.438c-.016-.078.246-.099.365-.132 1.178-.307 2.359-.602 3.54-.9.743-.187 1.481-.374 2.219-.573.291-.079.57-.195.853-.294.14.253.099.402-.205.502-1.325.439-2.678.742-4.036 1.045-.804.178-1.591.377-2.42.469-.111.012-.258.058-.316-.117Z",
    fill: "#DA9A64"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M154.779 295.036c-.398.038-.862-.157-1.178-.539-.385-.469-.164-1.315.673-1.547.644-.178 1.218.012 1.731.348.209.137.447.324.558.635.16.44.144.614-.287.809-.431.195-.894.278-1.497.294Z",
    fill: "#EAB781"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M161.584 293.427c.123-.187.311-.29.512-.394.115.091.168.046.275.004.722-.298 2.17.216 2.367 1.062.094.402.024.635-.402.776-.472.157-.952.278-1.456.224-.369-.042-.681-.191-.985-.407-.369-.265-.361-.614-.283-.991.021-.096.099-.195-.028-.274Z",
    fill: "#EAB781"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M178.204 251.158c.135.029.213-.071.287-.146a2.485 2.485 0 0 1 1.518-.725c.521-.063 1.029.099 1.546.136.058.005.099.054.115.117.025.107-.061.132-.123.178-.283.207-.628.249-.943.365-.534.195-1.038.473-1.608.572-.156.025-.283.083-.361-.112-.013-.029-.095.004-.148-.004-.008-.004-.283-.336-.283-.381Z",
    fill: "#EAB781"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1989_1050",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1038,
    y: 71,
    width: 239,
    height: 566
  }, _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M1277 71h-239v566h239V71Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.73 126.1c1.2 0 2.29-1 2.29-2.3 0-1.2-.99-2.3-2.29-2.3-1.19 0-2.28 1-2.28 2.3.1 1.2 1.09 2.3 2.28 2.3Z",
    fill: "url(#paint44_radial_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1043.27 594 219.81 4.4V96.8l-219.81-4.4V594Z",
    fill: "url(#paint45_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1065.45 23.3 6.76 268.7-18.3 152.9 29.84 1.9 10.54-152.9 60.77-185-7.75-3.8s-48.14 163.6-54.91 164.6c-6.76 1-.89-245.4-.89-245.4l-26.06-1Z",
    fill: "url(#paint46_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1118.66 442.7-72.4-1.7H1014.73v2.5c0-.4 0-1.3-.2-2.5h-22.381l-52.116 10.7-419.319 21s52.514-91.5 72.605-93.6c63.753-6.3 204.985-17 279.181 4.2 5.868 1.7 12.134 5.5 17.803 10.3 16.709 13.7 30.932 35.3 30.932 35.3s-1.293-50.1 4.177-53.4c5.471-3.2 77.978 8.2 82.648 12.6.2.2.6.8.8 1.3 2.88 6.5 4.37 30.3 5.07 44.2-.2-9.9 0-23.8 3.38-24.6 5.27-1.1 29.94 2.3 31.83 4.8.99 1.1 1.69 6.7 2.09 12.2.59 6.7.99 13.5.99 13.5s3.19-40.2 7.96-43.3c.2-.2.6-.4.99-.4 5.28-.4 19.3-1.1 37.6 3.2.8.2 1.29.4 1.69.6 8.45 4.8 18.2 43.1 18.2 43.1Z",
    fill: "url(#paint47_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m1118.66 442.7-72.41-1.7c1.1-.6 1.89-1 1.7-1.3-.2-.8 1.49-6.7 3.97-13.3.6 6.7 1 13.5 1 13.5s3.18-40.2 7.96-43.3c-1 9.2-2.29 37.8 8.95 41 19.19 5.5 49.33-24.8 29.54-38.1.79.2 1.29.4 1.69.6 7.85 4.3 17.6 42.6 17.6 42.6Z",
    fill: "url(#paint48_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1626.9 449.8-9.65 72-124.42 8.8-389.19 27.2-96.37 6.7-117.563 8.2-186.784 13.1-302.157-27-4.973-139s61.864 23.2 175.645 34.1h.795c7.161.8 15.516 1.1 24.865 1.5 76.981 3.2 216.821-3.4 323.739-9.5 82.353-4.8 145.313-9.5 145.313-9.5l560.75 13.4Z",
    fill: "url(#paint49_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "m1690.85 481.3-240.49 198.1-477.605-75.6-83.446-30.6-316.578-116-1.691-3h.796c7.161.8 15.515 1.1 24.864 1.5 21.484 10.1 47.84 21.9 62.262 26.6 27.152 8.7 105.625 23.2 105.625 23.2l119.948 27.2s54.106 14.5 122.335 32.1c163.11 42 406.89 102.1 185.69 26.2-33.72-11.6-63.36-22.6-89.31-32.9-26.06-10.4-219.71-45.2-239.005-54.3L1243.08 530l-249.24-40.9-177.932-31c-1.492-1.1 132.38 19 130.888 17.9l154.954 16.9c-11.33-1.5-108.904-15-173.155-34.6-3.779-4.6-6.465-8.6-8.155-12.2 82.35-4.8 145.31-9.5 145.31-9.5s80.46 65 595.86 42.8c9.55-.4 19.19 1.4 29.24 1.9Z",
    fill: "#43711C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M386.941 466c97.57 27.9 307.528 45.4 307.528 45.4l-28.446 1.9 265.556 17-48.437-9.2 189.268 7.4 6.47.2-161.524-20.8 300.364 11.7 101.35.6-207.87 29.6-500.675 11.1L385.549 505l1.392-39Z",
    fill: "url(#paint50_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.72 204.4s-18.4 10.1-23.67 9.9c-5.07-.2-18.8-9.7-18.8-9.7s-11.14 12.2-21.78 20.2c-5.27 4-10.44 7.2-13.83 7.2-10.44 0-41.17-2.3-43.26-4.6-.2-.2-.4-.4-.6-.8-1.69-2.5-2.98-6.7-2.98-6.7s-.2 1.9-.8 4.4c-.99 4.2-3.18 9.9-7.36 11.2-6.66 2.1-40.18-5.5-41.37-6.9-1-1.3-3.78-13-3.78-13l-20.69-14.5s-11.14 13.2-14.62 13.2c-3.38-.2-22.18-.4-24.86-3.2-1.3-1.5-5.87-5.1-9.85-8.6-3.78-3.1-7.06-5.7-7.06-5.7s.79 10.5-1.69 19.8c-1.3 4.8-3.38 9-7.06 11.6-7.36 5.3-16.32 6.7-20.89 6.9-1.89.2-3.08 0-3.08 0s-19.3 1.7-19.3 1.1v-1.1l-24.66-3-35.51-42.7 25.96-91.7 132.18-7.8 22.18.2 153.76 1h15.42c32.82 24.1 18 113.3 18 113.3Z",
    fill: "#41613D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1243.98 200c11.14 4 13.82 24.4 13.82 24.4l6.47 3.8s-4.58-8.2-4.77-17c-.2-8.8 11.93-31.8 11.93-31.8s-10.44 20.2-15.91 20.8c-5.67.8-11.54-.2-11.54-.2Z",
    fill: "url(#paint51_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.69 184.2c12.33 12 78.47 11.8 84.54 11.6 5.86-.2 21.78-9.7 21.78-9.7s12.93 12 25.06 20.2c6.07 4 32.62 9 36.4 10.1 62.96 20 137.46-1.9 139.94-4l.8-.8c2.09-2.5 3.58-6.7 3.58-6.7s.2 1.9.99 4.4c1.1 4.2 3.58 9.9 8.56 11.2 7.75 2.1 46.44-5.7 47.64-7.1 1.09-1.3 4.57-13.2 4.57-13.2l23.87-14.5s12.93 13.2 16.91 13c3.98-.2 25.56-.6 28.64-3.2 1.5-1.5 6.87-5.3 11.54-8.6 4.38-3.1 8.16-5.7 8.16-5.7s-1 10.5 1.89 19.8c1.49 4.8 3.98 9 7.95 11.4 8.56 5.1 18.8 6.5 23.87 6.9 2.29.2 3.58 0 3.58 0s-9.05.4-8.95 4.8c0 4.4 31.33 1.5 31.33-1.1v-3.6l28.45-3.1 40.98-42.9-29.64-91.7-152.28-7.2-25.56.2-287.73-1.9-17.31.2-57.88-1.9c-38.39 24-34.02 101.1-21.68 113.1Z",
    fill: "#538024"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1259.89 69s2.99 1.5 7.16 4c7.07 4.6 15.92 83.3 17.41 92.1 2.29 13.7-12.13 31.1-12.13 31.1 5.86-.2 21.78-9.7 21.78-9.7s12.93 12 25.06 20.2c-20.89-16.4-9.65-39.3-9.65-39.3l26.76-4.8s-41.18 2.3-48.94-.2c-5.27-1.7-3.78-83.1-2.88-89.4.4-2.9.8-4.8.8-4.8l-25.37.8Z",
    fill: "url(#paint52_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1074.2 489.1 122.34 3.6 22.97.8 25.46.8s4.38-6.3 1.89-7.6c-2.88-1.5-24.26-3.4-31.13-2.9-.39 0-.99.2-1.29.2-7.06 1.5-9.15 7.8-9.25 8.4 0-.4 0-2.9-1.49-5-1.1-1.5-2.89-2.9-6.07-3.4-9.65-1.7-81.75-11.4-107.12-9.2-33.51 3-16.31 14.3-16.31 14.3Z",
    fill: "url(#paint53_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1219.51 493.5c-1.69-1.3-5.07-4.8-5.07-9.3-7.06 1.5-9.15 7.8-9.25 8.4 0-.4 0-2.9-1.49-5-.8 2.3-3.98 4.2-7.06 5.3l22.87.6Z",
    fill: "url(#paint54_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1223.49 40.8 643.943 567.4l185.989 18.5L1265.96 5.7 860.068 586.9l43.463 4.8 393.559-618 55.2 3.8-371.081 616.2 219.011 6.7 254.81-633.6-205.58 14.7-25.96 59.3Z",
    fill: "#FAF9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.99 483.5v1.1l-2.09 95.7-1.19 50.7-203.1 1h-25.06l-16.12.2-33.02.2-22.57.2h-35.61l-18.2.2-321.651 1.7-6.465.2-22.975.6-63.356 1.7-70.019 1.9-5.669.2-13.128.4-27.65.8-113.184 3.1-5.272.2-19.892.6h-2.685l-19.295.6h-4.078l-11.04.4h-2.088l-13.129.4-195.139.8 32.225-63.1-.199-3.8-1.492-36.8-2.287-55.3 62.758 7.4h.796l123.827 14.9 4.575.6 14.023 1.7 6.266.8 15.317 1.9 8.951 1.1 2.089.2.796.2 17.405 2.1 20.489 10.1 9.647 4.8 4.177 2.1 127.606-1.5 4.973.2 15.516 1 9.249.4-.198-4.4 136.557.8 11.935 4.4h.199l.597.2h.795l83.243 3.8 1.1-1.3 4.18-4.8s1.29 0 3.58-.2c14.02-1 64.45-4.8 92.49-6.9 1.69-.2 3.58-.2 5.08-.4 8.55-.6 13.82-1 13.82-1l7.96-.8h.79l12.14-1.1 72.1-6.9 5.47-.6 12.54-1.1 20.68-1.9 20.09-1.9 10.85-1 7.16-.8 2.98-.2 11.14-1.1 18.8-1.7 9.05-1 13.13-1.3 4.77-.4 11.54-1.1 2.09-.2 200.31-19Z",
    fill: "#538024"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m973.551 635.5 675.329-3.4 1.09-50.7 2.09-96.9-273.51 25.9 259.39-14.9-179.03 31.5 125.72-5.9s-90.31 33.4-281.77 41.4c-191.56 8-280.08 48.2-378.741 77.6l49.432-4.6Z",
    fill: "#701D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1225.98 531-14.82 3.1h-.2s0-.6.2-1.7l-16.71.8-3.08 1.9-6.27 3.2-3.08 1.7s8.75-33.2 9.64-97.2c0-7.8.2-16 .2-24.8.2-23.6 0-50.9-.59-81.6-.4-26.7-1.1-56.1-2.49-88.1V247c-6.86-190.5-14.82-209.7-15.22-210.5l13.63 13 7.56 7.4s4.17 80.3 9.45 174.8v.8l.19 1.7.2 5 .2 3.4.2 3.2v1c3.58 61.2 7.36 127 11.14 179.8 1.49 23.6 3.18 44.6 4.58 61.6 2.18 23.9 3.87 39.4 5.27 42.8Z",
    fill: "url(#paint55_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1208.17 469.8c6.07 27.3 3.78 55.7 3.19 62.7l-16.71.8-2.99 1.9-6.26 3.2-2.69.4s23.67-26.3 11.74-82.8c-1.1-5-1.89-9.3-2.69-13.2 0-7.8.2-16 .2-24.8 0 0 10.45-29.9 7.06-46.1-2.08-9.3-3.58-87.7-5.86-98.8-.4-26.7-2.89 5.5-3.98-24.6v-1.3c-6.87-190.4-14.82-209.6-15.22-210.4l13.63 13c.39 48.2 1.09 128.1 1.09 130.6 0 3.4 15.91 51.7 15.91 51.7v.8l.2 1.7.2 5 .2 3.4.2 3.2v1s-10.05-42.1-12.33-42.1c-2.29 0-2.89 56.8-2.89 56.8s2.69-5.3 4.38 5.9c1.29 9 15.32 127.4 21.78 159.2 1.49 23.6 3.18 44.6 4.58 61.6-6.27-26.9-16.91-73.2-19.9-84.9-4.37-16.6-3.78 20.2-4.57 20.2-.8 0 4.67 14.6 11.73 45.9Z",
    fill: "#992C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.16 532.6v1.5h-.2c0 .2.2-.4.2-1.5Z",
    fill: "url(#paint56_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.5 564.8s-.6 0-1.89.2c-4.98.6-19 2.3-38.1 5-47.44 6.5-126.31 18.7-175.64 33.8-74.298 22.7-95.582 38.9-95.582 38.9l-323.142-4.2-53.31-.8c97.271-43.9 518.674-74.6 525.844-75.9 7.16-1.5-93.5-24.8-99.364-25.5 3.784.2 46.444 2.3 71.114 2.9 3.58 0 6.66.2 9.25.2 4.18 0 6.86 0 7.76-.2 4.97-1.3 70.91 12.8 103.33 17.4 32.23 4.4 69.73 8.2 69.73 8.2Z",
    fill: "url(#paint57_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1095.89 567.3-163.814 15.3s-209.958 28.6-306.831 56.2l-53.31-.8c106.023-46.3 518.675-74.6 525.835-75.9l-1.88 5.2Z",
    fill: "url(#paint58_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1108.02 558.5 13.43-1.3 3.78 2.7s-1.3.4-6.07.6c-4.88-.1-11.14-2-11.14-2Z",
    fill: "url(#paint59_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.43 539c-6.86-2.1-26.76-3.1-26.76-3.1l-37.19 2.3s9.15 3.4 21.98 4.6c11.63 1 41.97-3.8 41.97-3.8Z",
    fill: "url(#paint60_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.95 565c9.85 1.9 21.78-2.3 21.39-2.9-.4-.6-13.83.6-13.83.6l-12.13 1.9 4.57.4Z",
    fill: "url(#paint61_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1268.84 523.4-4.57 2.5s-3.38.8-7.96.8c0 0-4.77-1-5.87-1.7-.39-.4-.39-.6.8-.8 3.58-.8 17.6-.8 17.6-.8Z",
    fill: "url(#paint62_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1142.53 556.2-4.57 2.5s-3.39.8-7.96.8c0 0-4.77-1-5.87-1.7-.4-.4-.4-.6.8-.8 3.78-.8 17.6-.8 17.6-.8Z",
    fill: "url(#paint63_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.91 546.3c6.67 1.3 14.62-1.5 14.42-1.9-.39-.4-9.25.4-9.25.4l-8.15 1.3 2.98.2Z",
    fill: "url(#paint64_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.31 545.3h-1.89l-4.18.2-14.22.4h-.8s-.59 0-1.49-.2c-.4 0-.79 0-1.09-.2-3.58-.4-11.14-1-19.89-2.1-8.16-1-17.61-2.1-25.46-3.4-.4 0-.8-.2-1.1-.2-3.18-.6-6.07-1.1-8.55-1.7-.4-.2-.8-.2-1.1-.4-.2 0-.39-.2-.59-.2.39 0 10.24.2 21.98.6h3.38c3.78.2 7.76.2 11.54.4 1.69 0 7.75 1.7 9.44 1.7l-4.37-1.5c1.09 0 2.09 0 3.08.2 1.69 0 3.38.2 4.97.2.8 0 1.5 0 2.09.2 1 0 1.69 0 2.49.2H1070.13c.59 0 1.09 0 1.49.2h.59c1.1.2 2.29.2 3.19.4h.39c.6 0 1.1.2 1.7.2.39 0 .79.2 1.09.2.4 0 .6.2.99.2.6.2 1 .2 1.5.4 3.38 1 5.86 1.9 7.55 2.9 0 0 .2 0 .2.2h.2c.2 0 .2.2.4.2.2.2.4.2.6.4.89.3 1.29.5 1.29.5Z",
    fill: "url(#paint65_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.47 531s-.2 0-.39.2c-.6.2-2.29 1-4.78 1.5-.6.2-1.09.2-1.69.4-1.69.2-3.78.6-6.27.6-4.77 0-9.15-.2-12.33-.6-3.08-.2-5.07-.6-5.07-.6l-9.15-1.1s.6 0 1.69-.2c1.49-.2 3.98-.4 7.16-.8 4.18-.4 9.65-.6 15.52-.6 11.93.1 15.31 1.2 15.31 1.2Z",
    fill: "url(#paint66_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.82 538.1c-.2 0-2.09 1.3-5.07 2.9-2.29 1.1-23.67 2.7-26.76 3.4-7.06 1.7-14.02 1-14.82.8l1-.8 3.18-2.5.2-.2-8.55.2c1.29-1 4.77-1.7 8.75-2.1.4 0 .99-.2 1.29-.2h.6c1.09-.2 2.29-.2 3.38-.4 5.27-.4 29.24-1 32.62-1 2.59-.1 4.18-.1 4.18-.1Z",
    fill: "url(#paint67_linear_1989_1050)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.2 556.6c-3.09-1-12.14-1.3-12.14-1.3l-16.91 1.1s4.18 1.5 10.05 2.1c5.17.4 19-1.9 19-1.9Z",
    fill: "url(#paint68_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1091.71 549.1-2.09 1.1s-1.49.4-3.58.4c0 0-2.09-.4-2.69-.8-.2-.2-.2-.2.4-.4 1.69-.3 7.96-.3 7.96-.3Z",
    fill: "url(#paint69_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.04 552.8c3.09.6 6.67-.8 6.67-1-.2-.2-4.18.2-4.18.2l-3.58.6 1.09.2Z",
    fill: "url(#paint70_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1044.07 559.8-2.09 1.1s-1.49.4-3.58.4c0 0-2.09-.4-2.69-.8-.2-.2-.2-.2.4-.4 1.49-.3 7.96-.3 7.96-.3Z",
    fill: "url(#paint71_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.4 563.4c3.09.6 6.67-.8 6.67-1-.2-.2-4.18.2-4.18.2l-3.58.6 1.09.2Z",
    fill: "url(#paint72_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.22 552.8c-.4.2-1.09.6-2.29.8-.2 0-.59.2-.79.2-.8.2-1.69.2-2.89.2-2.08 0-4.17-.2-5.67-.2-1.29-.2-2.28-.2-2.28-.2l-4.18-.6h.8c.79 0 1.89-.2 3.18-.4 1.89-.2 4.37-.2 7.06-.4 5.57 0 7.06.6 7.06.6Z",
    fill: "url(#paint73_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.08 555.4s-.99.6-2.29 1.3c-.99.6-10.84 1.1-12.13 1.5-3.18.8-6.46.4-6.86.4l.4-.4 1.49-1.1h.2l-3.78.2c.59-.4 2.09-.8 3.98-1h.99c.6 0 .99-.2 1.49-.2 2.49-.2 13.23-.4 14.82-.4.9-.3 1.69-.3 1.69-.3Z",
    fill: "url(#paint74_linear_1989_1050)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "m1290.82 23.4-284.65 494.7 54.21 14.7 243.67-517.7-13.23 8.3Z",
    fill: "#FAF9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.25 151.6c-17.31 11.2-44.56 10.5-44.56 10.5l-6.86-11.8c0 .4.4 1.9-.2 4v.2c-.4 1-1 2.1-1.69 3.1l-.6.6c-1.69 1.7-4.37 3.4-8.55 4.6-.2 0-.4.2-.8.2-.59 0-1.09.2-1.89.2-6.86-.2-21.78-4-38.49-9.3-3.38-1.1-7.06-2.3-10.64-3.4-6.66-2.1-13.23-4.4-19.89-6.7-7.06-2.5-13.83-4.8-19.89-6.9l-2.09-.8c-9.25-3.2-16.71-5.9-20.49-7.4l-1.49-.6-1.3-.4h-.19c48.33 23.5 27.15 56.1 27.15 56.1s-54.41 13.9-62.56 10.3c-7.76-3.4-19.297-22.1-20.291-23.6v.4c0 2.7-.597 22.5-19.295 20.6-8.952-1-13.129-5.3-15.019-9.9-1.491-4-1.491-8-1.293-10.1-.596 2.5-2.088 7.8-7.757 12-2.089 1.5-4.774 3.1-7.957 4-3.382 1.1-7.36 1.7-12.134 1.9-7.062.2-18.997-1.3-33.219-4.4-3.979-.8-8.156-1.7-12.532-2.9-39.684-9.9-88.021-28.4-89.911-48.2-1.094-10.3-1.293-18.7-1.293-25.2 0-2.3 0-4.4.199-6.3 0-1.1 0-2.1.199-3.1 0 .2-.199.4-.398.6-.398.6-.796 1.1-1.293 1.5-.796.8-1.691 1.5-2.884 2.3-1.293 1-2.984 1.7-4.973 2.3-3.581 1.1-8.554 1.9-14.82 1.9-15.316 0-29.44-15.3-33.915-32.2-.398-1.7-.796-3.4-1.094-5.1-1.094-7.4-.398-14.9 3.083-21.4.796-1.3 1.492-2.7 2.486-4 2.089-2.5 4.575-5 7.559-6.9 3.382-2.1 7.559-3.8 12.532-5.1C809.841 22 941.027 17.6 961.317 18.3c14.621.6 24.467 14.1 28.843 21.7 0-2.5 2.089-5.3 10.44-6.9 17.31-3.1 31.63-2.9 39.69.8 1.09.6 2.29 1.5 3.08 2.9.2.2.2.2.2.4s.2.4.2.4c1.09 2.3 1.89 5.3 2.48 8.2 1.1 7.4 1 15.3 1 15.3s7.06-1.9 17.8-4.2c7.96-1.7 18.2-3.6 29.44-5.3 12.53-1.7 26.16-3.1 39.29-3.1 14.42 0 28.05 1.5 38.89 5.9 6.26 2.5 12.33 6.1 18.2 10.7 17.6 13.7 32.22 35.3 39.78 53.6v.2l.2.4c6.07 14.9 7.06 27.9.4 32.3Z",
    fill: "#425A27"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "m1077.09 136.7-2.29-.8-20.49-7.4-1.49-.6-1.29-.4h-.4s-5.87-25.6-39.79-25.6c-3.18 0-6.46.2-10.24.8-36.6 4.8-24.267 43.9-19.692 55.7-2.885-6.3-9.449-18.9-16.511-15.1-4.973 2.7-3.779 37.8-3.779 37.8-1.492-4-1.492-8-1.293-10.1-.597 2.5-2.089 7.8-7.758 12 4.376-10.9 5.868-21.2 5.868-30.3 0-15.8-4.973-27.8-8.752-31.5-5.868-5.5-66.041-10.7-66.041-10.7s50.824 1.3 68.13 0c56.098-4.4 44.756-25.6 34.114-38.1 11.04-5 11.04-10.1 10.244-12.4 1.691 3.6 8.16 14.7 24.87 12.4 14.22-2.1 24.06-16.8 25.26-26.7 1.09 7.4.99 15.3.99 15.3s7.06-1.9 17.81-4.2c-7.07 2.5-14.82 6.3-22.78 12-26.36 18.7 33.82 66.6 35.31 67.9Z",
    fill: "#122205"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1230.85 119s-29.44-12.2-43.06-5.1c-13.43 7.1-1.3 47.3-1.1 48.2l-6.86-11.8c0 .4.4 1.9-.2 4v.2c-.4 1-1 2.1-1.69 3.1l-.6.6c-1.69 1.7-4.37 3.4-8.55 4.6-.2 0-.4.2-.8.2l-1.89.2c14.42-1.5 10.05-36 7.96-41.9-1.89-5.9-32.42-11.4-32.42-11.4s17.4 1 35.11 0c17.6-1 19.69-11.2 21.98-15.3 8.55-13.9-6.87-28.6-7.96-29.6 17.6 13.7 32.22 35.3 39.78 53.6v.2l.3.2Z",
    fill: "#122205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.24 213.9s-27.15-10.3-24.66-13.7c2.48-3.6 12.13-10.5 12.13-10.5 24.07 6.9 12.53 24.2 12.53 24.2Z",
    fill: "url(#paint75_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.15 154.4c0 2.7-7.56 10.9-7.56 10.9s-4.77-5.5-5.47-10.7c-.39-2.1 0-4 1.3-5.3 0 0 3.78.8 7.16 1.9 2.48 1 4.57 2.1 4.57 3.2Z",
    fill: "url(#paint76_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.87 149.3c-.4.4-.8.6-1 1-.4.4-.99.8-1.29 1-2.49 1.7-5.47 2.7-8.56 3.4-7.06 1.5-13.62 1-13.62 1s-2.09-6.3 3.78-12c1.29-1.3 3.08-2.5 5.27-3.6-.1-.2 23.17 1.6 15.42 9.2Z",
    fill: "url(#paint77_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.87 178.5s-14.62-5.5-13.23-7.4c1.29-1.9 6.47-5.7 6.47-5.7 13.02 3.7 6.76 13.1 6.76 13.1Z",
    fill: "url(#paint78_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.88 202.1c0 1.5-4.17 5.9-4.17 5.9s-4.98-5.9-2.29-8.6c.2-.2 6.46 1.2 6.46 2.7Z",
    fill: "url(#paint79_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.55 172.6c-4.18 4.2-3.18 10.1-3.18 10.1s-11.74-11.8-5.27-15.3c.1 0 12.63 1 8.45 5.2Z",
    fill: "url(#paint80_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.22 165.5c0 1.3-3.77 5.3-3.77 5.3s-4.58-5.3-2.09-7.8c0 0 5.86 1 5.86 2.5Z",
    fill: "url(#paint81_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.76 177.5s-12.53 3.6-22.38-4.4c0 0-.8-17.2 10.64-12.6 11.54 4.6 11.74 17 11.74 17Z",
    fill: "url(#paint82_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1040.88 202.1c0 1.5-4.17 5.9-4.17 5.9s-4.98-5.9-2.29-8.6c.2-.2 6.46 1.2 6.46 2.7Z",
    fill: "url(#paint83_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1162.22 165.5c0 1.3-3.77 5.3-3.77 5.3s-4.58-5.3-2.09-7.8c0 0 5.86 1 5.86 2.5Z",
    fill: "url(#paint84_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1007.27 597-45.555-5.5-8.753-5.1 160.628.8-106.32 9.8Z",
    fill: "url(#paint85_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1155.36 571.4-28.24-1.3-5.08-1.7 101.45-2.3-68.13 5.3Z",
    fill: "url(#paint86_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1119.16 573.5-42.47 7.4 30.33 3.6 73.21-12.2-61.07 1.2Z",
    fill: "url(#paint87_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020 581.6 11.73-4.4 79.07-6.7-37.19 8-53.61 3.1Z",
    fill: "url(#paint88_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019.4 603.7 1.49-.4 60.47-9.3-61.26 4.2s-3.78 3.2-3.58 3.2c.2 0 2.88 2.3 2.88 2.3Z",
    fill: "url(#paint89_linear_1989_1050)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m1290.82 563.4-33.02 1.7h-.19c1.29-.2 1.89-.2 1.89-.2s-37.4-3.8-69.82-8.4c-32.23-4.6-98.27-18.7-103.34-17.4-.4 0-1 .2-2.09.2l4.18-4.8s1.29 0 3.58-.2c60.47 15.3 123.82 17.2 123.82 17.2l1.1 6.1 1.29-10.7 72.6 16.5Z",
    fill: "#701D70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1259.5 564.8s-.6 0-1.89.2c-4.98.6-69.23 9.5-88.52 12.2 4.97-1.3 37.59-11.1 37.39-11.4-.59-2.5-75.88-18.9-137.15-26.5 3.58 0 6.66.2 9.25.2 4.18 0 6.86 0 7.76-.2 4.97-1.3 70.91 12.8 103.34 17.4 32.32 4.3 69.82 8.1 69.82 8.1Z",
    fill: "#6D1D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1333.09 536-1.09 1.9-13.63 23.3-7.95 13.3-2.49 4.2s-17.11-7.6-19.19-5.7c-2.09 2.1-34.72 3.6-32.83 15.3.4 1.9 1.3 4.2 2.69 6.5 2.29 4 5.67 8.4 9.15 12.8.6.8 1.29 1.5 1.89 2.3 2.69 3.2 5.07 6.3 7.16 9 .4.4.6.8 1 1.1 1.49 2.1 2.88 4 3.38 5.3v.2c.2.6.4 1 .4 1.3 0 1-.2 3.8-.4 7.6-.4 4-.8 9.3-1.49 15.1-.6 5.7-1.5 12.2-2.29 18.3-.4 2.7-.8 5.3-1.3 7.8-1.88 10.3-3.97 19.8-6.66 25.5-.6 1.1-1.09 2.3-1.69 3.1-.2.4-.6.6-.8.8h-.39l-3.58-.2-11.04-.6h-.2l-9.65-.4-6.07-.4s-.4-.4.2-1.3c.6-.8 1.69-1.9 3.98-3.4 1.89-1.1 4.58-2.7 8.16-4.2.99-.4 1.89-1 2.68-1.7.2-.2.4-.2.6-.4.4-.4.79-.6 1.09-1l.6-.6.6-.6c.39-.6.99-1.1 1.29-1.9.2-.2.4-.6.6-.8.39-.6.79-1.1.99-1.7.2-.2.4-.6.4-.8.4-.6.59-1.1.99-1.7.2-.4.4-.8.6-1.1.2-.6.6-1.1.79-1.7 1.1-2.5 2.09-5.1 3.09-8 0-.2.2-.4.2-.8.99-3.1 1.89-6.1 2.68-9.2.2-.4.2-.8.4-1.1 1.09-4.6 1.89-9 2.69-13.2 0-.6.19-1.1.19-1.5.2-.8.2-1.5.4-2.3.2-1.3.2-2.5.4-3.6 0-.6.2-1.1.2-1.7V637c.2-3.2 0-5.7-.4-7.6-.2-1.3-.6-2.5-1.09-3.8-2.09-5.1-6.47-10.7-11.04-15.8l-.4-.4c-1.29-1.3-2.49-2.7-3.58-4 0 0 0-.2-.2-.2-3.38-3.6-6.47-6.9-8.35-9.2-.6-.8-1-1.3-1.1-1.7-.6-.8-1.49-2.1-2.88-3.8-2.09-2.5-5.08-5.7-8.36-9.2-3.98-4.2-6.26-5.5-9.84-9-3.58-3.6-6.47-6.3-7.17-6.7-2.68-1.5-49.33-21.2-52.91-20.8-.79 0-3.58-2.5-7.36-6.3-.79-.8-1.29-1.5-2.09-2.3-.59-.6-.99-1.1-1.49-1.7-.59-.6-1.09-1.1-1.49-1.7-.2-.2-.6-.6-.8-1-3.18-3.4-6.66-7.4-10.04-11.4-.6-.8-1.09-1.3-1.69-2.1-.6-.8-1.1-1.3-1.89-2.1-1-1-1.69-2.1-2.69-3.1-.99-1.1-1.69-2.1-2.68-3.1-1.69-2.1-3.38-4-4.98-5.7-.59-.6-.99-1.1-1.49-1.9-.59-.6-1.09-1.3-1.49-1.9-4.18-5-6.86-8.2-6.86-8.2l6.46-1.1 1.1-.2c.59 1 1.89 2.9 3.58 5.5.4.6.99 1.3 1.29 1.9 1 1.3 1.89 2.7 2.98 4.2.4.4.6 1 1 1.3.4.4.79 1 .99 1.3l.2.2c.2.2.4.4.6.8.8 1 1.29 1.9 2.09 2.9.4.6.99 1.3 1.49 1.9 1.49 2.1 2.88 4 4.38 5.9.99 1.3 1.89 2.7 2.88 3.8 2.49 3.4 4.97 6.5 6.86 9 1.3 1.7 2.49 3.1 3.38 4 .2.4.6.6.8.8l.2.2.2.2s.2 0 .2.2c1.29 1.1 2.48 1.9 3.78 2.7 3.58 2.1 6.86 2.3 7.95 1.7.2-.2.4-.8.6-1.7.2-.4.2-.8.2-1.3 0-.4.2-.6.2-1s.2-.8.2-1.3V533c.2-.8.2-1.5.39-2.3v-1.2c0-.4 0-.8.2-1.1 0-.6.2-1.1.2-1.9 0-.6.2-1.3.2-1.9.2-1.5.4-3.2.4-4.8.2-1.3.2-2.7.4-3.8V515.4c.2-1.9.39-3.6.39-5.1.2-2.1.2-3.4.2-3.4h1.5s-.2 1.3-.6 3.4c-.2 1.5-.6 3.6-.8 5.7v.2c0 .4-.2 1-.2 1.5-.19 1-.19 2.1-.39 3.1 0 .6-.2 1-.2 1.5 0 .6-.2 1.1-.2 1.7v.8c0 .6 0 1.1-.2 1.7v.4c0 1-.2 1.9-.2 2.9-.2 3.2-.4 9.2-.2 11.2.2 1.3.6 2.3 1.1 2.7 3.78 1.7 44.16 17.2 44.16 17.2l-1.3-5.3 1-2.9s1.29 7.2 3.38 10.1c1.49 2.1 10.04 9.7 16.91 14.9 2.28 1.7 4.37 3.1 5.87 3.8 1.69.8 3.18 1.3 4.57 1.5 3.78.4 5.87-7.1 6.07-8 0-.6 1.09-1.7 2.09-3.1.79-1.1 1.69-2.3 2.08-3.6v-.2c.4-1.1.2-2.3-.39-3.2-.4-.8-1.69-2.5-3.58-5.1-1.69-2.5-3.98-5.5-6.47-9-.4-.4-.79-1-1.09-1.5-.4-.6-.8-1-1.1-1.5-1.09-1.7-2.48-3.4-3.78-5.1-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-.99-1.3-2.09-2.7-3.08-4.2-3.09-4.2-6.07-8-8.56-11.2-.39-.6-.79-1.1-1.29-1.7-1.69-2.3-3.08-4.2-3.98-5.1 0-.2-.2-.2-.2-.4-.2-.4-.39-.6-.59-.8l1.29-1.9s.8 1.3 2.29 3.4c.2.2.2.4.4.8.19.2.39.6.59.8.2.2.4.6.6.8.4.6.79 1.1 1.29 1.9.2.4.4.8.8 1 .2.4.4.8.79 1.1 0 0 0 .2.2.2 0 0 0 .2.2.2.2.2.4.4.4.8.2.2.4.4.4.8 0 .2.2.2.2.4s.19.2.19.4c.4.6.6 1 1 1.5 1.29 2.1 2.88 4.2 4.38 6.3.79 1.1 1.49 2.1 2.28 3.2.4.6.8 1.1 1.1 1.7.39.6.79 1.1 1.09 1.7.2.4.6.8.8 1 1.89 2.5 3.58 5 5.27 7.2.59.8 1.29 1.7 1.89 2.5 3.38 4.4 6.46 8 8.35 9.3.8.6 1.3.8 1.69.6l.2-.2c.8-1 .8-3.8.6-7.8v-2.8c0-1.1-.2-2.1-.2-3.2 0-.4 0-.8-.2-1.3 0-.8-.2-1.3-.2-2.1-.2-1.3-.2-2.7-.4-4 0-.4 0-1-.19-1.3 0-.4 0-.8-.2-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c0-.8-.2-1.3-.2-2.1s-.2-1.7-.2-2.5-.2-1.5-.2-2.3c0-.8-.2-1.5-.2-2.1 0-.8-.2-1.3-.2-2.1v-1c0-1.3-.2-2.5-.2-3.4v-4.5c0-.2.2-.4.2-.6l2.09.6c0 .2-.2.4-.2.6 0 .2 0 .6-.2.8v8.6c0 .6 0 1 .2 1.5v3c0 .4 0 1 .2 1.3 0 1 .2 2.1.2 3.2v.2c0 .6 0 1.1.2 1.7 0 .6.2 1.1.2 1.9 0 1 .2 1.7.2 2.7v2.1c0 .4 0 .8.2 1.1 0 .6.19 1.1.19 1.7V543.8c.2 1 .2 1.9.4 3.1 0 .6.2 1.1.2 1.7 0 .4 0 .6.2.8v1.4c0 .6.2 1 .2 1.5v1c.4 4 .8 7.1.8 8v.2c0 1.1-5.28 8.4.79 11.8 6.07 3.4 21.38-3.1 22.98-4.6.19-.2.39-1.3.39-3.1.2-2.5 0-6.3 0-10.7 0-1.1 0-2.3-.2-3.4V546.6c0-1.7-.19-3.2-.19-4.8v-1.5c0-.8 0-1.7-.2-2.5 0-1.1-.2-2.3-.2-3.4 0-.8-.2-1.3-.2-1.9v-.8.1V527.2l1.09-3.6v14.1c0 1.7.2 3.6.2 5.5V554.7c.2 4.6.4 8.6.6 10.9.2 1.1.2 1.9.4 2.1.99 1.9 15.31 7.1 19.89 4 .4-.4.79-.8 1.09-1.1 1-1.7.4-6.5-.4-12.2 0-.4-.19-.8-.19-1 0-.4-.2-.8-.2-1.1-.4-2.1-.8-4.4-1.3-6.7 0-.2-.2-.6-.2-.8-.39-1.9-.79-3.8-1.09-5.5 0-.4-.2-.6-.2-1s-.2-1-.4-1.3c-.39-1.5-.79-2.9-.99-4.2v-.2c-.2-.4-.2-.8-.4-1.3-.2-.6-.4-1.1-.4-1.7-.19-.4-.2-1-.39-1.3v-.2c-.2-.8-.4-1.5-.6-2.1-.2-.6-.2-1-.4-1.1v-.2l.6-1 .2-.6v-.3l3.38 1V529.8c0 .2.2.6.2.8 0 .4.2.8.2 1.1 0 .3.2 1 .2 1.5 0 .4.19.8.19 1.1v2c.2 1.5.4 3.1.6 4.6.2 1.5.4 2.9.6 4.4v.2c0 .6.2 1.1.2 1.5 0 .6.2 1.3.2 1.9v1.4c0 .6.19 1.1.19 1.7 0 .4.2 1 .2 1.3 0 .4.2 1 .2 1.3 0 .4.2.8.2 1.1v1.2c0 .4.2.8.2 1.1 0 .4.2.8.2 1.1.79 2.9 1.69 5 2.88 5 1.5.2 3.19-1.1 4.98-3.4.39-.4.79-1 1.09-1.3.4-.6.8-1 1.09-1.5 1-1.3 1.7-2.9 2.69-4.4.6-1 .99-1.9 1.49-2.9.4-.6.6-1.3 1-1.9.79-1.5 1.49-3.1 2.09-4.4.19-.2.19-.6.39-.8.4-.6.6-1.1.8-1.7.2-.2.2-.6.4-.8.2-.4.2-.6.39-1 .2-.2.2-.6.4-.8.2-.4.4-.8.4-1.1l.2-.2v-.2l-.2-.4-1.69-3.2 8.15 1.9Z",
    fill: "url(#paint90_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1246.27 551h-1c-.4-.4-.79-1-1.09-1.5-.4-.6-.8-1-1.1-1.5-1.09-1.7-2.48-3.4-3.77-5.1-.4-.6-.8-1.1-1.3-1.7-.2-.4-.4-.6-.59-1-.2-.2-.4-.4-.6-.8-.2-.2-.4-.4-.6-.8-.99-1.3-2.09-2.7-3.08-4.2-2.99-4.2-6.07-8-8.55-11.2-.4-.6-.8-1.1-1.3-1.7-1.69-2.3-3.08-4.2-3.98-5.1 0-.2-.2-.2-.2-.4-.19-.4-.39-.6-.59-.8l1.29-1.9s.8 1.3 2.29 3.4c.2.2.2.4.4.8.2.2.39.6.59.8.2.2.4.6.6.8.4.6.8 1.1 1.29 1.9.2.4.4.8.8 1 .2.4.4.8.79 1.1 0 0 0 .2.2.2 0 0 0 .2.2.2.2.2.4.4.4.8.2.2.4.4.4.8 0 .2.2.2.2.4s.2.2.2.4c.39.6.79 1 .99 1.5 1.29 2.1 2.88 4.2 4.38 6.3.79 1.1 1.49 2.1 2.28 3.2.4.6.8 1.1 1.1 1.7.4.6.79 1.1 1.09 1.7.2.4.6.8.8 1 1.89 2.5 3.58 5 5.27 7.2.79 1 1.39 1.8 2.19 2.5Z",
    fill: "#6574AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1259.1 552.4-2.09-.2v-2c0-1.1-.2-2.1-.2-3.2 0-.4 0-.8-.2-1.3 0-.8-.2-1.3-.2-2.1-.2-1.3-.2-2.7-.4-4 0-.4 0-1-.19-1.3 0-.4 0-.8-.2-1.1V536c0-.8-.2-1.7-.2-2.5v-.4c0-.8-.2-1.3-.2-2.1s-.2-1.7-.2-2.5-.2-1.5-.2-2.3c0-.8-.2-1.5-.2-2.1 0-.8-.2-1.3-.2-2.1v-1c0-1.3-.2-2.5-.2-3.4v-4.5c0-.2.2-.4.2-.6l2.09.6c0 .2-.2.4-.2.6 0 .2 0 .6-.2.8v8.6c0 .6 0 1 .2 1.5v3c0 .3 0 1 .2 1.3 0 1 .2 2.1.2 3.2v.2c0 .6 0 1.1.2 1.7 0 .6.2 1.1.2 1.9 0 1 .2 1.7.2 2.7v2.1c0 .4 0 .8.2 1.1 0 .6.19 1.1.19 1.7V544.1c.2 1 .2 1.9.4 3 0 .6.2 1.1.2 1.7 0 .4 0 .6.2.8v1.4c.5.4.6 1 .6 1.4Z",
    fill: "#6574AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m1143.82 521.5-5.47-1c-.59-.8-1.09-1.3-1.89-2.1-.59-.8-1.09-1.3-1.89-2.1-.99-1-1.69-2.1-2.68-3.1-1-1.1-1.69-2.1-2.69-3.1-1.69-2.1-3.38-4-4.97-5.7-.6-.6-.99-1.1-1.49-1.9-.6-.6-1.1-1.3-1.49-1.9l-.4-9.3 1.09-.2c.6 1 1.89 2.9 3.58 5.5.4.6 1 1.3 1.3 1.9.99 1.3 1.89 2.7 3.08 4.2.4.4.6 1 .99 1.3.4.4.8 1 1 1.3l.2.2c.2.2.4.4.59.8.8 1 1.3 1.9 2.09 2.9.4.6 1 1.3 1.5 1.9 1.49 2.1 2.88 4 4.37 5.9 1.29 1.8 2.29 3.2 3.18 4.5Z",
    fill: "#6574AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1158.84 538.3c-1.49 0-3.08 0-4.57.2-.8-.8-1.3-1.5-2.09-2.3-.6-.6-1-1.1-1.49-1.7-.6-.6-1.1-1.1-1.49-1.7-.2-.2-.6-.6-.8-1l2.29-1.5c1.29 1.7 2.48 3.1 3.38 4 .2.4.6.6.79.8l.2.2.2.2s.2 0 .2.2c.9 1.2 2.19 2 3.38 2.6Z",
    fill: "#6574AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1170.98 516.9c0 .6-.2 1.1-.2 1.5-.2 1-.2 2.1-.4 3 0 .6-.2 1-.2 1.5 0 .6-.2 1.1-.2 1.7v.8c0 .6 0 1.1-.2 1.7v.4c0 1-.2 1.9-.2 2.9-.19 3.2-.39 9.2-.19 11.2-.8 0-1.3-3.1-2.09-3.1.2-.4.2-.8.2-1.3 0-.4.19-.6.19-1s.2-.8.2-1.3v-1.1c.2-.8.2-1.5.4-2.3v-1.2c0-.4.2-.8.2-1.1 0-.6.2-1.1.2-1.9 0-.6.2-1.3.2-1.9.2-1.5.4-3.2.4-4.8.19-1.3.19-2.7.39-3.8V516.2l1.3.7Z",
    fill: "#6574AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1327.62 513.7 33.22 25.9-28.64-1.5h-.2l-3.38-.2-12.73-.8-4.97-.2 11.13 3.1c-.39.2-3.38 1.1-6.66 2.3-3.38 1.1-7.16 2.5-9.15 3.2h-.2c-.4.2-.79.4-.99.4-.4.2.2.8 1.29 1.3 2.29 1.1 6.27 2.9 6.66 2.9h-.39c-.8 0-2.89-.2-5.87-.2h-2.29c-4.77 0-11.54.4-19.89 1.5h-.8c-3.08.4-6.06.8-9.45 1.3-5.66 1-10.84 1-15.31.4-.8-.2-1.49-.2-2.09-.4-4.97-1-9.25-2.5-12.93-4.2-.4-.2-.8-.4-1.09-.6-6.67-3.6-10.25-7.4-10.25-7.4l4.58-.2h.79l17.81-1 1.69-.2 25.56-1.3h.99l17.31-1 2.68-.2s-1.09-.4-2.98-1.1c-3.08-1.1-8.16-3.1-13.63-5.3-1.09-.4-2.28-1-3.38-1.3-.4-.2-.79-.4-1.09-.4-7.76-3.2-15.52-6.7-19.7-9.3-2.08-1.3-4.57-2.1-6.86-2.7-.79-.2-1.29-.4-2.09-.4-8.75-1.3-17.6.8-17.6.8l15.32 3.4s-3.78 2.5-25.27 3.2h-1.69c-3.58 0-7.76.2-12.33.2-11.14 0-25.96-2.9-41.57-6.7-.4 0-.6-.2-1-.2-12.73-3.2-25.56-7.2-37.2-10.9-.2 0-.39-.2-.59-.2-3.19-1-6.27-2.1-9.25-3.1-15.22-5.1-25.76-9.2-25.76-9.2s37.69-11.1 81.16-19.6c1.69-.4 3.58-.8 5.27-1 17.8-3.4 36.4-6.3 53.7-7.6.8 0 1.5-.2 2.29-.2 11.14-.8 21.58-1 30.93-.4 53.51 4 108.51 50.7 110.9 52.8l-11.14-2.9 6.27 12.8c-.4-.4-15.32-13-28.25-17.7-4.97-1.9-8.95-1.7-12.33-1-5.57 1.5-8.56 5.1-8.56 5.1Z",
    fill: "url(#paint91_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1356.47 503 5.07 6.1c-.8-.4-23.87-13-65.44-18.1-4.58-.6-20.89-7.6-30.74-10.7-.39-.2-.79-.2-1.09-.4-2.49-.8-4.38-1.1-5.47-1.1-4.78 0-9.45.4-13.83.8l20.49 11.6c-28.24 3.6-45.75 15.8-45.75 15.8l-3.18 1.1s-6.66 4.8-38.89 3.4c-1.89 0-3.98-.2-6.07-.4h-1.29c-11.04-1-24.27-2.9-37.6-5.1h-.59c-2.69-.4-5.07-1-7.76-1.3-27.85-5.1-53.11-26.5-53.11-26.5l58.58-10.5 5.07-1 28.45-11.8-27.65 1.1h-1c.4-.2 31.13-20.6 81.16-21h2.49c5.67 0 11.54.2 17.6 1 9.85 1 20.09 2.7 30.74 5.5.79.2 1.29.4 2.08.6.2 0 .4 0 .6.2 10.64 2.9 20.49 6.7 29.54 11.1 1 .4 1.69.8 2.69 1.3 7.95 3.8 15.51 8.2 22.57 12.6 4.18 2.7 7.96 5.3 11.74 8 2.29 1.7 4.57 3.4 6.86 5.1 1.89 1.5 3.58 2.9 5.27 4.4 20.29 16.8 32.23 31.8 33.22 33l-24.76-14.8Z",
    fill: "url(#paint92_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.65 539.6s-12.54.6-28.65-1.5h-.2c-1.09-.2-2.29-.2-3.38-.4-7.56-1.1-15.71-2.9-23.67-5.3-.8-.2-1.69-.6-2.49-1-.79-.2-1.49-.6-2.28-.8-4.18-1.5-7.96-3.4-11.74-5.5-30.34-17.4-49.83-15.1-49.83-15.1 8.55-7.4 19.89-11.4 31.63-13.5.2 0 .4 0 .59-.2 22.38-3.8 45.16-.2 50.43 1.9 3.18 1.3 9.25 5.7 15.32 10.3 8.95 6.9 17.8 14.7 18.6 15.4l-11.54-6.3 17.21 22Z",
    fill: "url(#paint93_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.2 550.3h-.39l-6.07-.8-2.29-.2-19.69-2.3h-.8l-25.56-3-1.89-.2-17.4-2.1h-1l-5.27-.6c1.09-.6 2.29-1.1 3.38-1.7.2-.2.4-.2.6-.4 6.26-2.9 12.53-4.8 18.4-6.1.6-.2 1.09-.2 1.69-.4 9.25-1.9 18-2.5 25.96-1.9h1.09c1.1 0 2.29.2 3.18.2 4.78.4 8.96 1.1 12.93 2.1 1.5.4 3.09.8 4.38 1.1 4.38 1.1 8.16 2.5 11.04 3.6 3.78 1.5 5.87 2.7 6.27 2.9l-16.31 1.1-3.19.2-2.68.2 3.18 2.1 2.88 1.9.2.2 7.36 4.1Z",
    fill: "url(#paint94_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.81 436.5c-4.98-.6-10.05-1.1-15.02-2.1-6.47-1.1-11.54-2.7-15.52-4-8.95-3.1-11.73-5.9-11.73-5.9 21.98.2 30.73 4.2 34.11 7.1 1.89 1.7 2.29 3.1 2.29 3.1l5.87 1.8Z",
    fill: "url(#paint95_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1280.98 634.9c-.4 4-.8 9.3-1.49 15.1-1.5-6.9-5.08-9.9-6.27-10.7 1.09 10.5 2.88 22.1 3.98 29.2-.4 2.7-.8 5.3-1.29 7.8 0-9.9-2.09-28.6-4.38-40.2-1.09-5.9-2.49-9.9-3.58-10.1h-.4c-2.09-5.1-6.46-10.7-11.04-15.8 5.67 6.1 11.34 11.8 12.73 11.6h.2c2.49-.8-.99-11.8-1.69-13.9.6.8 1.29 1.5 1.89 2.3.4 2.7 2.09 13.3 2.69 19.6.19 1.3.19 2.7.39 4 .2 1.1.6 2.3 1 3.1.99 1.9 4.37 7.8 5.47 5.7.99-1.7-1.29-18.1-2.09-23.5.4.4.6.8.99 1.1 0 2.9.2 10.7 3.19 12.2-.3.1-.3 1-.3 2.5Z",
    fill: "#7F2659"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1255.72 568.6c-.4 1.3-1.1 2.5-2.09 3.6.99-1.9 1.69-3.2 2.09-3.6Z",
    fill: "#7F2659"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1271.43 636.1c0 .4-.2.8-.4 1-1.49 2.5-1.09 22.9-1.49 29.2v.2c0 1-.2 1.7-.2 1.7-.79.6-1.49 9.7-2.68 13.7-.8 2.9-2.49 6.3-3.39 8.2 1.1-1.9 3.09-5.1 3.09-3.4 0 1.3-1.49 8.6-2.89 14.7-.2 1.1-.59 2.3-.79 3.2 0 .4-.2.6-.2 1l-11.04-.6h-.2l-9.65-.4-6.06-.4s-.4-.4.19-1.3c.6-.8 1.7-1.9 3.98-3.4 1.89-1.1 4.58-2.7 8.16-4.2.99-.4 1.89-1 2.68-1.7.2-.2.4-.2.6-.4.4-.4.8-.6 1.09-1l.6-.6.6-.6c.4-.6.99-1.1 1.29-1.9.2-.2.4-.6.6-.8.4-.6.79-1.1.99-1.7.2-.2.4-.6.4-.8.4-.6.6-1.1.99-1.7.2-.4.4-.8.6-1.1.2-.6.6-1.1.8-1.7 1.09-2.5 2.09-5.1 3.08-8 0-.2.2-.4.2-.8.99-3 1.89-6.1 2.68-9.2.2-.4.2-.8.4-1.1 1.1-4.6 1.89-9 2.69-13.2 0-.6.2-1.1.2-1.5.2-.8.2-1.5.39-2.3.2-1.3.2-2.5.4-3.6 0-.6.2-1.1.2-1.7v-2.1c.2-3.2 0-5.7-.4-7.6-.2-1.3-.59-2.5-1.09-3.8-2.09-5.1-6.47-10.7-11.04-15.8l-.4-.4c-1.29-1.3-2.48-2.7-3.58-4 0 0 0-.2-.2-.2-3.38-3.6-6.46-6.9-8.35-9.2v-.4c0-1 13.82 12.2 13.62 11.6-1.29-8.4-18.99-24.2-22.57-29.7 2.28 1.7 4.37 3 5.86 3.8 1.7.8 3.19 1.3 4.58 1.5 3.78.4 5.87-7.1 6.07-8 0-.6 1.09-1.7 2.09-3.1-2.49 5.3-5.67 15.3 0 25 1.49 2.7 8.55 11.1 11.93 15.6 1.29 1.7 2.69 5.1 3.78 9 1.29 5 2.39 11.3 1.79 14Z",
    fill: "#7F2659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.98 489.3c-3.38-2.1-8.95-5.5-15.51-9.5-7.76-4.6-17.11-9.9-26.96-14.9-18.99-9.7-39.08-18.1-51.02-17.5-15.51.8-32.02 13.2-32.02 13.2l29.44 12 18 7.8c-1.1-.4-11.04-3.6-23.47-6.9-16.12-4-43.77-7.2-55.6-4l7.06-2.3 9.65-3 9.65-5-13.43-3.4h-.4s38.29-18.3 63.55-10.7c9.85 2.9 25.57 11.2 40.98 19.8 9.25 5.3 18.2 10.7 25.76 15.3 6.17 3.9 11.34 7.2 14.32 9.1Z",
    fill: "url(#paint96_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.81 436.5c-4.98-.6-10.05-1.1-15.02-2.1-6.47-1.1-11.54-2.7-15.52-4-8.95-3.1-11.73-5.9-11.73-5.9 21.98.2 30.73 4.2 34.11 7.1 1.89 1.7 2.29 3.1 2.29 3.1l5.87 1.8Z",
    fill: "url(#paint97_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.4 523.4c-11.73 0-18.8-10.5-20.68-11.8-1.1-1-1.1-1.5-1.1-1.5l-3.18-1.1c2.68.2 5.47.6 8.15 1 3.58.6 6.27 1.3 8.36 2.1 4.47 1.2 8.45 11.3 8.45 11.3Z",
    fill: "url(#paint98_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1239.4 543c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm0 0c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm44.06-8.5c0-.8-.19-1.3-.19-1.9V530.2c-7.96-.4-16.71 0-25.96 1.9 0 .6 0 1.1.2 1.7 0 .6.19 1.1.19 1.9 0 1 .2 1.7.2 2.7v1l25.56-1.3v-3.6Zm-27.55 3.6c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm-27.65-12.2c.4.6.6 1 1 1.5-.3-.6-.7-1-1-1.5Zm11.14 17.1c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm44.06-8.5c0-.8-.19-1.3-.19-1.9V530.2c-7.96-.4-16.71 0-25.96 1.9 0 .6 0 1.1.2 1.7 0 .6.19 1.1.19 1.9 0 1 .2 1.7.2 2.7v1l25.56-1.3v-3.6Zm-27.55 3.6c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm-27.65-12.2c.4.6.6 1 1 1.5-.3-.6-.7-1-1-1.5Zm78.08 19.8c0 .6.2 1.1.2 1.5 2.29 1.1 6.27 2.9 6.66 2.9l-6.86-4.4Zm-66.94-2.7c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm44.06-8.5c0-.8-.19-1.3-.19-1.9V530.2c-7.96-.4-16.71 0-25.96 1.9 0 .6 0 1.1.2 1.7 0 .6.19 1.1.19 1.9 0 1 .2 1.7.2 2.7v1l25.56-1.3v-3.6Zm-27.55 3.6c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm-26.75-10.7c-.2-.6-.6-1-.99-1.5.29.5.59.9.99 1.5Zm119.35-17.7c12.93 5 27.65 17.4 28.25 17.7l-6.27-12.8 11.14 2.9c-.99-1.1-12.93-16.4-33.22-33-1.69-1.5-3.58-2.9-5.27-4.4-2.29-1.7-4.38-3.4-6.86-5.1-3.78-2.7-7.56-5.3-11.74-8-7.06-4.4-14.42-8.8-22.58-12.6-.99-.4-1.69-.8-2.68-1.3-9.25-4.2-19.2-8-29.54-11.1-.2 0-.4 0-.6-.2-.79-.2-1.29-.4-2.09-.6-10.64-2.9-20.88-4.6-30.73-5.5-6.07-.6-11.93-1-17.6-1h-2.49c-50.03.6-80.76 20.8-81.16 21h1l13.42 3.4-9.64 5-9.65 3.1-58.58 10.5s25.26 21.4 53.11 26.5c1.49 1.7 3.18 3.8 4.97 5.7 1 1 1.69 2.1 2.69 3.1.99 1 1.69 2.1 2.68 3.1.6.8 1.1 1.3 1.89 2.1.6.8 1.1 1.3 1.69 2.1 3.38 4 7.06 7.8 10.05 11.4.2.4.59.6.79 1 .6.6 1.1 1.1 1.5 1.7.59.6.99 1.1 1.49 1.7.79.8 1.49 1.5 2.09 2.3 3.78 4 6.46 6.5 7.36 6.3 3.38-.4 50.22 19.3 52.91 20.8.79.4 3.58 3.1 7.16 6.7s5.87 4.8 9.85 9c3.18 3.4 6.06 6.7 8.35 9.2 1.29 1.7 2.49 3.1 2.88 3.8.4.6.8 1.1 1.1 1.7 1.89 2.3 4.97 5.5 8.35 9.2 0 0 0 .2.2.2 1.1 1.3 2.49 2.7 3.58 4l.4.4c4.58 5.1 8.95 10.7 11.04 15.8.6 1.3.99 2.7 1.09 3.8.4 1.9.4 4.4.4 7.6v2.1c0 .6 0 1.1-.2 1.7 0 1.1-.2 2.3-.39 3.6 0 .8-.2 1.5-.4 2.3 0 .6-.2 1.1-.2 1.5-.6 4.2-1.49 8.8-2.69 13.2 0 .4-.2.8-.39 1.1-.8 3.1-1.7 6.3-2.69 9.2 0 .2-.2.4-.2.8-.99 2.9-1.89 5.5-3.08 8-.2.6-.6 1.1-.8 1.7-.2.4-.4.8-.59 1.1-.4.6-.6 1.1-1 1.7-.2.2-.4.6-.4.8-.39.6-.59 1.1-.99 1.7-.2.2-.4.6-.6.8-.4.6-.99 1.3-1.29 1.9l-.6.6c-.2.2-.4.4-.59.6-.4.4-.8.8-1.1 1-.2.2-.4.4-.6.4-.99.8-1.69 1.3-2.68 1.7-3.58 1.7-6.27 3-8.16 4.2l-26.95-2.1-93.09-2.1-70.32 6.1 91.6 3.8-31.13 3.2 159.83 3.8 34.11-7.6-34.91-2.9c2.69-5.7 4.98-15.1 6.67-25.6.4-2.7.99-5.1 1.29-7.8 1-6.3 1.69-12.6 2.29-18.3.6-5.9 1.09-11.1 1.49-15.1.4-3.8.4-6.7.4-7.6 0-.4-.2-1-.4-1.3v-.2c-.6-1.3-1.69-3.2-3.38-5.3-.4-.4-.6-.8-1-1.1-2.08-2.7-4.57-5.7-7.16-9-.59-.8-1.29-1.5-1.89-2.3-3.38-4.4-6.86-8.8-9.15-12.8-1.29-2.3-2.28-4.6-2.68-6.5-2.09-11.6 30.73-13.2 32.82-15.3 2.09-2.1 19.2 5.7 19.2 5.7l2.48-4.2 7.96-13.3 13.62-23.3h.2c16.12 2.1 28.65 1.5 28.65 1.5l-17.41-21.7 11.54 6.3c-.8-.8-9.65-8.6-18.6-15.4 3.88-.4 8.06-.4 12.83 1.5Zm-120.25 16.2c0-.2-.19-.2-.19-.4-.2-.2-.2-.2-.2-.4-.2-.2-.4-.4-.4-.8-.2-.2-.4-.4-.4-.8 0 0 0-.2-.2-.2l-.2-.2c21.39-.8 25.27-3.2 25.27-3.2l-15.32-3.4s8.95-2.1 17.6-.8v.8c0 1 0 2.3.2 3.4v1c0 .6 0 1.3.2 2.1 0 .8.2 1.3.2 2.1s.2 1.5.2 2.3c0 .8.2 1.7.2 2.5s.2 1.3.2 2.1c-5.87 1.3-12.14 3.4-18.4 6.1-.4-.6-.8-1.1-1.1-1.7-.79-1.1-1.49-2.3-2.28-3.2-1.5-2.1-3.09-4.4-4.38-6.3-.3-.1-.7-.5-1-1Zm28.95 6.3c-.2-1.1-.2-2.3-.2-3.4 0-.4 0-1-.2-1.3V524.5c0-.6 0-1-.2-1.5v-6c2.49.6 4.77 1.5 6.86 2.7 4.18 2.7 12.14 6.1 19.7 9.3v1.6c-7.86-.9-16.61-.3-25.96 1.6Zm-90.21 8c-1.1.6-4.38.2-7.96-1.7-1.09-.8-2.48-1.5-3.78-2.7l-.2-.2-.2-.2-.19-.2-.8-.8c-.99-1-2.09-2.3-3.38-4-1.89-2.5-4.38-5.5-6.86-9-1-1.3-1.89-2.5-2.89-3.8-1.49-1.9-2.88-4-4.38-5.9-.39-.8-.99-1.3-1.49-1.9-.79-1-1.29-1.9-2.09-2.9-.19-.2-.39-.4-.59-.8l-.2-.2h.6c11.33 3.8 24.46 7.6 37.19 10.9 0 1.1-.2 2.5-.39 3.8-.2 1.5-.2 3.2-.4 4.8 0 .6-.2 1.3-.2 1.9 0 .6-.2 1.1-.2 1.9 0 .4 0 .8-.2 1.1v1.2c-.2.8-.2 1.5-.4 2.3v1.2c0 .4-.2 1-.2 1.3 0 .4 0 .6-.2 1 0 .4-.19 1-.19 1.3 0 .8-.2 1.4-.4 1.6Zm88.72 28.2v.2c-.4.4-1.1 1.7-2.09 3.6-1 1.3-2.09 2.5-2.09 3-.2 1-2.29 8.6-6.07 8-1.29-.2-2.88-.6-4.57-1.5-1.69-.8-3.58-2.3-5.87-3.8-6.86-5-15.32-12.6-16.91-14.9-2.09-2.9-3.38-10.1-3.38-10.1l-1 2.9 1.3 5.3s-40.38-15.3-44.16-17.2c-.6-.2-1-1.1-1.1-2.7-.39-1.9 0-7.8.2-11.2 0-1 .2-1.9.2-2.9v-.4c0-.6 0-1.1.2-1.7v-.8c0-.6 0-1.1.2-1.7 0-.6 0-1 .2-1.5.2-1 .2-2.1.4-3.1 0-.6.19-1 .19-1.5 15.52 3.8 30.54 6.7 41.58 6.7 4.57 0 8.75 0 12.33-.2 2.49 3.2 5.27 7.2 8.55 11.2 1 1.3 2.09 2.7 3.09 4.2-1.1.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4.4.6.8 1 1.09 1.5.4.6.8 1 1.1 1.5 2.49 3.4 4.77 6.5 6.46 9 1.89 2.7 3.19 4.4 3.58 5.1.1 1.6.1 2.8-.29 3.9Zm.79-7.6c-.6.4-1.09.2-1.89-.4-1.89-1.3-4.97-4.8-8.35-9.3-.6-.8-1.1-1.5-1.89-2.5 3.58 1.7 7.76 3.4 12.93 4.2-.1 4.2-.1 7-.8 8Zm27.65 4.9c0 1.7-.2 2.9-.4 3.1-1.49 1.5-16.9 8-22.97 4.6-6.07-3.4-.8-10.7-.8-11.8v-.2c0-1-.4-3.8-.79-8 4.57.6 9.84.6 15.31-.4 3.39-.6 6.47-1 9.45-1.3 0 1.1 0 2.3.2 3.4.2 4.1.2 8 0 10.6Zm22.78 5.4c-.2.4-.6.8-1.1 1.1-4.57 3-18.99-2.3-19.89-4-.2-.2-.2-1-.4-2.1-.2-2.3-.39-6.3-.59-10.9V551.6c8.35-1 15.01-1.3 19.89-1.5.6 2.3.99 4.6 1.29 6.7 0 .4.2.8.2 1.1 0 .4.2.8.2 1.1.79 5.6 1.19 10.4.4 12.1Zm21.58-33.2c0 .2-.2.2-.2.6-.2.2-.2.6-.4 1.1 0 .2-.2.4-.39.8-.2.2-.2.6-.4 1-.2.2-.2.6-.4.8-.2.6-.6 1.1-.8 1.7-.2.2-.2.6-.39.8-.6 1.3-1.3 2.9-2.09 4.4-.4.6-.6 1.1-1 1.9-.59 1-.99 1.9-1.49 2.9-.99 1.5-1.69 3.1-2.68 4.4-.4.6-.8 1.1-1.1 1.5-.4.6-.79 1-1.09 1.3-1.69 2.1-3.58 3.6-4.98 3.4-1.09-.2-2.08-2.1-2.88-5 0-.4-.2-.8-.2-1.1 0-.4-.2-.8-.2-1.1v-1.2c0-.4-.2-.8-.2-1.1 0-.4-.2-1-.2-1.3 0-.4-.19-1-.19-1.3 0-.6-.2-1.1-.2-1.7v-.4c2.98 0 5.07.2 5.86.2h.4l-6.86-4.4v-.2c1.89-.8 5.67-2.1 9.15-3.2 3.38-1.1 6.27-2.3 6.66-2.3-.2-.2-2.48-1.3-6.26-2.9l12.53.4Zm-100.26-12c.4.6.6 1 1 1.5-.3-.6-.7-1-1-1.5Zm27.65 12.2c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm27.55-3.6c0-.8-.19-1.3-.19-1.9V530.2c-7.96-.4-16.71 0-25.96 1.9 0 .6 0 1.1.2 1.7 0 .6.19 1.1.19 1.9 0 1 .2 1.7.2 2.7v1l25.56-1.3v-3.6Zm-44.06 8.5c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm-11.14-17.1c.4.6.6 1 1 1.5-.3-.6-.7-1-1-1.5Zm27.65 12.2c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm27.55-3.6c0-.8-.19-1.3-.19-1.9V530.2c-7.96-.4-16.71 0-25.96 1.9 0 .6 0 1.1.2 1.7 0 .6.19 1.1.19 1.9 0 1 .2 1.7.2 2.7v1l25.56-1.3v-3.6Zm-44.06 8.5c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Zm-11.14-17.1c.4.6.6 1 1 1.5-.3-.6-.7-1-1-1.5Zm27.65 12.2c0-.4 0-.8-.19-1.1v-1.2c0-.8-.2-1.7-.2-2.5v-.4c-5.87 1.3-12.14 3.4-18.4 6.1.39.6.79 1.1 1.09 1.7l17.8-1c.1-.9-.1-1.2-.1-1.6Zm-16.51 4.9c-.39-.6-.79-1.1-1.29-1.7-.2-.4-.4-.6-.6-1-.19-.2-.39-.4-.59-.8-.2-.2-.4-.4-.6-.8-1.09.6-2.29 1.1-3.38 1.7 0 0 3.58 3.8 10.24 7.4-1.29-1.3-2.58-3-3.78-4.8Z",
    fill: "#425A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.91 627.5h.4l-.4.2v-.2Z",
    fill: "url(#paint99_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.09 624.3.59 2.3-4.37 1h7.75l9.45-1.1s-.2-1-.59-2.9c0-.4-.2-.8-.2-1.3-1.1-5.7-3.39-16.6-5.47-23.8-.8-3.1-1.5-5.3-2.29-6.7l1.29 6.3 3.78 19.4-5.07-19.8-2.09-8.2c-1.29-1.3-3.08-2.5-4.57-3.6l1.29 10.3 3.18 24.4-3.78-24.6-1.69-10.9c-1.49-1.1-2.49-1.7-2.49-1.7l2.09 12 4.98 27.3.19 1.5.4 1.9-.4-1.9-.39-1.5-6.27-27.8-6.27-27.8-4.37-5.9 7.96 33 7.06 28.6.3 1.5Z",
    fill: "url(#paint100_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.24 626.6h-.2l.2.2v-.2Z",
    fill: "url(#paint101_linear_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1130.6 622.6-1.69 2.3-3.98-19.6-2.69-13.3 1.1-2.1 3.08 15.4 3.18 15.1-1.29-15.1-3.18-35.5-.2-16.6 4.17 52.2 1.5 17.2Z",
    fill: "url(#paint102_linear_1989_1050)"
  }))), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152 485V218h-93.5v-10h93.5V89h11v119h93v10h-93v267h97v10h-97v125h-11V495h-96v-10h96Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1152 218h.5v-.5h-.5v.5Zm0 267v.5h.5v-.5h-.5Zm-93.5-267h-.5v.5h.5v-.5Zm0-10v-.5h-.5v.5h.5Zm93.5 0v.5h.5v-.5h-.5Zm0-119v-.5h-.5v.5h.5Zm11 0h.5v-.5h-.5v.5Zm0 119h-.5v.5h.5v-.5Zm93 0h.5v-.5h-.5v.5Zm0 10v.5h.5v-.5h-.5Zm-93 0v-.5h-.5v.5h.5Zm0 267h-.5v.5h.5v-.5Zm97 0h.5v-.5h-.5v.5Zm0 10v.5h.5v-.5h-.5Zm-97 0v-.5h-.5v.5h.5Zm0 125v.5h.5v-.5h-.5Zm-11 0h-.5v.5h.5v-.5Zm0-125h.5v-.5h-.5v.5Zm-96 0h-.5v.5h.5v-.5Zm0-10v-.5h-.5v.5h.5Zm95.5-267v267h1V218h-1Zm-93 .5h93.5v-1h-93.5v1Zm-.5-10.5v10h1v-10h-1Zm94-.5h-93.5v1h93.5v-1Zm-.5-118.5v119h1V89h-1Zm11.5-.5h-11v1h11v-1Zm.5 119.5V89h-1v119h1Zm92.5-.5h-93v1h93v-1Zm.5 10.5v-10h-1v10h1Zm-93.5.5h93v-1h-93v1Zm.5 266.5V218h-1v267h1Zm-.5.5h97v-1h-97v1Zm96.5-.5v10h1v-10h-1Zm.5 9.5h-97v1h97v-1ZM1163.5 620V495h-1v125h1Zm-11.5.5h11v-1h-11v1Zm-.5-125.5v125h1V495h-1Zm.5-.5h-96v1h96v-1Zm-95.5.5v-10h-1v10h1Zm-.5-9.5h96v-1h-96v1Z",
    fill: "#EFEFEF"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1038 70h240v567h-240V70Zm18 549h204V88h-204v531Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1043 711h95l-70 92h-95l70-92Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M965 816h95l-160 222h-95l160-222Z",
    fill: "url(#paint103_linear_1989_1050)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1076 816h95l-160 222h-95l160-222Z",
    fill: "url(#paint104_linear_1989_1050)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1154 712h95l-70 92h-95l70-92Z",
    fill: "white"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.5,
    cy: 707,
    rx: 28.5,
    ry: 4,
    fill: "#40343F",
    fillOpacity: 0.39
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.01 705c17.126 0 31.009-13.879 31.009-31 0-17.121-13.883-31-31.009-31S264 656.879 264 674c0 17.121 13.884 31 31.01 31Z",
    fill: "url(#paint105_radial_1989_1050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59 649.835c7.226-5.803 16.927-8.257 26.432-6.037-2.552-.097-3.896.877-5.201 2.162-.292.292-.857.506-1.266.506-3.545-.078-6.603.584-10.382 2.882-.35.214-.935.273-1.324.156-2.669-.857-5.298-.916-8.259.331Zm-5.22 17.642c.136-.39.039-.974-.176-1.305-1.733-2.629-2.396-5.569-1.441-8.646a31.174 31.174 0 0 0-3.078 6.446 30.91 30.91 0 0 0 .955 22.49c-.195-2.298.818-4.829 2.415-6.737.253-.312.429-.876.37-1.285-.662-3.973-.311-7.166.955-10.963Zm45.482-13.242c.039.409.273.994.545 1.286 2.786 3.057 4.383 5.413 5.513 8.957.117.389.526.837.876 1.051 1.364.838 2.416 2.454 2.961 4.382a31.076 31.076 0 0 0-13.148-21.439c1.85 1.499 3.039 3.622 3.253 5.763Zm5.142 32.052c-.37.195-.798.623-.954 1.013-1.617 3.836-3.195 6.075-6.117 8.197-.331.234-.701.74-.857 1.13-.681 1.674-1.869 3.485-3.584 4.79 6.74-3.563 12.194-9.6 14.862-17.369.195-.565.371-1.13.526-1.694-.798 1.888-2.454 3.193-3.876 3.933Zm-28.38 16.104c-.175-.37-.623-.721-1.032-.799-3.721-.584-6.526-1.733-9.74-3.894-.331-.234-.935-.331-1.344-.253-2.551.486-5.454-.137-7.694-1.792a31.074 31.074 0 0 0 12.155 7.672A31.083 31.083 0 0 0 295.244 705c-1.169-.448-2.104-1.577-2.63-2.609Zm11.064-38.186c2.318 3.233 4.246 6.601 5.726 9.97.195.448.721.799 1.189.818l7.518.253c.468 0 1.013-.311 1.228-.72 1.499-2.765 2.376-5.316 2.629-7.789a4.127 4.127 0 0 0-.195-1.519c-1.344-3.875-3.311-7.108-5.999-9.931-.312-.312-.877-.682-1.286-.818a16.028 16.028 0 0 0-5.064-.837c-.799 0-1.636.058-2.435.195-.467.077-.915.525-.993 1.012a32.922 32.922 0 0 1-2.455 7.906c-.194.448-.136 1.09.137 1.46Zm-25.127 21.77c.311 0 .623-.077.857-.194l8.103-4.615c.409-.234.74-.779.759-1.246a111.37 111.37 0 0 1 1.033-11.859c.058-.467-.176-1.071-.526-1.363l-7.402-5.978c-.234-.195-.604-.312-.974-.312-.175 0-.331.02-.487.078-3.058 1.207-5.785 2.999-8.317 5.472a3.73 3.73 0 0 0-.799 1.304c-1.305 4.168-1.636 7.965-1.032 11.567.078.428.35 1.052.643 1.383 2.084 2.453 4.596 4.361 7.499 5.647.195.058.409.116.643.116Zm34.652 9.62c2.844-2.162 5.123-5.199 6.798-9.035.175-.39.311-1.071.292-1.5a31.984 31.984 0 0 0-1.208-8.276c-.136-.467-.623-.856-1.11-.876l-7.48-.253c-.467 0-1.013.292-1.266.682-1.948 2.979-4.324 5.919-7.246 8.996-.331.331-.506.954-.428 1.421l1.48 8.12c.078.468.506.954.954 1.091 1.578.487 3.059.72 4.539.72 1.11 0 2.201-.136 3.272-.409.448-.117 1.052-.428 1.403-.681Zm-12.252-8.685c-.078-.467-.526-.935-.974-1.051-4.052-1.013-7.558-2.376-10.694-4.148-.195-.117-.467-.175-.74-.175a1.41 1.41 0 0 0-.721.175l-8.044 4.595c-.429.234-.74.799-.721 1.266.117 2.804.701 5.667 1.753 8.49.156.429.565.954.935 1.207 2.922 1.987 6.311 3.311 10.343 4.051.175.039.39.058.623.058.332 0 .663-.039.896-.097 3.565-.896 6.389-2.512 8.435-4.79.311-.332.467-.974.389-1.441l-1.48-8.14Zm-4.831-40.093h-.565c-3.486 0-6.973.993-10.401 2.979-.39.214-.857.701-1.072 1.09a24.473 24.473 0 0 0-2.824 7.984c-.078.467.156 1.071.526 1.363l7.363 5.959c.234.175.565.292.915.292.195 0 .37-.039.526-.098 3.292-1.382 6.837-2.336 11.181-2.979.467-.078.993-.467 1.169-.876 1.188-2.687 1.986-5.277 2.434-7.867.078-.467-.077-1.11-.37-1.461-1.928-2.434-4.48-4.459-7.596-5.997-.37-.214-.935-.389-1.286-.389Z",
    fill: "url(#paint106_radial_1989_1050)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_f_1989_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m449 742 14.194-53h496.612L976 742H449Z",
    fill: "#23234B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1989_1050",
    x: 513,
    y: 180,
    width: 360,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0.878333 0 0 0 0 0.85125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_1050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_1050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1989_1050",
    x: 104,
    y: 492.5,
    width: 308,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1989_1050",
    x: 104,
    y: 583.5,
    width: 308,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1989_1050",
    x: 104,
    y: 397,
    width: 308,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1989_1050",
    x: 104,
    y: 286,
    width: 308,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1989_1050",
    x: 104,
    y: 195,
    width: 308,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1989_1050",
    x: 810,
    y: 445,
    width: 218,
    height: 44.2034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1989_1050",
    x: 771.982,
    y: 213.416,
    width: 74.8828,
    height: 69.8301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_1050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_1050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1989_1050",
    x: 802.529,
    y: 209.887,
    width: 11.1365,
    height: 11.1365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498333 0 0 0 0 0.291667 0 0 0 0 0.625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_1050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_1050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1989_1050",
    x: 260,
    y: 696,
    width: 71,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1989_1050",
    x: 441,
    y: 681,
    width: 543,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1989_1050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_1050",
    x1: 69,
    y1: 848,
    x2: 1368.5,
    y2: 848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B98B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_1050",
    x1: 719.75,
    y1: 689,
    x2: 719.75,
    y2: 1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C5A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_1050",
    x1: 368.25,
    y1: 972,
    x2: 368.25,
    y2: 1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1989_1050",
    x1: 483.25,
    y1: 808,
    x2: 483.25,
    y2: 937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1989_1050",
    x1: 669.25,
    y1: 782,
    x2: 669.25,
    y2: 911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1989_1050",
    x1: 858.25,
    y1: 808,
    x2: 858.25,
    y2: 937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1989_1050",
    x1: 971.25,
    y1: 752,
    x2: 971.25,
    y2: 881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1989_1050",
    x1: 1128.25,
    y1: 908,
    x2: 1128.25,
    y2: 1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1989_1050",
    x1: 990.25,
    y1: 872,
    x2: 990.25,
    y2: 1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1989_1050",
    x1: 431.25,
    y1: 735,
    x2: 431.25,
    y2: 864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1989_1050",
    x1: 280.25,
    y1: 889,
    x2: 280.25,
    y2: 1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1989_1050",
    x1: 106.75,
    y1: 937,
    x2: 106.75,
    y2: 1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1989_1050",
    x1: 533.25,
    y1: 989,
    x2: 533.25,
    y2: 1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C889",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1989_1050",
    x1: 347.25,
    y1: 870,
    x2: 347.25,
    y2: 999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1989_1050",
    x1: 341.75,
    y1: 706.5,
    x2: 341.75,
    y2: 835.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1989_1050",
    x1: 199.75,
    y1: 806.5,
    x2: 199.75,
    y2: 935.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1989_1050",
    x1: 408.25,
    y1: 687.25,
    x2: 406.5,
    y2: 725.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9976B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AE86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1989_1050",
    x1: 259.25,
    y1: 688.25,
    x2: 257.5,
    y2: 726.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9976B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AE86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1989_1050",
    x1: 174.25,
    y1: 688.25,
    x2: 172.5,
    y2: 726.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9976B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AE86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1989_1050",
    x1: 238.75,
    y1: 783.25,
    x2: 237,
    y2: 821.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9976B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AE86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1989_1050",
    x1: 701.5,
    y1: 180,
    x2: 701.5,
    y2: 413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71717E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1989_1050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588 255.5) rotate(54.2222) scale(194.135 285.787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1989_1050",
    x1: 259,
    y1: 494.5,
    x2: 259,
    y2: 511.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1989_1050",
    x1: 259,
    y1: 585.5,
    x2: 259,
    y2: 602.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1989_1050",
    x1: 259,
    y1: 399,
    x2: 259,
    y2: 416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1989_1050",
    x1: 259,
    y1: 288,
    x2: 259,
    y2: 305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1989_1050",
    x1: 942,
    y1: 449,
    x2: 900,
    y2: 459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84869A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70738D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1989_1050",
    x1: 222.776,
    y1: 486.954,
    x2: 216.776,
    y2: 487.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C25B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD98F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1989_1050",
    x1: 229.276,
    y1: 488.954,
    x2: 224.776,
    y2: 488.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1989_1050",
    x1: 236.777,
    y1: 489.954,
    x2: 230.777,
    y2: 489.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECED7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1989_1050",
    x1: 1341,
    y1: 824.5,
    x2: 1224,
    y2: 982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1989_1050",
    x1: 1396.25,
    y1: 136,
    x2: 1396.25,
    y2: 843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BB4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1C8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1989_1050",
    x1: 1250,
    y1: 939.5,
    x2: 1133,
    y2: 1097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1989_1050",
    x1: 152.142,
    y1: 406.6,
    x2: 152.142,
    y2: 411.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1989_1050",
    x1: 152.142,
    y1: 402.3,
    x2: 152.142,
    y2: 406.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5F5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1989_1050",
    x1: 144.992,
    y1: 369.5,
    x2: 153.992,
    y2: 405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1989_1050",
    x1: 148.992,
    y1: 371.5,
    x2: 150.992,
    y2: 383.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1989_1050",
    x1: 144.992,
    y1: 399,
    x2: 159.492,
    y2: 358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89969A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1989_1050",
    x1: 148.492,
    y1: 402,
    x2: 156.992,
    y2: 385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2AEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#B7C3C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1989_1050",
    x1: 153.992,
    y1: 402,
    x2: 160.492,
    y2: 379.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2BBBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1989_1050",
    x1: 162.992,
    y1: 366,
    x2: 151.492,
    y2: 392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D8A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1989_1050",
    x1: 158.992,
    y1: 403,
    x2: 160.937,
    y2: 398.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99A8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D969A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1989_1050",
    x1: 142.992,
    y1: 353,
    x2: 158.992,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BECBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DEE8",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1989_1050",
    x1: 158.286,
    y1: 280.065,
    x2: 159.063,
    y2: 280.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6031,
    stopColor: "#DA9A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6948"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1989_1050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1270.7 123.715) rotate(-14.9344) scale(2.17297 2.18323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    stopColor: "#FD8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    stopColor: "#F68B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    stopColor: "#EB8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DA7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    stopColor: "#C46E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#A85F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#884D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    stopColor: "#623700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    stopColor: "#371F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    stopColor: "#090500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1989_1050",
    x1: 1158.19,
    y1: 600.525,
    x2: 1147.63,
    y2: 72.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#C2D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1316,
    stopColor: "#B8D0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3107,
    stopColor: "#E6F3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#A7CBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7552,
    stopColor: "#A9CCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#98C7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1989_1050",
    x1: 1144.03,
    y1: 514.828,
    x2: 1077.62,
    y2: 119.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#AED3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1904,
    stopColor: "#A7CDA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#95BEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#76A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#5B8EA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1989_1050",
    x1: 819.97,
    y1: 531.032,
    x2: 819.317,
    y2: 386.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1989_1050",
    x1: 1046.17,
    y1: 419.671,
    x2: 1118.62,
    y2: 419.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1989_1050",
    x1: 978.087,
    y1: 660.872,
    x2: 1046.4,
    y2: 207.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77870D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1989_1050",
    x1: 838.921,
    y1: 420.047,
    x2: 861.643,
    y2: 575.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1989_1050",
    x1: 1271.26,
    y1: 203.826,
    x2: 1243.92,
    y2: 203.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#5F570A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1989_1050",
    x1: 1336.33,
    y1: 137.471,
    x2: 1259.91,
    y2: 137.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    stopColor: "#5F570A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E7703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1989_1050",
    x1: 1163.92,
    y1: 558.725,
    x2: 1154.13,
    y2: 423.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1989_1050",
    x1: 1212.47,
    y1: 555.213,
    x2: 1202.69,
    y2: 419.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1989_1050",
    x1: 1198.7,
    y1: 536.728,
    x2: 1200.66,
    y2: 121.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2715,
    stopColor: "#885F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4777,
    stopColor: "#845502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    stopColor: "#7D4504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8335,
    stopColor: "#732E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#661109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1989_1050",
    x1: 1211.04,
    y1: 532.836,
    x2: 1211.13,
    y2: 534.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF6601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2551,
    stopColor: "#AE6302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4489,
    stopColor: "#AA5907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#A4490E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    stopColor: "#9C3218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    stopColor: "#911525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C062C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1989_1050",
    x1: 926.467,
    y1: 519.499,
    x2: 919.289,
    y2: 573.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#996929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#8D3328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1989_1050",
    x1: 834.931,
    y1: 598.665,
    x2: 843.007,
    y2: 503.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1989_1050",
    x1: 990.192,
    y1: 414.952,
    x2: 1146.63,
    y2: 591.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1989_1050",
    x1: 1083.07,
    y1: 318.043,
    x2: 1245.66,
    y2: 501.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1989_1050",
    x1: 1008.09,
    y1: 383.971,
    x2: 1182.72,
    y2: 580.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1989_1050",
    x1: 1076.41,
    y1: 315.213,
    x2: 1246.84,
    y2: 507.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1989_1050",
    x1: 978.766,
    y1: 380.695,
    x2: 1149.19,
    y2: 572.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1989_1050",
    x1: 987.174,
    y1: 315.505,
    x2: 1161.8,
    y2: 512.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1989_1050",
    x1: 934.211,
    y1: 391.242,
    x2: 1083.76,
    y2: 581.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1989_1050",
    x1: 1068.09,
    y1: 330.948,
    x2: 1232.71,
    y2: 516.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1989_1050",
    x1: 1045.13,
    y1: 329.861,
    x2: 1217.24,
    y2: 524.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1989_1050",
    x1: 1009.65,
    y1: 456.101,
    x2: 1083.63,
    y2: 539.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1989_1050",
    x1: 1004.17,
    y1: 454.472,
    x2: 1081.72,
    y2: 541.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1989_1050",
    x1: 1019.74,
    y1: 432.396,
    x2: 1099.2,
    y2: 522.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1989_1050",
    x1: 969.556,
    y1: 479.957,
    x2: 1047.1,
    y2: 567.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1989_1050",
    x1: 985.446,
    y1: 458.246,
    x2: 1064.9,
    y2: 547.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1989_1050",
    x1: 1000.3,
    y1: 461.713,
    x2: 1075.2,
    y2: 546.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1989_1050",
    x1: 982.593,
    y1: 460.62,
    x2: 1060.9,
    y2: 548.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2132B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFB22A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1989_1050",
    x1: 1067.87,
    y1: 260.262,
    x2: 1038.14,
    y2: 113.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1989_1050",
    x1: 1072.3,
    y1: 1.39054,
    x2: 1129.79,
    y2: 212.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1989_1050",
    x1: 1066.3,
    y1: 1.93819,
    x2: 1124.11,
    y2: 214.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1989_1050",
    x1: 1099.24,
    y1: 203.401,
    x2: 1083.25,
    y2: 124.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1989_1050",
    x1: 1015.07,
    y1: 119.788,
    x2: 1045.97,
    y2: 233.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1989_1050",
    x1: 1131.19,
    y1: 24.4237,
    x2: 1190.93,
    y2: 243.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1989_1050",
    x1: 1112.64,
    y1: -6.31497,
    x2: 1170.08,
    y2: 204.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1989_1050",
    x1: 1165.11,
    y1: -23.8547,
    x2: 1224.77,
    y2: 195.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1989_1050",
    x1: 1037.21,
    y1: 206.54,
    x2: 1037.23,
    y2: 203.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4FDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1989_1050",
    x1: 1158.9,
    y1: 169.598,
    x2: 1158.92,
    y2: 166.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4FDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1989_1050",
    x1: 1036.07,
    y1: 552.844,
    x2: 1029.22,
    y2: 638.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#B07F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#A4493C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1989_1050",
    x1: 1172.97,
    y1: 564.622,
    x2: 1166.12,
    y2: 649.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#B07F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#A4493C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1989_1050",
    x1: 1130.32,
    y1: 553.516,
    x2: 1121.76,
    y2: 659.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#B07F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#A4493C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1989_1050",
    x1: 1067.27,
    y1: 552.764,
    x2: 1060.42,
    y2: 637.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#B07F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#A4493C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1989_1050",
    x1: 1056.83,
    y1: 499.453,
    x2: 1042.54,
    y2: 677.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0111732,
    stopColor: "#B07F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#A4493C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1989_1050",
    x1: 1234.72,
    y1: 679.408,
    x2: 1226.4,
    y2: 551.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2715,
    stopColor: "#885F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4777,
    stopColor: "#845502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    stopColor: "#7D4504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8335,
    stopColor: "#732E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#661109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#661009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1989_1050",
    x1: 1216.31,
    y1: 551.998,
    x2: 1299.99,
    y2: 386.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1989_1050",
    x1: 1217.04,
    y1: 541.722,
    x2: 1237.79,
    y2: 444.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1989_1050",
    x1: 1292.37,
    y1: 558.407,
    x2: 1313.24,
    y2: 460.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1989_1050",
    x1: 1274.36,
    y1: 554.582,
    x2: 1295.24,
    y2: 456.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1989_1050",
    x1: 1142.48,
    y1: 526.425,
    x2: 1163.34,
    y2: 428.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1989_1050",
    x1: 1172.57,
    y1: 536.865,
    x2: 1262.15,
    y2: 360.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1989_1050",
    x1: 1164.62,
    y1: 419.12,
    x2: 1120.87,
    y2: 675.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1989_1050",
    x1: 1119.25,
    y1: 520.49,
    x2: 1098.6,
    y2: 481.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706D01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1989_1050",
    x1: 1051.46,
    y1: 595.241,
    x2: 1035.77,
    y2: 456.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1989_1050",
    x1: 1058.32,
    y1: 594.529,
    x2: 1042.66,
    y2: 456.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1989_1050",
    x1: 1099.99,
    y1: 589.761,
    x2: 1084.3,
    y2: 451.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1989_1050",
    x1: 1125.17,
    y1: 586.954,
    x2: 1109.51,
    y2: 448.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#022A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1989_1050",
    x1: 985,
    y1: 897.5,
    x2: 875,
    y2: 951.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1989_1050",
    x1: 1043.5,
    y1: 816,
    x2: 1043.5,
    y2: 1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_1989_1050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.554 661.366) scale(43.3163 43.3027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2242,
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_1989_1050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.406 664.674) scale(38.7772 38.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    stopColor: "#D9D9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5945,
    stopColor: "#DFDFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7184,
    stopColor: "#DBDBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#B5B3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9484,
    stopColor: "#8F8D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#968F9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1048,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1989_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3,
    height: 59.6,
    fill: "white",
    transform: "translate(138.992 352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1989_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(264 643)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene);
export default __webpack_public_path__ + "static/media/Scene.529969c23dacac8238d43f93f16eb963.svg";
export { ForwardRef as ReactComponent };